import { useQuery, UseQueryOptions, useMutation, UseMutationOptions } from 'react-query';
import { graphQlFetcher } from '../services/fetchers';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  DateTime: any;
  Decimal: any;
};

export type ActiveCart = {
  __typename?: 'ActiveCart';
  BinderCustomer?: Maybe<BinderCustomer>;
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: Maybe<BinderCustomerUser>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: Maybe<BinderCustomerUser>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: Maybe<BinderCustomerUser>;
  Cart?: Maybe<Cart>;
  CartIntegratedPayment: Array<CartIntegratedPayment>;
  CartItem: Array<CartItem>;
  CartItemInventoryAdjustment: Array<CartItemInventoryAdjustment>;
  CartTax: Array<CartTax>;
  CartTender: Array<CartTender>;
  ProductsToProcess: Array<ProductsToProcess>;
  ShopifyCustomer?: Maybe<ShopifyCustomer>;
  StoreCreditHistory: Array<StoreCreditHistory>;
  _count?: Maybe<CartCount>;
  abandoned: Scalars['Boolean'];
  binderCustomerId?: Maybe<Scalars['String']>;
  binderCustomerTillId?: Maybe<Scalars['BigInt']>;
  cartName?: Maybe<Scalars['String']>;
  cartNotes?: Maybe<Scalars['String']>;
  cartType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['BigInt']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateSubmitted?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Decimal']>;
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  itemCount: Scalars['Decimal'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  orderNumber?: Maybe<Scalars['String']>;
  other_Cart: Array<Cart>;
  parentCartId?: Maybe<Scalars['BigInt']>;
  removedBy?: Maybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: Maybe<Scalars['String']>;
  shopifyCustomerId?: Maybe<Scalars['BigInt']>;
  shopifyOrderId?: Maybe<Scalars['BigInt']>;
  subTotal?: Maybe<Scalars['Decimal']>;
  submittedBy?: Maybe<Scalars['BigInt']>;
  taxIncluded?: Maybe<Scalars['Boolean']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Decimal']>;
  totalTax?: Maybe<Scalars['Decimal']>;
};


export type ActiveCartCartIntegratedPaymentArgs = {
  cursor?: InputMaybe<CartIntegratedPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartIntegratedPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartIntegratedPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartIntegratedPaymentWhereInput>;
};


export type ActiveCartCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type ActiveCartCartItemInventoryAdjustmentArgs = {
  cursor?: InputMaybe<CartItemInventoryAdjustmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemInventoryAdjustmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemInventoryAdjustmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};


export type ActiveCartCartTaxArgs = {
  cursor?: InputMaybe<CartTaxWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTaxScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTaxOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTaxWhereInput>;
};


export type ActiveCartCartTenderArgs = {
  cursor?: InputMaybe<CartTenderWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTenderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTenderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTenderWhereInput>;
};


export type ActiveCartProductsToProcessArgs = {
  cursor?: InputMaybe<ProductsToProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductsToProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductsToProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsToProcessWhereInput>;
};


export type ActiveCartStoreCreditHistoryArgs = {
  cursor?: InputMaybe<StoreCreditHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StoreCreditHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StoreCreditHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoreCreditHistoryWhereInput>;
};


export type ActiveCartOther_CartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};

export type ActiveCarts = {
  __typename?: 'ActiveCarts';
  carts: Array<ActiveCart>;
  totalRows: Scalars['Decimal'];
};

export type AllCartsWhereInput = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  containsNote?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  oldestFirst?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  priceMax?: InputMaybe<Scalars['Decimal']>;
  priceMin?: InputMaybe<Scalars['Decimal']>;
  savedOnly?: InputMaybe<Scalars['Boolean']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  submitted?: InputMaybe<Scalars['Boolean']>;
  tillId?: InputMaybe<Scalars['BigInt']>;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']>;
  divide?: InputMaybe<Scalars['BigInt']>;
  increment?: InputMaybe<Scalars['BigInt']>;
  multiply?: InputMaybe<Scalars['BigInt']>;
  set?: InputMaybe<Scalars['BigInt']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type BinderCustomer = {
  __typename?: 'BinderCustomer';
  BinderCustomerLocation: Array<BinderCustomerLocation>;
  BinderCustomerSettings: Array<BinderCustomerSettings>;
  BinderCustomerShopifyTheme: Array<BinderCustomerShopifyTheme>;
  BinderCustomerUser: Array<BinderCustomerUser>;
  Cart: Array<Cart>;
  ShopifyCustomerBuylist: Array<ShopifyCustomerBuylist>;
  _count?: Maybe<BinderCustomerCount>;
  allowNonEnglish: Scalars['Boolean'];
  apiKey: Scalars['String'];
  apiKeyPassword: Scalars['String'];
  betaTester?: Maybe<Scalars['Boolean']>;
  binderKey?: Maybe<Scalars['String']>;
  buylistRoundToNearest?: Maybe<Scalars['Float']>;
  commonLowPrice?: Maybe<Scalars['Decimal']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  differentHandle: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  mythicLowPrice?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
  noRounding: Scalars['Boolean'];
  nonEnglishWording?: Maybe<Scalars['String']>;
  posPriceMarkup?: Maybe<Scalars['Float']>;
  priceMarkup?: Maybe<Scalars['Float']>;
  priceMultiplier?: Maybe<Scalars['Float']>;
  primaryLogin: Scalars['String'];
  rareLowPrice?: Maybe<Scalars['Decimal']>;
  roundToNearest?: Maybe<Scalars['Float']>;
  setup?: Maybe<Scalars['Boolean']>;
  sharedSecret: Scalars['String'];
  siteUrl: Scalars['String'];
  standaloneEnabled?: Maybe<Scalars['Boolean']>;
  tcgPlayerPriceType?: Maybe<Scalars['String']>;
  test?: Maybe<Scalars['Boolean']>;
  timezone?: Maybe<Scalars['String']>;
  uncommonLowPrice?: Maybe<Scalars['Decimal']>;
  updatePricing?: Maybe<Scalars['Boolean']>;
  useOriginalPricing?: Maybe<Scalars['Boolean']>;
  useTCGPlayerPricing?: Maybe<Scalars['Boolean']>;
};


export type BinderCustomerBinderCustomerLocationArgs = {
  cursor?: InputMaybe<BinderCustomerLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerLocationWhereInput>;
};


export type BinderCustomerBinderCustomerSettingsArgs = {
  cursor?: InputMaybe<BinderCustomerSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerSettingsWhereInput>;
};


export type BinderCustomerBinderCustomerShopifyThemeArgs = {
  cursor?: InputMaybe<BinderCustomerShopifyThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerShopifyThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerShopifyThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
};


export type BinderCustomerBinderCustomerUserArgs = {
  cursor?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerUserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerUserWhereInput>;
};


export type BinderCustomerCartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type BinderCustomerShopifyCustomerBuylistArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};

export type BinderCustomerCount = {
  __typename?: 'BinderCustomerCount';
  BinderCustomerLocation: Scalars['Int'];
  BinderCustomerSettings: Scalars['Int'];
  BinderCustomerShopifyTheme: Scalars['Int'];
  BinderCustomerUser: Scalars['Int'];
  Cart: Scalars['Int'];
  ShopifyCustomerBuylist: Scalars['Int'];
};

export type BinderCustomerCreateNestedOneWithoutBinderCustomerShopifyThemeInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutBinderCustomerShopifyThemeInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutBinderCustomerShopifyThemeInput>;
};

export type BinderCustomerCreateNestedOneWithoutBinderCustomerUserInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutBinderCustomerUserInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutBinderCustomerUserInput>;
};

export type BinderCustomerCreateNestedOneWithoutCartInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutCartInput>;
};

export type BinderCustomerCreateNestedOneWithoutShopifyCustomerBuylistInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutShopifyCustomerBuylistInput>;
};

export type BinderCustomerCreateOrConnectWithoutBinderCustomerShopifyThemeInput = {
  create: BinderCustomerCreateWithoutBinderCustomerShopifyThemeInput;
  where: BinderCustomerWhereUniqueInput;
};

export type BinderCustomerCreateOrConnectWithoutBinderCustomerUserInput = {
  create: BinderCustomerCreateWithoutBinderCustomerUserInput;
  where: BinderCustomerWhereUniqueInput;
};

export type BinderCustomerCreateOrConnectWithoutCartInput = {
  create: BinderCustomerCreateWithoutCartInput;
  where: BinderCustomerWhereUniqueInput;
};

export type BinderCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput = {
  create: BinderCustomerCreateWithoutShopifyCustomerBuylistInput;
  where: BinderCustomerWhereUniqueInput;
};

export type BinderCustomerCreateWithoutBinderCustomerShopifyThemeInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserCreateNestedManyWithoutBinderCustomerInput>;
  Cart?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistCreateNestedManyWithoutBinderCustomerInput>;
  allowNonEnglish: Scalars['Boolean'];
  apiKey: Scalars['String'];
  apiKeyPassword: Scalars['String'];
  betaTester?: InputMaybe<Scalars['Boolean']>;
  binderKey?: InputMaybe<Scalars['String']>;
  buylistRoundToNearest?: InputMaybe<Scalars['Float']>;
  commonLowPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  differentHandle: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  mythicLowPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  noRounding: Scalars['Boolean'];
  nonEnglishWording?: InputMaybe<Scalars['String']>;
  posPriceMarkup?: InputMaybe<Scalars['Float']>;
  priceMarkup?: InputMaybe<Scalars['Float']>;
  priceMultiplier?: InputMaybe<Scalars['Float']>;
  primaryLogin: Scalars['String'];
  rareLowPrice?: InputMaybe<Scalars['Decimal']>;
  roundToNearest?: InputMaybe<Scalars['Float']>;
  setup?: InputMaybe<Scalars['Boolean']>;
  sharedSecret: Scalars['String'];
  siteUrl: Scalars['String'];
  standaloneEnabled?: InputMaybe<Scalars['Boolean']>;
  tcgPlayerPriceType?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  uncommonLowPrice?: InputMaybe<Scalars['Decimal']>;
  updatePricing?: InputMaybe<Scalars['Boolean']>;
  useOriginalPricing?: InputMaybe<Scalars['Boolean']>;
  useTCGPlayerPricing?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerCreateWithoutBinderCustomerUserInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeCreateNestedManyWithoutBinderCustomerInput>;
  Cart?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistCreateNestedManyWithoutBinderCustomerInput>;
  allowNonEnglish: Scalars['Boolean'];
  apiKey: Scalars['String'];
  apiKeyPassword: Scalars['String'];
  betaTester?: InputMaybe<Scalars['Boolean']>;
  binderKey?: InputMaybe<Scalars['String']>;
  buylistRoundToNearest?: InputMaybe<Scalars['Float']>;
  commonLowPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  differentHandle: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  mythicLowPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  noRounding: Scalars['Boolean'];
  nonEnglishWording?: InputMaybe<Scalars['String']>;
  posPriceMarkup?: InputMaybe<Scalars['Float']>;
  priceMarkup?: InputMaybe<Scalars['Float']>;
  priceMultiplier?: InputMaybe<Scalars['Float']>;
  primaryLogin: Scalars['String'];
  rareLowPrice?: InputMaybe<Scalars['Decimal']>;
  roundToNearest?: InputMaybe<Scalars['Float']>;
  setup?: InputMaybe<Scalars['Boolean']>;
  sharedSecret: Scalars['String'];
  siteUrl: Scalars['String'];
  standaloneEnabled?: InputMaybe<Scalars['Boolean']>;
  tcgPlayerPriceType?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  uncommonLowPrice?: InputMaybe<Scalars['Decimal']>;
  updatePricing?: InputMaybe<Scalars['Boolean']>;
  useOriginalPricing?: InputMaybe<Scalars['Boolean']>;
  useTCGPlayerPricing?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerCreateWithoutCartInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserCreateNestedManyWithoutBinderCustomerInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistCreateNestedManyWithoutBinderCustomerInput>;
  allowNonEnglish: Scalars['Boolean'];
  apiKey: Scalars['String'];
  apiKeyPassword: Scalars['String'];
  betaTester?: InputMaybe<Scalars['Boolean']>;
  binderKey?: InputMaybe<Scalars['String']>;
  buylistRoundToNearest?: InputMaybe<Scalars['Float']>;
  commonLowPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  differentHandle: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  mythicLowPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  noRounding: Scalars['Boolean'];
  nonEnglishWording?: InputMaybe<Scalars['String']>;
  posPriceMarkup?: InputMaybe<Scalars['Float']>;
  priceMarkup?: InputMaybe<Scalars['Float']>;
  priceMultiplier?: InputMaybe<Scalars['Float']>;
  primaryLogin: Scalars['String'];
  rareLowPrice?: InputMaybe<Scalars['Decimal']>;
  roundToNearest?: InputMaybe<Scalars['Float']>;
  setup?: InputMaybe<Scalars['Boolean']>;
  sharedSecret: Scalars['String'];
  siteUrl: Scalars['String'];
  standaloneEnabled?: InputMaybe<Scalars['Boolean']>;
  tcgPlayerPriceType?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  uncommonLowPrice?: InputMaybe<Scalars['Decimal']>;
  updatePricing?: InputMaybe<Scalars['Boolean']>;
  useOriginalPricing?: InputMaybe<Scalars['Boolean']>;
  useTCGPlayerPricing?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerCreateWithoutShopifyCustomerBuylistInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeCreateNestedManyWithoutBinderCustomerInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserCreateNestedManyWithoutBinderCustomerInput>;
  Cart?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerInput>;
  allowNonEnglish: Scalars['Boolean'];
  apiKey: Scalars['String'];
  apiKeyPassword: Scalars['String'];
  betaTester?: InputMaybe<Scalars['Boolean']>;
  binderKey?: InputMaybe<Scalars['String']>;
  buylistRoundToNearest?: InputMaybe<Scalars['Float']>;
  commonLowPrice?: InputMaybe<Scalars['Decimal']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: Scalars['String'];
  differentHandle: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  mythicLowPrice?: InputMaybe<Scalars['Decimal']>;
  name: Scalars['String'];
  noRounding: Scalars['Boolean'];
  nonEnglishWording?: InputMaybe<Scalars['String']>;
  posPriceMarkup?: InputMaybe<Scalars['Float']>;
  priceMarkup?: InputMaybe<Scalars['Float']>;
  priceMultiplier?: InputMaybe<Scalars['Float']>;
  primaryLogin: Scalars['String'];
  rareLowPrice?: InputMaybe<Scalars['Decimal']>;
  roundToNearest?: InputMaybe<Scalars['Float']>;
  setup?: InputMaybe<Scalars['Boolean']>;
  sharedSecret: Scalars['String'];
  siteUrl: Scalars['String'];
  standaloneEnabled?: InputMaybe<Scalars['Boolean']>;
  tcgPlayerPriceType?: InputMaybe<Scalars['String']>;
  test?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
  uncommonLowPrice?: InputMaybe<Scalars['Decimal']>;
  updatePricing?: InputMaybe<Scalars['Boolean']>;
  useOriginalPricing?: InputMaybe<Scalars['Boolean']>;
  useTCGPlayerPricing?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerEventListRelationFilter = {
  every?: InputMaybe<BinderCustomerEventWhereInput>;
  none?: InputMaybe<BinderCustomerEventWhereInput>;
  some?: InputMaybe<BinderCustomerEventWhereInput>;
};

export type BinderCustomerEventParticipantsListRelationFilter = {
  every?: InputMaybe<BinderCustomerEventParticipantsWhereInput>;
  none?: InputMaybe<BinderCustomerEventParticipantsWhereInput>;
  some?: InputMaybe<BinderCustomerEventParticipantsWhereInput>;
};

export type BinderCustomerEventParticipantsRelationFilter = {
  is?: InputMaybe<BinderCustomerEventParticipantsWhereInput>;
  isNot?: InputMaybe<BinderCustomerEventParticipantsWhereInput>;
};

export type BinderCustomerEventParticipantsWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerEventParticipantsWhereInput>>;
  BinderCustomerEvent?: InputMaybe<BinderCustomerEventRelationFilter>;
  EventParticipantAdditionalInfo?: InputMaybe<EventParticipantAdditionalInfoListRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerEventParticipantsWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerEventParticipantsWhereInput>>;
  binderCustomerEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  participantEmail?: InputMaybe<StringNullableFilter>;
  participantName?: InputMaybe<StringFilter>;
};

export type BinderCustomerEventRelationFilter = {
  is?: InputMaybe<BinderCustomerEventWhereInput>;
  isNot?: InputMaybe<BinderCustomerEventWhereInput>;
};

export type BinderCustomerEventWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerEventWhereInput>>;
  BinderCustomerEvent?: InputMaybe<BinderCustomerEventRelationFilter>;
  BinderCustomerEventParticipants?: InputMaybe<BinderCustomerEventParticipantsListRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerEventWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerEventWhereInput>>;
  additionalInfoRequired?: InputMaybe<BoolNullableFilter>;
  archived?: InputMaybe<BoolFilter>;
  banner?: InputMaybe<StringNullableFilter>;
  buildingName?: InputMaybe<StringNullableFilter>;
  calendarIcon?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  created?: InputMaybe<BoolFilter>;
  createdBy?: InputMaybe<BigIntFilter>;
  customerId?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  dateFormat?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  featureImage?: InputMaybe<StringNullableFilter>;
  fullAddress?: InputMaybe<StringNullableFilter>;
  game?: InputMaybe<StringFilter>;
  id?: InputMaybe<BigIntFilter>;
  includeDateInEventTitle?: InputMaybe<BoolNullableFilter>;
  isDeleting?: InputMaybe<BoolNullableFilter>;
  isDisabled?: InputMaybe<BoolFilter>;
  isTicketed?: InputMaybe<BoolFilter>;
  maxParticipants?: InputMaybe<IntNullableFilter>;
  monthlyRecurringDay?: InputMaybe<StringNullableFilter>;
  monthlyRecurringDayNumber?: InputMaybe<IntNullableFilter>;
  monthlyRecurringType?: InputMaybe<StringNullableFilter>;
  other_BinderCustomerEvent?: InputMaybe<BinderCustomerEventListRelationFilter>;
  parentEventId?: InputMaybe<BigIntNullableFilter>;
  prizePool?: InputMaybe<StringNullableFilter>;
  prizeStructure?: InputMaybe<StringNullableFilter>;
  recurring?: InputMaybe<BoolFilter>;
  recurringDays?: InputMaybe<StringNullableFilter>;
  recurringEndDate?: InputMaybe<DateTimeNullableFilter>;
  recurringFrequency?: InputMaybe<IntNullableFilter>;
  recurringType?: InputMaybe<StringNullableFilter>;
  results?: InputMaybe<StringNullableFilter>;
  shopifyCustomerProductId?: InputMaybe<BigIntNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  streetAddress?: InputMaybe<StringNullableFilter>;
  taxable?: InputMaybe<BoolNullableFilter>;
  ticketImage?: InputMaybe<StringNullableFilter>;
  ticketPrice?: InputMaybe<FloatNullableFilter>;
  time?: InputMaybe<DateTimeFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  zipCode?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerLocation = {
  __typename?: 'BinderCustomerLocation';
  BinderCustomer?: Maybe<BinderCustomer>;
  active: Scalars['Boolean'];
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  adminGraphqlApiId?: Maybe<Scalars['String']>;
  binderCustomerId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  legacy: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  updateAt?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type BinderCustomerLocationCreateManyBinderCustomerInput = {
  active: Scalars['Boolean'];
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  adminGraphqlApiId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  legacy: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  provinceCode?: InputMaybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  updateAt?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerLocationCreateManyBinderCustomerInputEnvelope = {
  data: Array<BinderCustomerLocationCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerLocationCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<BinderCustomerLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerLocationCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerLocationCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerLocationCreateManyBinderCustomerInputEnvelope>;
};

export type BinderCustomerLocationCreateOrConnectWithoutBinderCustomerInput = {
  create: BinderCustomerLocationCreateWithoutBinderCustomerInput;
  where: BinderCustomerLocationWhereUniqueInput;
};

export type BinderCustomerLocationCreateWithoutBinderCustomerInput = {
  active: Scalars['Boolean'];
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  adminGraphqlApiId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  legacy: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  provinceCode?: InputMaybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  updateAt?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerLocationListRelationFilter = {
  every?: InputMaybe<BinderCustomerLocationWhereInput>;
  none?: InputMaybe<BinderCustomerLocationWhereInput>;
  some?: InputMaybe<BinderCustomerLocationWhereInput>;
};

export type BinderCustomerLocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerLocationOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  active?: InputMaybe<SortOrder>;
  address1?: InputMaybe<SortOrder>;
  address2?: InputMaybe<SortOrder>;
  adminGraphqlApiId?: InputMaybe<SortOrder>;
  binderCustomerId?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  countryName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  legacy?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  province?: InputMaybe<SortOrder>;
  provinceCode?: InputMaybe<SortOrder>;
  shopifyId?: InputMaybe<SortOrder>;
  updateAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrder>;
};

export enum BinderCustomerLocationScalarFieldEnum {
  Active = 'active',
  Address1 = 'address1',
  Address2 = 'address2',
  AdminGraphqlApiId = 'adminGraphqlApiId',
  BinderCustomerId = 'binderCustomerId',
  City = 'city',
  Country = 'country',
  CountryCode = 'countryCode',
  CountryName = 'countryName',
  CreatedAt = 'createdAt',
  Id = 'id',
  Legacy = 'legacy',
  Name = 'name',
  Phone = 'phone',
  Province = 'province',
  ProvinceCode = 'provinceCode',
  ShopifyId = 'shopifyId',
  UpdateAt = 'updateAt',
  Zip = 'zip'
}

export type BinderCustomerLocationScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerLocationScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerLocationScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerLocationScalarWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  address1?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  adminGraphqlApiId?: InputMaybe<StringNullableFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  countryName?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  legacy?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  province?: InputMaybe<StringNullableFilter>;
  provinceCode?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  updateAt?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerLocationUpdateManyMutationInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  adminGraphqlApiId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  legacy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provinceCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  updateAt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerLocationUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: BinderCustomerLocationUpdateManyMutationInput;
  where: BinderCustomerLocationScalarWhereInput;
};

export type BinderCustomerLocationUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerLocationCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerLocationCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerLocationCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerLocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerLocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerLocationWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerLocationWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerLocationUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerLocationUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<BinderCustomerLocationUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type BinderCustomerLocationUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: BinderCustomerLocationUpdateWithoutBinderCustomerInput;
  where: BinderCustomerLocationWhereUniqueInput;
};

export type BinderCustomerLocationUpdateWithoutBinderCustomerInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  address1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  address2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  adminGraphqlApiId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  countryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  legacy?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  provinceCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  updateAt?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerLocationUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: BinderCustomerLocationCreateWithoutBinderCustomerInput;
  update: BinderCustomerLocationUpdateWithoutBinderCustomerInput;
  where: BinderCustomerLocationWhereUniqueInput;
};

export type BinderCustomerLocationWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerLocationWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerLocationWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerLocationWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  address1?: InputMaybe<StringNullableFilter>;
  address2?: InputMaybe<StringNullableFilter>;
  adminGraphqlApiId?: InputMaybe<StringNullableFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringNullableFilter>;
  country?: InputMaybe<StringNullableFilter>;
  countryCode?: InputMaybe<StringNullableFilter>;
  countryName?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  legacy?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  province?: InputMaybe<StringNullableFilter>;
  provinceCode?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  updateAt?: InputMaybe<StringNullableFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerLocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type BinderCustomerOrderByWithRelationInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationOrderByRelationAggregateInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsOrderByRelationAggregateInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeOrderByRelationAggregateInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserOrderByRelationAggregateInput>;
  Cart?: InputMaybe<CartOrderByRelationAggregateInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistOrderByRelationAggregateInput>;
  allowNonEnglish?: InputMaybe<SortOrder>;
  apiKey?: InputMaybe<SortOrder>;
  apiKeyPassword?: InputMaybe<SortOrder>;
  betaTester?: InputMaybe<SortOrder>;
  binderKey?: InputMaybe<SortOrder>;
  buylistRoundToNearest?: InputMaybe<SortOrder>;
  commonLowPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<SortOrder>;
  differentHandle?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mythicLowPrice?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  noRounding?: InputMaybe<SortOrder>;
  nonEnglishWording?: InputMaybe<SortOrder>;
  posPriceMarkup?: InputMaybe<SortOrder>;
  priceMarkup?: InputMaybe<SortOrder>;
  priceMultiplier?: InputMaybe<SortOrder>;
  primaryLogin?: InputMaybe<SortOrder>;
  rareLowPrice?: InputMaybe<SortOrder>;
  roundToNearest?: InputMaybe<SortOrder>;
  setup?: InputMaybe<SortOrder>;
  sharedSecret?: InputMaybe<SortOrder>;
  siteUrl?: InputMaybe<SortOrder>;
  standaloneEnabled?: InputMaybe<SortOrder>;
  tcgPlayerPriceType?: InputMaybe<SortOrder>;
  test?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  uncommonLowPrice?: InputMaybe<SortOrder>;
  updatePricing?: InputMaybe<SortOrder>;
  useOriginalPricing?: InputMaybe<SortOrder>;
  useTCGPlayerPricing?: InputMaybe<SortOrder>;
};

export type BinderCustomerRelationFilter = {
  is?: InputMaybe<BinderCustomerWhereInput>;
  isNot?: InputMaybe<BinderCustomerWhereInput>;
};

export type BinderCustomerSettings = {
  __typename?: 'BinderCustomerSettings';
  BinderCustomer?: Maybe<BinderCustomer>;
  binderCustomerId?: Maybe<Scalars['String']>;
  editable: Scalars['Boolean'];
  id: Scalars['BigInt'];
  settingName?: Maybe<Scalars['String']>;
  settingValue?: Maybe<Scalars['String']>;
};

export type BinderCustomerSettingsCreateManyBinderCustomerInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerSettingsCreateManyBinderCustomerInputEnvelope = {
  data: Array<BinderCustomerSettingsCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerSettingsCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<BinderCustomerSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerSettingsCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerSettingsCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerSettingsCreateManyBinderCustomerInputEnvelope>;
};

export type BinderCustomerSettingsCreateOrConnectWithoutBinderCustomerInput = {
  create: BinderCustomerSettingsCreateWithoutBinderCustomerInput;
  where: BinderCustomerSettingsWhereUniqueInput;
};

export type BinderCustomerSettingsCreateWithoutBinderCustomerInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerSettingsListRelationFilter = {
  every?: InputMaybe<BinderCustomerSettingsWhereInput>;
  none?: InputMaybe<BinderCustomerSettingsWhereInput>;
  some?: InputMaybe<BinderCustomerSettingsWhereInput>;
};

export type BinderCustomerSettingsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerSettingsOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  editable?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  settingName?: InputMaybe<SortOrder>;
  settingValue?: InputMaybe<SortOrder>;
};

export enum BinderCustomerSettingsScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  Editable = 'editable',
  Id = 'id',
  SettingName = 'settingName',
  SettingValue = 'settingValue'
}

export type BinderCustomerSettingsScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerSettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerSettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerSettingsScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerSettingsUk981pwuvvyn3kdqbf3yo5ew98pCompoundUniqueInput = {
  binderCustomerId: Scalars['String'];
  settingName: Scalars['String'];
};

export type BinderCustomerSettingsUpdateManyMutationInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerSettingsUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: BinderCustomerSettingsUpdateManyMutationInput;
  where: BinderCustomerSettingsScalarWhereInput;
};

export type BinderCustomerSettingsUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerSettingsCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerSettingsCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerSettingsCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerSettingsUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerSettingsUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<BinderCustomerSettingsUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type BinderCustomerSettingsUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: BinderCustomerSettingsUpdateWithoutBinderCustomerInput;
  where: BinderCustomerSettingsWhereUniqueInput;
};

export type BinderCustomerSettingsUpdateWithoutBinderCustomerInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerSettingsUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: BinderCustomerSettingsCreateWithoutBinderCustomerInput;
  update: BinderCustomerSettingsUpdateWithoutBinderCustomerInput;
  where: BinderCustomerSettingsWhereUniqueInput;
};

export type BinderCustomerSettingsWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerSettingsWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerSettingsWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerSettingsWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerSettingsWhereUniqueInput = {
  UK981pwuvvyn3kdqbf3yo5ew98p?: InputMaybe<BinderCustomerSettingsUk981pwuvvyn3kdqbf3yo5ew98pCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type BinderCustomerShopifyTheme = {
  __typename?: 'BinderCustomerShopifyTheme';
  BinderCustomer: BinderCustomer;
  ShopifyThemeRelease: ShopifyThemeRelease;
  currentVersion: Scalars['String'];
  customerId: Scalars['String'];
  lastUpdate?: Maybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
  theme: Scalars['String'];
};

export type BinderCustomerShopifyThemeCreateInput = {
  BinderCustomer: BinderCustomerCreateNestedOneWithoutBinderCustomerShopifyThemeInput;
  ShopifyThemeRelease: ShopifyThemeReleaseCreateNestedOneWithoutBinderCustomerShopifyThemeInput;
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
};

export type BinderCustomerShopifyThemeCreateManyBinderCustomerInput = {
  currentVersion: Scalars['String'];
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
  theme: Scalars['String'];
};

export type BinderCustomerShopifyThemeCreateManyBinderCustomerInputEnvelope = {
  data: Array<BinderCustomerShopifyThemeCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerShopifyThemeCreateManyShopifyThemeReleaseInput = {
  customerId: Scalars['String'];
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
};

export type BinderCustomerShopifyThemeCreateManyShopifyThemeReleaseInputEnvelope = {
  data: Array<BinderCustomerShopifyThemeCreateManyShopifyThemeReleaseInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerShopifyThemeCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerShopifyThemeCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerShopifyThemeCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerShopifyThemeCreateManyBinderCustomerInputEnvelope>;
};

export type BinderCustomerShopifyThemeCreateNestedManyWithoutShopifyThemeReleaseInput = {
  connect?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerShopifyThemeCreateOrConnectWithoutShopifyThemeReleaseInput>>;
  create?: InputMaybe<Array<BinderCustomerShopifyThemeCreateWithoutShopifyThemeReleaseInput>>;
  createMany?: InputMaybe<BinderCustomerShopifyThemeCreateManyShopifyThemeReleaseInputEnvelope>;
};

export type BinderCustomerShopifyThemeCreateOrConnectWithoutBinderCustomerInput = {
  create: BinderCustomerShopifyThemeCreateWithoutBinderCustomerInput;
  where: BinderCustomerShopifyThemeWhereUniqueInput;
};

export type BinderCustomerShopifyThemeCreateOrConnectWithoutShopifyThemeReleaseInput = {
  create: BinderCustomerShopifyThemeCreateWithoutShopifyThemeReleaseInput;
  where: BinderCustomerShopifyThemeWhereUniqueInput;
};

export type BinderCustomerShopifyThemeCreateWithoutBinderCustomerInput = {
  ShopifyThemeRelease: ShopifyThemeReleaseCreateNestedOneWithoutBinderCustomerShopifyThemeInput;
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
};

export type BinderCustomerShopifyThemeCreateWithoutShopifyThemeReleaseInput = {
  BinderCustomer: BinderCustomerCreateNestedOneWithoutBinderCustomerShopifyThemeInput;
  lastUpdate?: InputMaybe<Scalars['DateTime']>;
  releaseTrain: ReleaseTrain;
};

export type BinderCustomerShopifyThemeCustomerIdThemeCompoundUniqueInput = {
  customerId: Scalars['String'];
  theme: Scalars['String'];
};

export type BinderCustomerShopifyThemeDeploymentAuditLog = {
  __typename?: 'BinderCustomerShopifyThemeDeploymentAuditLog';
  customerId: Scalars['String'];
  deployedAt?: Maybe<Scalars['DateTime']>;
  deployedBy?: Maybe<Scalars['BigInt']>;
  theme: Scalars['String'];
  version: Scalars['String'];
};

export type BinderCustomerShopifyThemeDeploymentAuditLogCustomerIdVersionCompoundUniqueInput = {
  customerId: Scalars['String'];
  version: Scalars['String'];
};

export type BinderCustomerShopifyThemeDeploymentAuditLogOrderByWithRelationInput = {
  customerId?: InputMaybe<SortOrder>;
  deployedAt?: InputMaybe<SortOrder>;
  deployedBy?: InputMaybe<SortOrder>;
  theme?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export enum BinderCustomerShopifyThemeDeploymentAuditLogScalarFieldEnum {
  CustomerId = 'customerId',
  DeployedAt = 'deployedAt',
  DeployedBy = 'deployedBy',
  Theme = 'theme',
  Version = 'version'
}

export type BinderCustomerShopifyThemeDeploymentAuditLogWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerShopifyThemeDeploymentAuditLogWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerShopifyThemeDeploymentAuditLogWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerShopifyThemeDeploymentAuditLogWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
  deployedAt?: InputMaybe<DateTimeNullableFilter>;
  deployedBy?: InputMaybe<BigIntNullableFilter>;
  theme?: InputMaybe<StringFilter>;
  version?: InputMaybe<StringFilter>;
};

export type BinderCustomerShopifyThemeDeploymentAuditLogWhereUniqueInput = {
  customerId_version?: InputMaybe<BinderCustomerShopifyThemeDeploymentAuditLogCustomerIdVersionCompoundUniqueInput>;
};

export type BinderCustomerShopifyThemeListRelationFilter = {
  every?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
  none?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
  some?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
};

export type BinderCustomerShopifyThemeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerShopifyThemeOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  ShopifyThemeRelease?: InputMaybe<ShopifyThemeReleaseOrderByWithRelationInput>;
  currentVersion?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  lastUpdate?: InputMaybe<SortOrder>;
  releaseTrain?: InputMaybe<SortOrder>;
  theme?: InputMaybe<SortOrder>;
};

export enum BinderCustomerShopifyThemeScalarFieldEnum {
  CurrentVersion = 'currentVersion',
  CustomerId = 'customerId',
  LastUpdate = 'lastUpdate',
  ReleaseTrain = 'releaseTrain',
  Theme = 'theme'
}

export type BinderCustomerShopifyThemeScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerShopifyThemeScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerShopifyThemeScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerShopifyThemeScalarWhereInput>>;
  currentVersion?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  lastUpdate?: InputMaybe<DateTimeNullableFilter>;
  releaseTrain?: InputMaybe<EnumReleaseTrainFilter>;
  theme?: InputMaybe<StringFilter>;
};

export type BinderCustomerShopifyThemeUpdateInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneRequiredWithoutBinderCustomerShopifyThemeNestedInput>;
  ShopifyThemeRelease?: InputMaybe<ShopifyThemeReleaseUpdateOneRequiredWithoutBinderCustomerShopifyThemeNestedInput>;
  lastUpdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  releaseTrain?: InputMaybe<EnumReleaseTrainFieldUpdateOperationsInput>;
};

export type BinderCustomerShopifyThemeUpdateManyMutationInput = {
  lastUpdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  releaseTrain?: InputMaybe<EnumReleaseTrainFieldUpdateOperationsInput>;
};

export type BinderCustomerShopifyThemeUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: BinderCustomerShopifyThemeUpdateManyMutationInput;
  where: BinderCustomerShopifyThemeScalarWhereInput;
};

export type BinderCustomerShopifyThemeUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerShopifyThemeCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerShopifyThemeCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerShopifyThemeCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerShopifyThemeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerShopifyThemeWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerShopifyThemeUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerShopifyThemeUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<BinderCustomerShopifyThemeUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type BinderCustomerShopifyThemeUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: BinderCustomerShopifyThemeUpdateWithoutBinderCustomerInput;
  where: BinderCustomerShopifyThemeWhereUniqueInput;
};

export type BinderCustomerShopifyThemeUpdateWithoutBinderCustomerInput = {
  ShopifyThemeRelease?: InputMaybe<ShopifyThemeReleaseUpdateOneRequiredWithoutBinderCustomerShopifyThemeNestedInput>;
  lastUpdate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  releaseTrain?: InputMaybe<EnumReleaseTrainFieldUpdateOperationsInput>;
};

export type BinderCustomerShopifyThemeUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: BinderCustomerShopifyThemeCreateWithoutBinderCustomerInput;
  update: BinderCustomerShopifyThemeUpdateWithoutBinderCustomerInput;
  where: BinderCustomerShopifyThemeWhereUniqueInput;
};

export type BinderCustomerShopifyThemeWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerShopifyThemeWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerShopifyThemeWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerShopifyThemeWhereInput>>;
  ShopifyThemeRelease?: InputMaybe<ShopifyThemeReleaseRelationFilter>;
  currentVersion?: InputMaybe<StringFilter>;
  customerId?: InputMaybe<StringFilter>;
  lastUpdate?: InputMaybe<DateTimeNullableFilter>;
  releaseTrain?: InputMaybe<EnumReleaseTrainFilter>;
  theme?: InputMaybe<StringFilter>;
};

export type BinderCustomerShopifyThemeWhereUniqueInput = {
  customerId_theme?: InputMaybe<BinderCustomerShopifyThemeCustomerIdThemeCompoundUniqueInput>;
};

export type BinderCustomerTill = {
  __typename?: 'BinderCustomerTill';
  BinderCustomerTillSensitiveSettings: Array<BinderCustomerTillSensitiveSettings>;
  BinderCustomerTillSettings: Array<BinderCustomerTillSettings>;
  Cart: Array<Cart>;
  POSFloat: Array<PosFloat>;
  Quicklinks: Array<Quicklinks>;
  _count?: Maybe<BinderCustomerTillCount>;
  archived: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};


export type BinderCustomerTillBinderCustomerTillSensitiveSettingsArgs = {
  cursor?: InputMaybe<BinderCustomerTillSensitiveSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillSensitiveSettingsWhereInput>;
};


export type BinderCustomerTillBinderCustomerTillSettingsArgs = {
  cursor?: InputMaybe<BinderCustomerTillSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerTillSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
};


export type BinderCustomerTillCartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type BinderCustomerTillPosFloatArgs = {
  cursor?: InputMaybe<PosFloatWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PosFloatOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatWhereInput>;
};


export type BinderCustomerTillQuicklinksArgs = {
  cursor?: InputMaybe<QuicklinksWhereUniqueInput>;
  distinct?: InputMaybe<Array<QuicklinksScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<QuicklinksOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuicklinksWhereInput>;
};

export type BinderCustomerTillCount = {
  __typename?: 'BinderCustomerTillCount';
  BinderCustomerTillSensitiveSettings: Scalars['Int'];
  BinderCustomerTillSettings: Scalars['Int'];
  Cart: Scalars['Int'];
  POSFloat: Scalars['Int'];
  Quicklinks: Scalars['Int'];
};

export type BinderCustomerTillCreateNestedOneWithoutCartInput = {
  connect?: InputMaybe<BinderCustomerTillWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerTillCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<BinderCustomerTillCreateWithoutCartInput>;
};

export type BinderCustomerTillCreateOrConnectWithoutCartInput = {
  create: BinderCustomerTillCreateWithoutCartInput;
  where: BinderCustomerTillWhereUniqueInput;
};

export type BinderCustomerTillCreateWithoutCartInput = {
  BinderCustomerTillSensitiveSettings?: InputMaybe<BinderCustomerTillSensitiveSettingsCreateNestedManyWithoutBinderCustomerTillInput>;
  BinderCustomerTillSettings?: InputMaybe<BinderCustomerTillSettingsCreateNestedManyWithoutBinderCustomerTillInput>;
  POSFloat?: InputMaybe<PosFloatCreateNestedManyWithoutBinderCustomerTillInput>;
  Quicklinks?: InputMaybe<QuicklinksCreateNestedManyWithoutBinderCustomerTillInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isActive: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillDto = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillOrderByWithRelationInput = {
  BinderCustomerTillSensitiveSettings?: InputMaybe<BinderCustomerTillSensitiveSettingsOrderByRelationAggregateInput>;
  BinderCustomerTillSettings?: InputMaybe<BinderCustomerTillSettingsOrderByRelationAggregateInput>;
  Cart?: InputMaybe<CartOrderByRelationAggregateInput>;
  POSFloat?: InputMaybe<PosFloatOrderByRelationAggregateInput>;
  Quicklinks?: InputMaybe<QuicklinksOrderByRelationAggregateInput>;
  archived?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type BinderCustomerTillRelationFilter = {
  is?: InputMaybe<BinderCustomerTillWhereInput>;
  isNot?: InputMaybe<BinderCustomerTillWhereInput>;
};

export enum BinderCustomerTillScalarFieldEnum {
  Archived = 'archived',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Description = 'description',
  Id = 'id',
  IsActive = 'isActive',
  Name = 'name'
}

export type BinderCustomerTillSensitiveSettings = {
  __typename?: 'BinderCustomerTillSensitiveSettings';
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  editable: Scalars['Boolean'];
  id: Scalars['BigInt'];
  settingName?: Maybe<Scalars['String']>;
  settingValue?: Maybe<Scalars['String']>;
  tillId?: Maybe<Scalars['BigInt']>;
};

export type BinderCustomerTillSensitiveSettingsCreateManyBinderCustomerTillInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillSensitiveSettingsCreateManyBinderCustomerTillInputEnvelope = {
  data: Array<BinderCustomerTillSensitiveSettingsCreateManyBinderCustomerTillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerTillSensitiveSettingsCreateNestedManyWithoutBinderCustomerTillInput = {
  connect?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<BinderCustomerTillSensitiveSettingsCreateManyBinderCustomerTillInputEnvelope>;
};

export type BinderCustomerTillSensitiveSettingsCreateOrConnectWithoutBinderCustomerTillInput = {
  create: BinderCustomerTillSensitiveSettingsCreateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSensitiveSettingsWhereUniqueInput;
};

export type BinderCustomerTillSensitiveSettingsCreateWithoutBinderCustomerTillInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillSensitiveSettingsListRelationFilter = {
  every?: InputMaybe<BinderCustomerTillSensitiveSettingsWhereInput>;
  none?: InputMaybe<BinderCustomerTillSensitiveSettingsWhereInput>;
  some?: InputMaybe<BinderCustomerTillSensitiveSettingsWhereInput>;
};

export type BinderCustomerTillSensitiveSettingsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerTillSensitiveSettingsOrderByWithRelationInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillOrderByWithRelationInput>;
  editable?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  settingName?: InputMaybe<SortOrder>;
  settingValue?: InputMaybe<SortOrder>;
  tillId?: InputMaybe<SortOrder>;
};

export enum BinderCustomerTillSensitiveSettingsScalarFieldEnum {
  Editable = 'editable',
  Id = 'id',
  SettingName = 'settingName',
  SettingValue = 'settingValue',
  TillId = 'tillId'
}

export type BinderCustomerTillSensitiveSettingsScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsScalarWhereInput>>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
};

export type BinderCustomerTillSensitiveSettingsTillIdSettingNameCompoundUniqueInput = {
  settingName: Scalars['String'];
  tillId: Scalars['BigInt'];
};

export type BinderCustomerTillSensitiveSettingsUpdateManyMutationInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerTillSensitiveSettingsUpdateManyWithWhereWithoutBinderCustomerTillInput = {
  data: BinderCustomerTillSensitiveSettingsUpdateManyMutationInput;
  where: BinderCustomerTillSensitiveSettingsScalarWhereInput;
};

export type BinderCustomerTillSensitiveSettingsUpdateManyWithoutBinderCustomerTillNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<BinderCustomerTillSensitiveSettingsCreateManyBinderCustomerTillInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsUpdateWithWhereUniqueWithoutBinderCustomerTillInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsUpdateManyWithWhereWithoutBinderCustomerTillInput>>;
  upsert?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsUpsertWithWhereUniqueWithoutBinderCustomerTillInput>>;
};

export type BinderCustomerTillSensitiveSettingsUpdateWithWhereUniqueWithoutBinderCustomerTillInput = {
  data: BinderCustomerTillSensitiveSettingsUpdateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSensitiveSettingsWhereUniqueInput;
};

export type BinderCustomerTillSensitiveSettingsUpdateWithoutBinderCustomerTillInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerTillSensitiveSettingsUpsertWithWhereUniqueWithoutBinderCustomerTillInput = {
  create: BinderCustomerTillSensitiveSettingsCreateWithoutBinderCustomerTillInput;
  update: BinderCustomerTillSensitiveSettingsUpdateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSensitiveSettingsWhereUniqueInput;
};

export type BinderCustomerTillSensitiveSettingsWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereInput>>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerTillSensitiveSettingsWhereInput>>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
};

export type BinderCustomerTillSensitiveSettingsWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tillId_settingName?: InputMaybe<BinderCustomerTillSensitiveSettingsTillIdSettingNameCompoundUniqueInput>;
};

export type BinderCustomerTillSettings = {
  __typename?: 'BinderCustomerTillSettings';
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  editable: Scalars['Boolean'];
  id: Scalars['BigInt'];
  settingName?: Maybe<Scalars['String']>;
  settingValue?: Maybe<Scalars['String']>;
  tillId?: Maybe<Scalars['BigInt']>;
};

export type BinderCustomerTillSettingsCreateManyBinderCustomerTillInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillSettingsCreateManyBinderCustomerTillInputEnvelope = {
  data: Array<BinderCustomerTillSettingsCreateManyBinderCustomerTillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerTillSettingsCreateNestedManyWithoutBinderCustomerTillInput = {
  connect?: InputMaybe<Array<BinderCustomerTillSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerTillSettingsCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<BinderCustomerTillSettingsCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<BinderCustomerTillSettingsCreateManyBinderCustomerTillInputEnvelope>;
};

export type BinderCustomerTillSettingsCreateOrConnectWithoutBinderCustomerTillInput = {
  create: BinderCustomerTillSettingsCreateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSettingsWhereUniqueInput;
};

export type BinderCustomerTillSettingsCreateWithoutBinderCustomerTillInput = {
  editable: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
  settingValue?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerTillSettingsListRelationFilter = {
  every?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
  none?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
  some?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
};

export type BinderCustomerTillSettingsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerTillSettingsOrderByWithRelationInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillOrderByWithRelationInput>;
  editable?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  settingName?: InputMaybe<SortOrder>;
  settingValue?: InputMaybe<SortOrder>;
  tillId?: InputMaybe<SortOrder>;
};

export enum BinderCustomerTillSettingsScalarFieldEnum {
  Editable = 'editable',
  Id = 'id',
  SettingName = 'settingName',
  SettingValue = 'settingValue',
  TillId = 'tillId'
}

export type BinderCustomerTillSettingsScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerTillSettingsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerTillSettingsScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerTillSettingsScalarWhereInput>>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
};

export type BinderCustomerTillSettingsUKdk67g5yrxetl95sbmurv644utCompoundUniqueInput = {
  settingName: Scalars['String'];
  tillId: Scalars['BigInt'];
};

export type BinderCustomerTillSettingsUpdateManyMutationInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerTillSettingsUpdateManyWithWhereWithoutBinderCustomerTillInput = {
  data: BinderCustomerTillSettingsUpdateManyMutationInput;
  where: BinderCustomerTillSettingsScalarWhereInput;
};

export type BinderCustomerTillSettingsUpdateManyWithoutBinderCustomerTillNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerTillSettingsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerTillSettingsCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<BinderCustomerTillSettingsCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<BinderCustomerTillSettingsCreateManyBinderCustomerTillInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerTillSettingsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerTillSettingsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerTillSettingsWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerTillSettingsWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerTillSettingsUpdateWithWhereUniqueWithoutBinderCustomerTillInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerTillSettingsUpdateManyWithWhereWithoutBinderCustomerTillInput>>;
  upsert?: InputMaybe<Array<BinderCustomerTillSettingsUpsertWithWhereUniqueWithoutBinderCustomerTillInput>>;
};

export type BinderCustomerTillSettingsUpdateWithWhereUniqueWithoutBinderCustomerTillInput = {
  data: BinderCustomerTillSettingsUpdateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSettingsWhereUniqueInput;
};

export type BinderCustomerTillSettingsUpdateWithoutBinderCustomerTillInput = {
  editable?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  settingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  settingValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerTillSettingsUpsertWithWhereUniqueWithoutBinderCustomerTillInput = {
  create: BinderCustomerTillSettingsCreateWithoutBinderCustomerTillInput;
  update: BinderCustomerTillSettingsUpdateWithoutBinderCustomerTillInput;
  where: BinderCustomerTillSettingsWhereUniqueInput;
};

export type BinderCustomerTillSettingsWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerTillSettingsWhereInput>>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerTillSettingsWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerTillSettingsWhereInput>>;
  editable?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  settingName?: InputMaybe<StringNullableFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
};

export type BinderCustomerTillSettingsWhereUniqueInput = {
  UKdk67g5yrxetl95sbmurv644ut?: InputMaybe<BinderCustomerTillSettingsUKdk67g5yrxetl95sbmurv644utCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type BinderCustomerTillUKpkn4tq8j26sj8s6ci7oc56l63CompoundUniqueInput = {
  customerId: Scalars['String'];
  name: Scalars['String'];
};

export type BinderCustomerTillUpdateOneWithoutCartNestedInput = {
  connect?: InputMaybe<BinderCustomerTillWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerTillCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<BinderCustomerTillCreateWithoutCartInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerTillUpdateWithoutCartInput>;
  upsert?: InputMaybe<BinderCustomerTillUpsertWithoutCartInput>;
};

export type BinderCustomerTillUpdateWithoutCartInput = {
  BinderCustomerTillSensitiveSettings?: InputMaybe<BinderCustomerTillSensitiveSettingsUpdateManyWithoutBinderCustomerTillNestedInput>;
  BinderCustomerTillSettings?: InputMaybe<BinderCustomerTillSettingsUpdateManyWithoutBinderCustomerTillNestedInput>;
  POSFloat?: InputMaybe<PosFloatUpdateManyWithoutBinderCustomerTillNestedInput>;
  Quicklinks?: InputMaybe<QuicklinksUpdateManyWithoutBinderCustomerTillNestedInput>;
  archived?: InputMaybe<BoolFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type BinderCustomerTillUpsertWithoutCartInput = {
  create: BinderCustomerTillCreateWithoutCartInput;
  update: BinderCustomerTillUpdateWithoutCartInput;
};

export type BinderCustomerTillWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerTillWhereInput>>;
  BinderCustomerTillSensitiveSettings?: InputMaybe<BinderCustomerTillSensitiveSettingsListRelationFilter>;
  BinderCustomerTillSettings?: InputMaybe<BinderCustomerTillSettingsListRelationFilter>;
  Cart?: InputMaybe<CartListRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerTillWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerTillWhereInput>>;
  POSFloat?: InputMaybe<PosFloatListRelationFilter>;
  Quicklinks?: InputMaybe<QuicklinksListRelationFilter>;
  archived?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  isActive?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
};

export type BinderCustomerTillWhereUniqueInput = {
  UKpkn4tq8j26sj8s6ci7oc56l63?: InputMaybe<BinderCustomerTillUKpkn4tq8j26sj8s6ci7oc56l63CompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type BinderCustomerUpdateOneRequiredWithoutBinderCustomerShopifyThemeNestedInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutBinderCustomerShopifyThemeInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutBinderCustomerShopifyThemeInput>;
  update?: InputMaybe<BinderCustomerUpdateWithoutBinderCustomerShopifyThemeInput>;
  upsert?: InputMaybe<BinderCustomerUpsertWithoutBinderCustomerShopifyThemeInput>;
};

export type BinderCustomerUpdateOneRequiredWithoutBinderCustomerUserNestedInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutBinderCustomerUserInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutBinderCustomerUserInput>;
  update?: InputMaybe<BinderCustomerUpdateWithoutBinderCustomerUserInput>;
  upsert?: InputMaybe<BinderCustomerUpsertWithoutBinderCustomerUserInput>;
};

export type BinderCustomerUpdateOneWithoutCartNestedInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutCartInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerUpdateWithoutCartInput>;
  upsert?: InputMaybe<BinderCustomerUpsertWithoutCartInput>;
};

export type BinderCustomerUpdateOneWithoutShopifyCustomerBuylistNestedInput = {
  connect?: InputMaybe<BinderCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput>;
  create?: InputMaybe<BinderCustomerCreateWithoutShopifyCustomerBuylistInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerUpdateWithoutShopifyCustomerBuylistInput>;
  upsert?: InputMaybe<BinderCustomerUpsertWithoutShopifyCustomerBuylistInput>;
};

export type BinderCustomerUpdateWithoutBinderCustomerShopifyThemeInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserUpdateManyWithoutBinderCustomerNestedInput>;
  Cart?: InputMaybe<CartUpdateManyWithoutBinderCustomerNestedInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistUpdateManyWithoutBinderCustomerNestedInput>;
  allowNonEnglish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  apiKeyPassword?: InputMaybe<StringFieldUpdateOperationsInput>;
  betaTester?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  binderKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buylistRoundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  commonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  differentHandle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mythicLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  noRounding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nonEnglishWording?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  posPriceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMultiplier?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  primaryLogin?: InputMaybe<StringFieldUpdateOperationsInput>;
  rareLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  roundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  siteUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  standaloneEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tcgPlayerPriceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  test?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uncommonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatePricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useOriginalPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useTCGPlayerPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type BinderCustomerUpdateWithoutBinderCustomerUserInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeUpdateManyWithoutBinderCustomerNestedInput>;
  Cart?: InputMaybe<CartUpdateManyWithoutBinderCustomerNestedInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistUpdateManyWithoutBinderCustomerNestedInput>;
  allowNonEnglish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  apiKeyPassword?: InputMaybe<StringFieldUpdateOperationsInput>;
  betaTester?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  binderKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buylistRoundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  commonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  differentHandle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mythicLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  noRounding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nonEnglishWording?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  posPriceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMultiplier?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  primaryLogin?: InputMaybe<StringFieldUpdateOperationsInput>;
  rareLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  roundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  siteUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  standaloneEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tcgPlayerPriceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  test?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uncommonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatePricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useOriginalPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useTCGPlayerPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type BinderCustomerUpdateWithoutCartInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserUpdateManyWithoutBinderCustomerNestedInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistUpdateManyWithoutBinderCustomerNestedInput>;
  allowNonEnglish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  apiKeyPassword?: InputMaybe<StringFieldUpdateOperationsInput>;
  betaTester?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  binderKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buylistRoundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  commonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  differentHandle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mythicLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  noRounding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nonEnglishWording?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  posPriceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMultiplier?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  primaryLogin?: InputMaybe<StringFieldUpdateOperationsInput>;
  rareLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  roundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  siteUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  standaloneEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tcgPlayerPriceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  test?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uncommonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatePricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useOriginalPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useTCGPlayerPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type BinderCustomerUpdateWithoutShopifyCustomerBuylistInput = {
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeUpdateManyWithoutBinderCustomerNestedInput>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserUpdateManyWithoutBinderCustomerNestedInput>;
  Cart?: InputMaybe<CartUpdateManyWithoutBinderCustomerNestedInput>;
  allowNonEnglish?: InputMaybe<BoolFieldUpdateOperationsInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  apiKeyPassword?: InputMaybe<StringFieldUpdateOperationsInput>;
  betaTester?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  binderKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buylistRoundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  commonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<StringFieldUpdateOperationsInput>;
  differentHandle?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mythicLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  noRounding?: InputMaybe<BoolFieldUpdateOperationsInput>;
  nonEnglishWording?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  posPriceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMarkup?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  priceMultiplier?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  primaryLogin?: InputMaybe<StringFieldUpdateOperationsInput>;
  rareLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  roundToNearest?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  setup?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sharedSecret?: InputMaybe<StringFieldUpdateOperationsInput>;
  siteUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  standaloneEnabled?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tcgPlayerPriceType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  test?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  timezone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uncommonLowPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  updatePricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useOriginalPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  useTCGPlayerPricing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type BinderCustomerUpsertWithoutBinderCustomerShopifyThemeInput = {
  create: BinderCustomerCreateWithoutBinderCustomerShopifyThemeInput;
  update: BinderCustomerUpdateWithoutBinderCustomerShopifyThemeInput;
};

export type BinderCustomerUpsertWithoutBinderCustomerUserInput = {
  create: BinderCustomerCreateWithoutBinderCustomerUserInput;
  update: BinderCustomerUpdateWithoutBinderCustomerUserInput;
};

export type BinderCustomerUpsertWithoutCartInput = {
  create: BinderCustomerCreateWithoutCartInput;
  update: BinderCustomerUpdateWithoutCartInput;
};

export type BinderCustomerUpsertWithoutShopifyCustomerBuylistInput = {
  create: BinderCustomerCreateWithoutShopifyCustomerBuylistInput;
  update: BinderCustomerUpdateWithoutShopifyCustomerBuylistInput;
};

export type BinderCustomerUser = {
  __typename?: 'BinderCustomerUser';
  BinderCustomer: BinderCustomer;
  Cart_BinderCustomerUserToCart_createdBy: Array<Cart>;
  Cart_BinderCustomerUserToCart_removedBy: Array<Cart>;
  Cart_BinderCustomerUserToCart_submittedBy: Array<Cart>;
  _count?: Maybe<BinderCustomerUserCount>;
  customerId: Scalars['String'];
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  lastName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type BinderCustomerUserCart_BinderCustomerUserToCart_CreatedByArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type BinderCustomerUserCart_BinderCustomerUserToCart_RemovedByArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type BinderCustomerUserCart_BinderCustomerUserToCart_SubmittedByArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};

export type BinderCustomerUserCount = {
  __typename?: 'BinderCustomerUserCount';
  Cart_BinderCustomerUserToCart_createdBy: Scalars['Int'];
  Cart_BinderCustomerUserToCart_removedBy: Scalars['Int'];
  Cart_BinderCustomerUserToCart_submittedBy: Scalars['Int'];
};

export type BinderCustomerUserCreateManyBinderCustomerInput = {
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type BinderCustomerUserCreateManyBinderCustomerInputEnvelope = {
  data: Array<BinderCustomerUserCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BinderCustomerUserCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<BinderCustomerUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerUserCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerUserCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerUserCreateManyBinderCustomerInputEnvelope>;
};

export type BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
};

export type BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
};

export type BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
};

export type BinderCustomerUserCreateOrConnectWithoutBinderCustomerInput = {
  create: BinderCustomerUserCreateWithoutBinderCustomerInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_CreatedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_CreatedByInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_RemovedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_RemovedByInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_SubmittedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_SubmittedByInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserCreateWithoutBinderCustomerInput = {
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_CreatedByInput = {
  BinderCustomer: BinderCustomerCreateNestedOneWithoutBinderCustomerUserInput;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_RemovedByInput = {
  BinderCustomer: BinderCustomerCreateNestedOneWithoutBinderCustomerUserInput;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_SubmittedByInput = {
  BinderCustomer: BinderCustomerCreateNestedOneWithoutBinderCustomerUserInput;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type BinderCustomerUserListRelationFilter = {
  every?: InputMaybe<BinderCustomerUserWhereInput>;
  none?: InputMaybe<BinderCustomerUserWhereInput>;
  some?: InputMaybe<BinderCustomerUserWhereInput>;
};

export type BinderCustomerUserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BinderCustomerUserOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartOrderByRelationAggregateInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartOrderByRelationAggregateInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartOrderByRelationAggregateInput>;
  customerId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  enabled?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type BinderCustomerUserRelationFilter = {
  is?: InputMaybe<BinderCustomerUserWhereInput>;
  isNot?: InputMaybe<BinderCustomerUserWhereInput>;
};

export enum BinderCustomerUserScalarFieldEnum {
  CustomerId = 'customerId',
  Email = 'email',
  Enabled = 'enabled',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  UserId = 'userId'
}

export type BinderCustomerUserScalarWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerUserScalarWhereInput>>;
  NOT?: InputMaybe<Array<BinderCustomerUserScalarWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerUserScalarWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BinderCustomerUserUpdateManyMutationInput = {
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BinderCustomerUserUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: BinderCustomerUserUpdateManyMutationInput;
  where: BinderCustomerUserScalarWhereInput;
};

export type BinderCustomerUserUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<BinderCustomerUserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BinderCustomerUserCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<BinderCustomerUserCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<BinderCustomerUserCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<BinderCustomerUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BinderCustomerUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BinderCustomerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BinderCustomerUserWhereUniqueInput>>;
  update?: InputMaybe<Array<BinderCustomerUserUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<BinderCustomerUserUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<BinderCustomerUserUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  upsert?: InputMaybe<BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
};

export type BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  upsert?: InputMaybe<BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
};

export type BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput = {
  connect?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BinderCustomerUserCreateOrConnectWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  create?: InputMaybe<BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  upsert?: InputMaybe<BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
};

export type BinderCustomerUserUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: BinderCustomerUserUpdateWithoutBinderCustomerInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserUpdateWithoutBinderCustomerInput = {
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByNestedInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByNestedInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_CreatedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneRequiredWithoutBinderCustomerUserNestedInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByNestedInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_RemovedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneRequiredWithoutBinderCustomerUserNestedInput>;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByNestedInput>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_SubmittedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneRequiredWithoutBinderCustomerUserNestedInput>;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByNestedInput>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByNestedInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  enabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BinderCustomerUserUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: BinderCustomerUserCreateWithoutBinderCustomerInput;
  update: BinderCustomerUserUpdateWithoutBinderCustomerInput;
  where: BinderCustomerUserWhereUniqueInput;
};

export type BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_CreatedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_CreatedByInput;
  update: BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_CreatedByInput;
};

export type BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_RemovedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_RemovedByInput;
  update: BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_RemovedByInput;
};

export type BinderCustomerUserUpsertWithoutCart_BinderCustomerUserToCart_SubmittedByInput = {
  create: BinderCustomerUserCreateWithoutCart_BinderCustomerUserToCart_SubmittedByInput;
  update: BinderCustomerUserUpdateWithoutCart_BinderCustomerUserToCart_SubmittedByInput;
};

export type BinderCustomerUserWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerUserWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  Cart_BinderCustomerUserToCart_createdBy?: InputMaybe<CartListRelationFilter>;
  Cart_BinderCustomerUserToCart_removedBy?: InputMaybe<CartListRelationFilter>;
  Cart_BinderCustomerUserToCart_submittedBy?: InputMaybe<CartListRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerUserWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerUserWhereInput>>;
  customerId?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  enabled?: InputMaybe<BoolFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type BinderCustomerUserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type BinderCustomerWhereInput = {
  AND?: InputMaybe<Array<BinderCustomerWhereInput>>;
  BinderCustomerLocation?: InputMaybe<BinderCustomerLocationListRelationFilter>;
  BinderCustomerSettings?: InputMaybe<BinderCustomerSettingsListRelationFilter>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeListRelationFilter>;
  BinderCustomerUser?: InputMaybe<BinderCustomerUserListRelationFilter>;
  Cart?: InputMaybe<CartListRelationFilter>;
  NOT?: InputMaybe<Array<BinderCustomerWhereInput>>;
  OR?: InputMaybe<Array<BinderCustomerWhereInput>>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistListRelationFilter>;
  allowNonEnglish?: InputMaybe<BoolFilter>;
  apiKey?: InputMaybe<StringFilter>;
  apiKeyPassword?: InputMaybe<StringFilter>;
  betaTester?: InputMaybe<BoolNullableFilter>;
  binderKey?: InputMaybe<StringNullableFilter>;
  buylistRoundToNearest?: InputMaybe<FloatNullableFilter>;
  commonLowPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  currency?: InputMaybe<StringFilter>;
  differentHandle?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  mythicLowPrice?: InputMaybe<DecimalNullableFilter>;
  name?: InputMaybe<StringFilter>;
  noRounding?: InputMaybe<BoolFilter>;
  nonEnglishWording?: InputMaybe<StringNullableFilter>;
  posPriceMarkup?: InputMaybe<FloatNullableFilter>;
  priceMarkup?: InputMaybe<FloatNullableFilter>;
  priceMultiplier?: InputMaybe<FloatNullableFilter>;
  primaryLogin?: InputMaybe<StringFilter>;
  rareLowPrice?: InputMaybe<DecimalNullableFilter>;
  roundToNearest?: InputMaybe<FloatNullableFilter>;
  setup?: InputMaybe<BoolNullableFilter>;
  sharedSecret?: InputMaybe<StringFilter>;
  siteUrl?: InputMaybe<StringFilter>;
  standaloneEnabled?: InputMaybe<BoolNullableFilter>;
  tcgPlayerPriceType?: InputMaybe<StringNullableFilter>;
  test?: InputMaybe<BoolNullableFilter>;
  timezone?: InputMaybe<StringNullableFilter>;
  uncommonLowPrice?: InputMaybe<DecimalNullableFilter>;
  updatePricing?: InputMaybe<BoolNullableFilter>;
  useOriginalPricing?: InputMaybe<BoolNullableFilter>;
  useTCGPlayerPricing?: InputMaybe<BoolNullableFilter>;
};

export type BinderCustomerWhereUniqueInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  apiKeyPassword?: InputMaybe<Scalars['String']>;
  binderKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sharedSecret?: InputMaybe<Scalars['String']>;
  siteUrl?: InputMaybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type Cart = {
  __typename?: 'Cart';
  BinderCustomer?: Maybe<BinderCustomer>;
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: Maybe<BinderCustomerUser>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: Maybe<BinderCustomerUser>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: Maybe<BinderCustomerUser>;
  Cart?: Maybe<Cart>;
  CartIntegratedPayment: Array<CartIntegratedPayment>;
  CartItem: Array<CartItem>;
  CartItemInventoryAdjustment: Array<CartItemInventoryAdjustment>;
  CartTax: Array<CartTax>;
  CartTender: Array<CartTender>;
  ProductsToProcess: Array<ProductsToProcess>;
  ShopifyCustomer?: Maybe<ShopifyCustomer>;
  StoreCreditHistory: Array<StoreCreditHistory>;
  _count?: Maybe<CartCount>;
  abandoned: Scalars['Boolean'];
  binderCustomerId?: Maybe<Scalars['String']>;
  binderCustomerTillId?: Maybe<Scalars['BigInt']>;
  cartName?: Maybe<Scalars['String']>;
  cartNotes?: Maybe<Scalars['String']>;
  cartType?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['BigInt']>;
  dateCreated?: Maybe<Scalars['DateTime']>;
  dateSubmitted?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Decimal']>;
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  orderNumber?: Maybe<Scalars['String']>;
  other_Cart: Array<Cart>;
  parentCartId?: Maybe<Scalars['BigInt']>;
  removedBy?: Maybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: Maybe<Scalars['String']>;
  shopifyCustomerId?: Maybe<Scalars['BigInt']>;
  shopifyOrderId?: Maybe<Scalars['BigInt']>;
  subTotal?: Maybe<Scalars['Decimal']>;
  submittedBy?: Maybe<Scalars['BigInt']>;
  taxIncluded?: Maybe<Scalars['Boolean']>;
  taxRate?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Decimal']>;
  totalTax?: Maybe<Scalars['Decimal']>;
};


export type CartCartIntegratedPaymentArgs = {
  cursor?: InputMaybe<CartIntegratedPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartIntegratedPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartIntegratedPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartIntegratedPaymentWhereInput>;
};


export type CartCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type CartCartItemInventoryAdjustmentArgs = {
  cursor?: InputMaybe<CartItemInventoryAdjustmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemInventoryAdjustmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemInventoryAdjustmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};


export type CartCartTaxArgs = {
  cursor?: InputMaybe<CartTaxWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTaxScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTaxOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTaxWhereInput>;
};


export type CartCartTenderArgs = {
  cursor?: InputMaybe<CartTenderWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTenderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTenderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTenderWhereInput>;
};


export type CartProductsToProcessArgs = {
  cursor?: InputMaybe<ProductsToProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductsToProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductsToProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsToProcessWhereInput>;
};


export type CartStoreCreditHistoryArgs = {
  cursor?: InputMaybe<StoreCreditHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StoreCreditHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StoreCreditHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoreCreditHistoryWhereInput>;
};


export type CartOther_CartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};

export type CartCount = {
  __typename?: 'CartCount';
  CartIntegratedPayment: Scalars['Int'];
  CartItem: Scalars['Int'];
  CartItemInventoryAdjustment: Scalars['Int'];
  CartTax: Scalars['Int'];
  CartTender: Scalars['Int'];
  ProductsToProcess: Scalars['Int'];
  StoreCreditHistory: Scalars['Int'];
  other_Cart: Scalars['Int'];
};

export type CartCreateManyBinderCustomerInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  removedBy?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyBinderCustomerInputEnvelope = {
  data: Array<CartCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  removedBy?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_CreatedByInputEnvelope = {
  data: Array<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_RemovedByInputEnvelope = {
  data: Array<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  removedBy?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInputEnvelope = {
  data: Array<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateManyCartInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  removedBy?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyCartInputEnvelope = {
  data: Array<CartCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateManyShopifyCustomerInput = {
  abandoned: Scalars['Boolean'];
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerTillId?: InputMaybe<Scalars['BigInt']>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  removedBy?: InputMaybe<Scalars['BigInt']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateManyShopifyCustomerInputEnvelope = {
  data: Array<CartCreateManyShopifyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerInputEnvelope>;
};

export type CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_CreatedByInputEnvelope>;
};

export type CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_RemovedByInputEnvelope>;
};

export type CartCreateNestedManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInputEnvelope>;
};

export type CartCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartCreateManyCartInputEnvelope>;
};

export type CartCreateNestedManyWithoutShopifyCustomerInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<CartCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<CartCreateManyShopifyCustomerInputEnvelope>;
};

export type CartCreateNestedOneWithoutCartItemInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<CartCreateWithoutCartItemInput>;
};

export type CartCreateNestedOneWithoutCartItemInventoryAdjustmentInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutCartItemInventoryAdjustmentInput>;
  create?: InputMaybe<CartCreateWithoutCartItemInventoryAdjustmentInput>;
};

export type CartCreateNestedOneWithoutOther_CartInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutOther_CartInput>;
  create?: InputMaybe<CartCreateWithoutOther_CartInput>;
};

export type CartCreateNestedOneWithoutProductsToProcessInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutProductsToProcessInput>;
  create?: InputMaybe<CartCreateWithoutProductsToProcessInput>;
};

export type CartCreateNestedOneWithoutStoreCreditHistoryInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutStoreCreditHistoryInput>;
  create?: InputMaybe<CartCreateWithoutStoreCreditHistoryInput>;
};

export type CartCreateOrConnectWithoutBinderCustomerInput = {
  create: CartCreateWithoutBinderCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutCartInput = {
  create: CartCreateWithoutCartInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutCartItemInput = {
  create: CartCreateWithoutCartItemInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutCartItemInventoryAdjustmentInput = {
  create: CartCreateWithoutCartItemInventoryAdjustmentInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutOther_CartInput = {
  create: CartCreateWithoutOther_CartInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutProductsToProcessInput = {
  create: CartCreateWithoutProductsToProcessInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutShopifyCustomerInput = {
  create: CartCreateWithoutShopifyCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartCreateOrConnectWithoutStoreCreditHistoryInput = {
  create: CartCreateWithoutStoreCreditHistoryInput;
  where: CartWhereUniqueInput;
};

export type CartCreateWithoutBinderCustomerInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutCartInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutCartItemInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutCartItemInventoryAdjustmentInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutOther_CartInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutProductsToProcessInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutShopifyCustomerInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartCreateWithoutStoreCreditHistoryInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutCartInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillCreateNestedOneWithoutCartInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_CreatedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_RemovedByInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserCreateNestedOneWithoutCart_BinderCustomerUserToCart_SubmittedByInput>;
  Cart?: InputMaybe<CartCreateNestedOneWithoutOther_CartInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentCreateNestedManyWithoutCartInput>;
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutCartInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput>;
  CartTax?: InputMaybe<CartTaxCreateNestedManyWithoutCartInput>;
  CartTender?: InputMaybe<CartTenderCreateNestedManyWithoutCartInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutCartInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutCartInput>;
  abandoned: Scalars['Boolean'];
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  other_Cart?: InputMaybe<CartCreateNestedManyWithoutCartInput>;
  savedCart: Scalars['Boolean'];
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type CartIntegratedPayment = {
  __typename?: 'CartIntegratedPayment';
  Cart: Cart;
  approveAmount?: Maybe<Scalars['Decimal']>;
  batchNumber?: Maybe<Scalars['BigInt']>;
  cardHolder?: Maybe<Scalars['String']>;
  cartId: Scalars['BigInt'];
  fullResponseObject?: Maybe<Scalars['String']>;
  hostResponseMessage?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  lastFour?: Maybe<Scalars['Int']>;
  surchargeFee?: Maybe<Scalars['Decimal']>;
  timeStamp?: Maybe<Scalars['BigInt']>;
  transactionNumber?: Maybe<Scalars['BigInt']>;
};

export type CartIntegratedPaymentCreateManyCartInput = {
  approveAmount?: InputMaybe<Scalars['Decimal']>;
  batchNumber?: InputMaybe<Scalars['BigInt']>;
  cardHolder?: InputMaybe<Scalars['String']>;
  fullResponseObject?: InputMaybe<Scalars['String']>;
  hostResponseMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastFour?: InputMaybe<Scalars['Int']>;
  surchargeFee?: InputMaybe<Scalars['Decimal']>;
  timeStamp?: InputMaybe<Scalars['BigInt']>;
  transactionNumber?: InputMaybe<Scalars['BigInt']>;
};

export type CartIntegratedPaymentCreateManyCartInputEnvelope = {
  data: Array<CartIntegratedPaymentCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartIntegratedPaymentCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartIntegratedPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartIntegratedPaymentCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartIntegratedPaymentCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartIntegratedPaymentCreateManyCartInputEnvelope>;
};

export type CartIntegratedPaymentCreateOrConnectWithoutCartInput = {
  create: CartIntegratedPaymentCreateWithoutCartInput;
  where: CartIntegratedPaymentWhereUniqueInput;
};

export type CartIntegratedPaymentCreateWithoutCartInput = {
  approveAmount?: InputMaybe<Scalars['Decimal']>;
  batchNumber?: InputMaybe<Scalars['BigInt']>;
  cardHolder?: InputMaybe<Scalars['String']>;
  fullResponseObject?: InputMaybe<Scalars['String']>;
  hostResponseMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastFour?: InputMaybe<Scalars['Int']>;
  surchargeFee?: InputMaybe<Scalars['Decimal']>;
  timeStamp?: InputMaybe<Scalars['BigInt']>;
  transactionNumber?: InputMaybe<Scalars['BigInt']>;
};

export type CartIntegratedPaymentDto = {
  approveAmount?: InputMaybe<Scalars['Decimal']>;
  batchNumber?: InputMaybe<Scalars['BigInt']>;
  cardHolder?: InputMaybe<Scalars['String']>;
  cartId: Scalars['BigInt'];
  fullResponseObject?: InputMaybe<Scalars['String']>;
  hostResponseMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastFour?: InputMaybe<Scalars['Int']>;
  surchargeFee?: InputMaybe<Scalars['Decimal']>;
  timeStamp?: InputMaybe<Scalars['BigInt']>;
  transactionNumber?: InputMaybe<Scalars['BigInt']>;
};

export type CartIntegratedPaymentListRelationFilter = {
  every?: InputMaybe<CartIntegratedPaymentWhereInput>;
  none?: InputMaybe<CartIntegratedPaymentWhereInput>;
  some?: InputMaybe<CartIntegratedPaymentWhereInput>;
};

export type CartIntegratedPaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartIntegratedPaymentOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  approveAmount?: InputMaybe<SortOrder>;
  batchNumber?: InputMaybe<SortOrder>;
  cardHolder?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  fullResponseObject?: InputMaybe<SortOrder>;
  hostResponseMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrder>;
  surchargeFee?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  transactionNumber?: InputMaybe<SortOrder>;
};

export enum CartIntegratedPaymentScalarFieldEnum {
  ApproveAmount = 'approveAmount',
  BatchNumber = 'batchNumber',
  CardHolder = 'cardHolder',
  CartId = 'cartId',
  FullResponseObject = 'fullResponseObject',
  HostResponseMessage = 'hostResponseMessage',
  Id = 'id',
  LastFour = 'lastFour',
  SurchargeFee = 'surchargeFee',
  TimeStamp = 'timeStamp',
  TransactionNumber = 'transactionNumber'
}

export type CartIntegratedPaymentScalarWhereInput = {
  AND?: InputMaybe<Array<CartIntegratedPaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartIntegratedPaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<CartIntegratedPaymentScalarWhereInput>>;
  approveAmount?: InputMaybe<DecimalNullableFilter>;
  batchNumber?: InputMaybe<BigIntNullableFilter>;
  cardHolder?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  fullResponseObject?: InputMaybe<StringNullableFilter>;
  hostResponseMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastFour?: InputMaybe<IntNullableFilter>;
  surchargeFee?: InputMaybe<DecimalNullableFilter>;
  timeStamp?: InputMaybe<BigIntNullableFilter>;
  transactionNumber?: InputMaybe<BigIntNullableFilter>;
};

export type CartIntegratedPaymentUpdateManyMutationInput = {
  approveAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  batchNumber?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  cardHolder?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullResponseObject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hostResponseMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  surchargeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  timeStamp?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  transactionNumber?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
};

export type CartIntegratedPaymentUpdateManyWithWhereWithoutCartInput = {
  data: CartIntegratedPaymentUpdateManyMutationInput;
  where: CartIntegratedPaymentScalarWhereInput;
};

export type CartIntegratedPaymentUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartIntegratedPaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartIntegratedPaymentCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartIntegratedPaymentCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartIntegratedPaymentCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartIntegratedPaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartIntegratedPaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartIntegratedPaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<CartIntegratedPaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<CartIntegratedPaymentUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartIntegratedPaymentUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartIntegratedPaymentUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartIntegratedPaymentUpdateWithWhereUniqueWithoutCartInput = {
  data: CartIntegratedPaymentUpdateWithoutCartInput;
  where: CartIntegratedPaymentWhereUniqueInput;
};

export type CartIntegratedPaymentUpdateWithoutCartInput = {
  approveAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  batchNumber?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  cardHolder?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fullResponseObject?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hostResponseMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  surchargeFee?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  timeStamp?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  transactionNumber?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
};

export type CartIntegratedPaymentUpsertWithWhereUniqueWithoutCartInput = {
  create: CartIntegratedPaymentCreateWithoutCartInput;
  update: CartIntegratedPaymentUpdateWithoutCartInput;
  where: CartIntegratedPaymentWhereUniqueInput;
};

export type CartIntegratedPaymentWhereInput = {
  AND?: InputMaybe<Array<CartIntegratedPaymentWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<CartIntegratedPaymentWhereInput>>;
  OR?: InputMaybe<Array<CartIntegratedPaymentWhereInput>>;
  approveAmount?: InputMaybe<DecimalNullableFilter>;
  batchNumber?: InputMaybe<BigIntNullableFilter>;
  cardHolder?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  fullResponseObject?: InputMaybe<StringNullableFilter>;
  hostResponseMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastFour?: InputMaybe<IntNullableFilter>;
  surchargeFee?: InputMaybe<DecimalNullableFilter>;
  timeStamp?: InputMaybe<BigIntNullableFilter>;
  transactionNumber?: InputMaybe<BigIntNullableFilter>;
};

export type CartIntegratedPaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartItem = {
  __typename?: 'CartItem';
  Cart: Cart;
  CartItemAdditionalInfo: Array<CartItemAdditionalInfo>;
  ShopifyCustomerProductVariant?: Maybe<ShopifyCustomerProductVariant>;
  _count?: Maybe<CartItemCount>;
  actualPrice?: Maybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  cartId: Scalars['BigInt'];
  discountAmount?: Maybe<Scalars['Decimal']>;
  discountType?: Maybe<Scalars['String']>;
  discountValue?: Maybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  imageSrc?: Maybe<Scalars['String']>;
  itemTax?: Maybe<Scalars['Decimal']>;
  price?: Maybe<Scalars['Decimal']>;
  productTitle?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  shopifyPrice?: Maybe<Scalars['Decimal']>;
  shopifyTaxable?: Maybe<Scalars['Boolean']>;
  tags?: Maybe<Scalars['String']>;
  taxable?: Maybe<Scalars['Boolean']>;
  variantId?: Maybe<Scalars['BigInt']>;
  variantTitle?: Maybe<Scalars['String']>;
};


export type CartItemCartItemAdditionalInfoArgs = {
  cursor?: InputMaybe<CartItemAdditionalInfoWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemAdditionalInfoScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemAdditionalInfoOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemAdditionalInfoWhereInput>;
};

export type CartItemAdditionalInfo = {
  __typename?: 'CartItemAdditionalInfo';
  CartItem?: Maybe<CartItem>;
  cartItemId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CartItemAdditionalInfoCreateManyCartItemInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CartItemAdditionalInfoCreateManyCartItemInputEnvelope = {
  data: Array<CartItemAdditionalInfoCreateManyCartItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemAdditionalInfoCreateNestedManyWithoutCartItemInput = {
  connect?: InputMaybe<Array<CartItemAdditionalInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemAdditionalInfoCreateOrConnectWithoutCartItemInput>>;
  create?: InputMaybe<Array<CartItemAdditionalInfoCreateWithoutCartItemInput>>;
  createMany?: InputMaybe<CartItemAdditionalInfoCreateManyCartItemInputEnvelope>;
};

export type CartItemAdditionalInfoCreateOrConnectWithoutCartItemInput = {
  create: CartItemAdditionalInfoCreateWithoutCartItemInput;
  where: CartItemAdditionalInfoWhereUniqueInput;
};

export type CartItemAdditionalInfoCreateWithoutCartItemInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CartItemAdditionalInfoListRelationFilter = {
  every?: InputMaybe<CartItemAdditionalInfoWhereInput>;
  none?: InputMaybe<CartItemAdditionalInfoWhereInput>;
  some?: InputMaybe<CartItemAdditionalInfoWhereInput>;
};

export type CartItemAdditionalInfoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartItemAdditionalInfoOrderByWithRelationInput = {
  CartItem?: InputMaybe<CartItemOrderByWithRelationInput>;
  cartItemId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum CartItemAdditionalInfoScalarFieldEnum {
  CartItemId = 'cartItemId',
  Id = 'id',
  Name = 'name',
  Value = 'value'
}

export type CartItemAdditionalInfoScalarWhereInput = {
  AND?: InputMaybe<Array<CartItemAdditionalInfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartItemAdditionalInfoScalarWhereInput>>;
  OR?: InputMaybe<Array<CartItemAdditionalInfoScalarWhereInput>>;
  cartItemId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringNullableFilter>;
};

export type CartItemAdditionalInfoUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartItemAdditionalInfoUpdateManyWithWhereWithoutCartItemInput = {
  data: CartItemAdditionalInfoUpdateManyMutationInput;
  where: CartItemAdditionalInfoScalarWhereInput;
};

export type CartItemAdditionalInfoUpdateManyWithoutCartItemNestedInput = {
  connect?: InputMaybe<Array<CartItemAdditionalInfoWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemAdditionalInfoCreateOrConnectWithoutCartItemInput>>;
  create?: InputMaybe<Array<CartItemAdditionalInfoCreateWithoutCartItemInput>>;
  createMany?: InputMaybe<CartItemAdditionalInfoCreateManyCartItemInputEnvelope>;
  delete?: InputMaybe<Array<CartItemAdditionalInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemAdditionalInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemAdditionalInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemAdditionalInfoWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemAdditionalInfoUpdateWithWhereUniqueWithoutCartItemInput>>;
  updateMany?: InputMaybe<Array<CartItemAdditionalInfoUpdateManyWithWhereWithoutCartItemInput>>;
  upsert?: InputMaybe<Array<CartItemAdditionalInfoUpsertWithWhereUniqueWithoutCartItemInput>>;
};

export type CartItemAdditionalInfoUpdateWithWhereUniqueWithoutCartItemInput = {
  data: CartItemAdditionalInfoUpdateWithoutCartItemInput;
  where: CartItemAdditionalInfoWhereUniqueInput;
};

export type CartItemAdditionalInfoUpdateWithoutCartItemInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartItemAdditionalInfoUpsertWithWhereUniqueWithoutCartItemInput = {
  create: CartItemAdditionalInfoCreateWithoutCartItemInput;
  update: CartItemAdditionalInfoUpdateWithoutCartItemInput;
  where: CartItemAdditionalInfoWhereUniqueInput;
};

export type CartItemAdditionalInfoWhereInput = {
  AND?: InputMaybe<Array<CartItemAdditionalInfoWhereInput>>;
  CartItem?: InputMaybe<CartItemRelationFilter>;
  NOT?: InputMaybe<Array<CartItemAdditionalInfoWhereInput>>;
  OR?: InputMaybe<Array<CartItemAdditionalInfoWhereInput>>;
  cartItemId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringNullableFilter>;
  value?: InputMaybe<StringNullableFilter>;
};

export type CartItemAdditionalInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartItemCount = {
  __typename?: 'CartItemCount';
  CartItemAdditionalInfo: Scalars['Int'];
};

export type CartItemCreateManyCartInput = {
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageSrc?: InputMaybe<Scalars['String']>;
  itemTax?: InputMaybe<Scalars['Decimal']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productTitle?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shopifyPrice?: InputMaybe<Scalars['Decimal']>;
  shopifyTaxable?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
  variantTitle?: InputMaybe<Scalars['String']>;
};

export type CartItemCreateManyCartInputEnvelope = {
  data: Array<CartItemCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemCreateManyShopifyCustomerProductVariantInput = {
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  cartId: Scalars['BigInt'];
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageSrc?: InputMaybe<Scalars['String']>;
  itemTax?: InputMaybe<Scalars['Decimal']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productTitle?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shopifyPrice?: InputMaybe<Scalars['Decimal']>;
  shopifyTaxable?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  variantTitle?: InputMaybe<Scalars['String']>;
};

export type CartItemCreateManyShopifyCustomerProductVariantInputEnvelope = {
  data: Array<CartItemCreateManyShopifyCustomerProductVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartItemCreateManyCartInputEnvelope>;
};

export type CartItemCreateNestedManyWithoutShopifyCustomerProductVariantInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<CartItemCreateManyShopifyCustomerProductVariantInputEnvelope>;
};

export type CartItemCreateOrConnectWithoutCartInput = {
  create: CartItemCreateWithoutCartInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateOrConnectWithoutShopifyCustomerProductVariantInput = {
  create: CartItemCreateWithoutShopifyCustomerProductVariantInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateWithoutCartInput = {
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoCreateNestedManyWithoutCartItemInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantCreateNestedOneWithoutCartItemInput>;
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageSrc?: InputMaybe<Scalars['String']>;
  itemTax?: InputMaybe<Scalars['Decimal']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productTitle?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shopifyPrice?: InputMaybe<Scalars['Decimal']>;
  shopifyTaxable?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  variantTitle?: InputMaybe<Scalars['String']>;
};

export type CartItemCreateWithoutShopifyCustomerProductVariantInput = {
  Cart: CartCreateNestedOneWithoutCartItemInput;
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoCreateNestedManyWithoutCartItemInput>;
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageSrc?: InputMaybe<Scalars['String']>;
  itemTax?: InputMaybe<Scalars['Decimal']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productTitle?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  shopifyPrice?: InputMaybe<Scalars['Decimal']>;
  shopifyTaxable?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  variantTitle?: InputMaybe<Scalars['String']>;
};

export type CartItemDto = {
  actualPrice?: InputMaybe<Scalars['Decimal']>;
  buying: Scalars['Boolean'];
  cartId?: InputMaybe<Scalars['BigInt']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  eventAdditionalInfo?: InputMaybe<Array<LineItemProperty>>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageSrc?: InputMaybe<Scalars['String']>;
  itemTax?: InputMaybe<Scalars['Decimal']>;
  price?: InputMaybe<Scalars['Decimal']>;
  productTitle?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  quantityAvailable?: InputMaybe<Scalars['Int']>;
  refundMaxValue?: InputMaybe<Scalars['Decimal']>;
  shopifyPrice?: InputMaybe<Scalars['Decimal']>;
  shopifyTaxable?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
  variantTitle?: InputMaybe<Scalars['String']>;
};

export type CartItemInventoryAdjustment = {
  __typename?: 'CartItemInventoryAdjustment';
  Cart?: Maybe<Cart>;
  ShopifyCustomerProductVariant?: Maybe<ShopifyCustomerProductVariant>;
  binderCustomerId?: Maybe<Scalars['String']>;
  cartId?: Maybe<Scalars['BigInt']>;
  dateUpdated?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  quantityAfter?: Maybe<Scalars['Int']>;
  quantityChangeType?: Maybe<Scalars['String']>;
  quantityChanged?: Maybe<Scalars['Int']>;
  variantId?: Maybe<Scalars['BigInt']>;
};

export type CartItemInventoryAdjustmentCreateManyCartInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  quantityAfter?: InputMaybe<Scalars['Int']>;
  quantityChangeType?: InputMaybe<Scalars['String']>;
  quantityChanged?: InputMaybe<Scalars['Int']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
};

export type CartItemInventoryAdjustmentCreateManyCartInputEnvelope = {
  data: Array<CartItemInventoryAdjustmentCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemInventoryAdjustmentCreateManyShopifyCustomerProductVariantInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  cartId?: InputMaybe<Scalars['BigInt']>;
  dateUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  quantityAfter?: InputMaybe<Scalars['Int']>;
  quantityChangeType?: InputMaybe<Scalars['String']>;
  quantityChanged?: InputMaybe<Scalars['Int']>;
};

export type CartItemInventoryAdjustmentCreateManyShopifyCustomerProductVariantInputEnvelope = {
  data: Array<CartItemInventoryAdjustmentCreateManyShopifyCustomerProductVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartItemInventoryAdjustmentCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemInventoryAdjustmentCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartItemInventoryAdjustmentCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartItemInventoryAdjustmentCreateManyCartInputEnvelope>;
};

export type CartItemInventoryAdjustmentCreateNestedManyWithoutShopifyCustomerProductVariantInput = {
  connect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemInventoryAdjustmentCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<CartItemInventoryAdjustmentCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<CartItemInventoryAdjustmentCreateManyShopifyCustomerProductVariantInputEnvelope>;
};

export type CartItemInventoryAdjustmentCreateOrConnectWithoutCartInput = {
  create: CartItemInventoryAdjustmentCreateWithoutCartInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentCreateOrConnectWithoutShopifyCustomerProductVariantInput = {
  create: CartItemInventoryAdjustmentCreateWithoutShopifyCustomerProductVariantInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentCreateWithoutCartInput = {
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantCreateNestedOneWithoutCartItemInventoryAdjustmentInput>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  quantityAfter?: InputMaybe<Scalars['Int']>;
  quantityChangeType?: InputMaybe<Scalars['String']>;
  quantityChanged?: InputMaybe<Scalars['Int']>;
};

export type CartItemInventoryAdjustmentCreateWithoutShopifyCustomerProductVariantInput = {
  Cart?: InputMaybe<CartCreateNestedOneWithoutCartItemInventoryAdjustmentInput>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateUpdated?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  quantityAfter?: InputMaybe<Scalars['Int']>;
  quantityChangeType?: InputMaybe<Scalars['String']>;
  quantityChanged?: InputMaybe<Scalars['Int']>;
};

export type CartItemInventoryAdjustmentListRelationFilter = {
  every?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
  none?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
  some?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};

export type CartItemInventoryAdjustmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartItemInventoryAdjustmentOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantOrderByWithRelationInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  dateUpdated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantityAfter?: InputMaybe<SortOrder>;
  quantityChangeType?: InputMaybe<SortOrder>;
  quantityChanged?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
};

export enum CartItemInventoryAdjustmentScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  CartId = 'cartId',
  DateUpdated = 'dateUpdated',
  Id = 'id',
  QuantityAfter = 'quantityAfter',
  QuantityChangeType = 'quantityChangeType',
  QuantityChanged = 'quantityChanged',
  VariantId = 'variantId'
}

export type CartItemInventoryAdjustmentScalarWhereInput = {
  AND?: InputMaybe<Array<CartItemInventoryAdjustmentScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartItemInventoryAdjustmentScalarWhereInput>>;
  OR?: InputMaybe<Array<CartItemInventoryAdjustmentScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  dateUpdated?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  quantityAfter?: InputMaybe<IntNullableFilter>;
  quantityChangeType?: InputMaybe<StringNullableFilter>;
  quantityChanged?: InputMaybe<IntNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type CartItemInventoryAdjustmentUpdateManyMutationInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantityAfter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityChangeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantityChanged?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CartItemInventoryAdjustmentUpdateManyWithWhereWithoutCartInput = {
  data: CartItemInventoryAdjustmentUpdateManyMutationInput;
  where: CartItemInventoryAdjustmentScalarWhereInput;
};

export type CartItemInventoryAdjustmentUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput = {
  data: CartItemInventoryAdjustmentUpdateManyMutationInput;
  where: CartItemInventoryAdjustmentScalarWhereInput;
};

export type CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemInventoryAdjustmentCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartItemInventoryAdjustmentCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartItemInventoryAdjustmentCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemInventoryAdjustmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemInventoryAdjustmentUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartItemInventoryAdjustmentUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartItemInventoryAdjustmentUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartItemInventoryAdjustmentUpdateManyWithoutShopifyCustomerProductVariantNestedInput = {
  connect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemInventoryAdjustmentCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<CartItemInventoryAdjustmentCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<CartItemInventoryAdjustmentCreateManyShopifyCustomerProductVariantInputEnvelope>;
  delete?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemInventoryAdjustmentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemInventoryAdjustmentWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemInventoryAdjustmentUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
  updateMany?: InputMaybe<Array<CartItemInventoryAdjustmentUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput>>;
  upsert?: InputMaybe<Array<CartItemInventoryAdjustmentUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
};

export type CartItemInventoryAdjustmentUpdateWithWhereUniqueWithoutCartInput = {
  data: CartItemInventoryAdjustmentUpdateWithoutCartInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  data: CartItemInventoryAdjustmentUpdateWithoutShopifyCustomerProductVariantInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentUpdateWithoutCartInput = {
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantUpdateOneWithoutCartItemInventoryAdjustmentNestedInput>;
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantityAfter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityChangeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantityChanged?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CartItemInventoryAdjustmentUpdateWithoutShopifyCustomerProductVariantInput = {
  Cart?: InputMaybe<CartUpdateOneWithoutCartItemInventoryAdjustmentNestedInput>;
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantityAfter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityChangeType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantityChanged?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CartItemInventoryAdjustmentUpsertWithWhereUniqueWithoutCartInput = {
  create: CartItemInventoryAdjustmentCreateWithoutCartInput;
  update: CartItemInventoryAdjustmentUpdateWithoutCartInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  create: CartItemInventoryAdjustmentCreateWithoutShopifyCustomerProductVariantInput;
  update: CartItemInventoryAdjustmentUpdateWithoutShopifyCustomerProductVariantInput;
  where: CartItemInventoryAdjustmentWhereUniqueInput;
};

export type CartItemInventoryAdjustmentWhereInput = {
  AND?: InputMaybe<Array<CartItemInventoryAdjustmentWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<CartItemInventoryAdjustmentWhereInput>>;
  OR?: InputMaybe<Array<CartItemInventoryAdjustmentWhereInput>>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantRelationFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  dateUpdated?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  quantityAfter?: InputMaybe<IntNullableFilter>;
  quantityChangeType?: InputMaybe<StringNullableFilter>;
  quantityChanged?: InputMaybe<IntNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type CartItemInventoryAdjustmentWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartItemListRelationFilter = {
  every?: InputMaybe<CartItemWhereInput>;
  none?: InputMaybe<CartItemWhereInput>;
  some?: InputMaybe<CartItemWhereInput>;
};

export type CartItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartItemOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoOrderByRelationAggregateInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantOrderByWithRelationInput>;
  actualPrice?: InputMaybe<SortOrder>;
  buying?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  discountValue?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageSrc?: InputMaybe<SortOrder>;
  itemTax?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productTitle?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  shopifyPrice?: InputMaybe<SortOrder>;
  shopifyTaxable?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  taxable?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
  variantTitle?: InputMaybe<SortOrder>;
};

export type CartItemRelationFilter = {
  is?: InputMaybe<CartItemWhereInput>;
  isNot?: InputMaybe<CartItemWhereInput>;
};

export enum CartItemScalarFieldEnum {
  ActualPrice = 'actualPrice',
  Buying = 'buying',
  CartId = 'cartId',
  DiscountAmount = 'discountAmount',
  DiscountType = 'discountType',
  DiscountValue = 'discountValue',
  Id = 'id',
  ImageSrc = 'imageSrc',
  ItemTax = 'itemTax',
  Price = 'price',
  ProductTitle = 'productTitle',
  Quantity = 'quantity',
  ShopifyPrice = 'shopifyPrice',
  ShopifyTaxable = 'shopifyTaxable',
  Tags = 'tags',
  Taxable = 'taxable',
  VariantId = 'variantId',
  VariantTitle = 'variantTitle'
}

export type CartItemScalarWhereInput = {
  AND?: InputMaybe<Array<CartItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartItemScalarWhereInput>>;
  OR?: InputMaybe<Array<CartItemScalarWhereInput>>;
  actualPrice?: InputMaybe<DecimalNullableFilter>;
  buying?: InputMaybe<BoolFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountType?: InputMaybe<StringNullableFilter>;
  discountValue?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageSrc?: InputMaybe<StringNullableFilter>;
  itemTax?: InputMaybe<DecimalNullableFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  productTitle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  shopifyPrice?: InputMaybe<DecimalNullableFilter>;
  shopifyTaxable?: InputMaybe<BoolNullableFilter>;
  tags?: InputMaybe<StringNullableFilter>;
  taxable?: InputMaybe<BoolNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
  variantTitle?: InputMaybe<StringNullableFilter>;
};

export type CartItemUKligupprf73is26ct5gb8fk9e4CompoundUniqueInput = {
  cartId: Scalars['BigInt'];
  variantId: Scalars['BigInt'];
};

export type CartItemUpdateManyMutationInput = {
  actualPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buying?: InputMaybe<BoolFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageSrc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  productTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  shopifyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shopifyTaxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  variantTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartItemUpdateManyWithWhereWithoutCartInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartItemCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartItemUpdateManyWithoutShopifyCustomerProductVariantNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<CartItemCreateManyShopifyCustomerProductVariantInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
};

export type CartItemUpdateWithWhereUniqueWithoutCartInput = {
  data: CartItemUpdateWithoutCartInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  data: CartItemUpdateWithoutShopifyCustomerProductVariantInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithoutCartInput = {
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoUpdateManyWithoutCartItemNestedInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantUpdateOneWithoutCartItemNestedInput>;
  actualPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buying?: InputMaybe<BoolFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageSrc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  productTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  shopifyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shopifyTaxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  variantTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartItemUpdateWithoutShopifyCustomerProductVariantInput = {
  Cart?: InputMaybe<CartUpdateOneRequiredWithoutCartItemNestedInput>;
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoUpdateManyWithoutCartItemNestedInput>;
  actualPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buying?: InputMaybe<BoolFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageSrc?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  itemTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  productTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  shopifyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shopifyTaxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  tags?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  variantTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartItemUpsertWithWhereUniqueWithoutCartInput = {
  create: CartItemCreateWithoutCartInput;
  update: CartItemUpdateWithoutCartInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  create: CartItemCreateWithoutShopifyCustomerProductVariantInput;
  update: CartItemUpdateWithoutShopifyCustomerProductVariantInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemWhereInput = {
  AND?: InputMaybe<Array<CartItemWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  CartItemAdditionalInfo?: InputMaybe<CartItemAdditionalInfoListRelationFilter>;
  NOT?: InputMaybe<Array<CartItemWhereInput>>;
  OR?: InputMaybe<Array<CartItemWhereInput>>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantRelationFilter>;
  actualPrice?: InputMaybe<DecimalNullableFilter>;
  buying?: InputMaybe<BoolFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountType?: InputMaybe<StringNullableFilter>;
  discountValue?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageSrc?: InputMaybe<StringNullableFilter>;
  itemTax?: InputMaybe<DecimalNullableFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  productTitle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  shopifyPrice?: InputMaybe<DecimalNullableFilter>;
  shopifyTaxable?: InputMaybe<BoolNullableFilter>;
  tags?: InputMaybe<StringNullableFilter>;
  taxable?: InputMaybe<BoolNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
  variantTitle?: InputMaybe<StringNullableFilter>;
};

export type CartItemWhereUniqueInput = {
  UKligupprf73is26ct5gb8fk9e4?: InputMaybe<CartItemUKligupprf73is26ct5gb8fk9e4CompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartListRelationFilter = {
  every?: InputMaybe<CartWhereInput>;
  none?: InputMaybe<CartWhereInput>;
  some?: InputMaybe<CartWhereInput>;
};

export type CartOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillOrderByWithRelationInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserOrderByWithRelationInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserOrderByWithRelationInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserOrderByWithRelationInput>;
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentOrderByRelationAggregateInput>;
  CartItem?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentOrderByRelationAggregateInput>;
  CartTax?: InputMaybe<CartTaxOrderByRelationAggregateInput>;
  CartTender?: InputMaybe<CartTenderOrderByRelationAggregateInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessOrderByRelationAggregateInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerOrderByWithRelationInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryOrderByRelationAggregateInput>;
  abandoned?: InputMaybe<SortOrder>;
  binderCustomerId?: InputMaybe<SortOrder>;
  binderCustomerTillId?: InputMaybe<SortOrder>;
  cartName?: InputMaybe<SortOrder>;
  cartNotes?: InputMaybe<SortOrder>;
  cartType?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dateCreated?: InputMaybe<SortOrder>;
  dateSubmitted?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  discountValue?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdated?: InputMaybe<SortOrder>;
  orderNumber?: InputMaybe<SortOrder>;
  other_Cart?: InputMaybe<CartOrderByRelationAggregateInput>;
  parentCartId?: InputMaybe<SortOrder>;
  removedBy?: InputMaybe<SortOrder>;
  savedCart?: InputMaybe<SortOrder>;
  savedName?: InputMaybe<SortOrder>;
  shopifyCustomerId?: InputMaybe<SortOrder>;
  shopifyOrderId?: InputMaybe<SortOrder>;
  subTotal?: InputMaybe<SortOrder>;
  submittedBy?: InputMaybe<SortOrder>;
  taxIncluded?: InputMaybe<SortOrder>;
  taxRate?: InputMaybe<SortOrder>;
  totalPrice?: InputMaybe<SortOrder>;
  totalTax?: InputMaybe<SortOrder>;
};

export type CartRelationFilter = {
  is?: InputMaybe<CartWhereInput>;
  isNot?: InputMaybe<CartWhereInput>;
};

export enum CartScalarFieldEnum {
  Abandoned = 'abandoned',
  BinderCustomerId = 'binderCustomerId',
  BinderCustomerTillId = 'binderCustomerTillId',
  CartName = 'cartName',
  CartNotes = 'cartNotes',
  CartType = 'cartType',
  CreatedBy = 'createdBy',
  DateCreated = 'dateCreated',
  DateSubmitted = 'dateSubmitted',
  DiscountAmount = 'discountAmount',
  DiscountType = 'discountType',
  DiscountValue = 'discountValue',
  Id = 'id',
  LastUpdated = 'lastUpdated',
  OrderNumber = 'orderNumber',
  ParentCartId = 'parentCartId',
  RemovedBy = 'removedBy',
  SavedCart = 'savedCart',
  SavedName = 'savedName',
  ShopifyCustomerId = 'shopifyCustomerId',
  ShopifyOrderId = 'shopifyOrderId',
  SubTotal = 'subTotal',
  SubmittedBy = 'submittedBy',
  TaxIncluded = 'taxIncluded',
  TaxRate = 'taxRate',
  TotalPrice = 'totalPrice',
  TotalTax = 'totalTax'
}

export type CartScalarWhereInput = {
  AND?: InputMaybe<Array<CartScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartScalarWhereInput>>;
  OR?: InputMaybe<Array<CartScalarWhereInput>>;
  abandoned?: InputMaybe<BoolFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerTillId?: InputMaybe<BigIntNullableFilter>;
  cartName?: InputMaybe<StringNullableFilter>;
  cartNotes?: InputMaybe<StringNullableFilter>;
  cartType?: InputMaybe<StringNullableFilter>;
  createdBy?: InputMaybe<BigIntNullableFilter>;
  dateCreated?: InputMaybe<DateTimeNullableFilter>;
  dateSubmitted?: InputMaybe<DateTimeNullableFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountType?: InputMaybe<StringNullableFilter>;
  discountValue?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdated?: InputMaybe<DateTimeNullableFilter>;
  orderNumber?: InputMaybe<StringNullableFilter>;
  parentCartId?: InputMaybe<BigIntNullableFilter>;
  removedBy?: InputMaybe<BigIntNullableFilter>;
  savedCart?: InputMaybe<BoolFilter>;
  savedName?: InputMaybe<StringNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  shopifyOrderId?: InputMaybe<BigIntNullableFilter>;
  subTotal?: InputMaybe<DecimalNullableFilter>;
  submittedBy?: InputMaybe<BigIntNullableFilter>;
  taxIncluded?: InputMaybe<BoolNullableFilter>;
  taxRate?: InputMaybe<FloatNullableFilter>;
  totalPrice?: InputMaybe<DecimalNullableFilter>;
  totalTax?: InputMaybe<DecimalNullableFilter>;
};

export type CartTax = {
  __typename?: 'CartTax';
  Cart?: Maybe<Cart>;
  cartId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  price?: Maybe<Scalars['Decimal']>;
  rate?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type CartTaxCreateManyCartInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['Decimal']>;
  rate?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CartTaxCreateManyCartInputEnvelope = {
  data: Array<CartTaxCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartTaxCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartTaxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartTaxCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartTaxCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartTaxCreateManyCartInputEnvelope>;
};

export type CartTaxCreateOrConnectWithoutCartInput = {
  create: CartTaxCreateWithoutCartInput;
  where: CartTaxWhereUniqueInput;
};

export type CartTaxCreateWithoutCartInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['Decimal']>;
  rate?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CartTaxDto = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['Decimal']>;
  rate?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CartTaxListRelationFilter = {
  every?: InputMaybe<CartTaxWhereInput>;
  none?: InputMaybe<CartTaxWhereInput>;
  some?: InputMaybe<CartTaxWhereInput>;
};

export type CartTaxOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartTaxOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  cartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum CartTaxScalarFieldEnum {
  CartId = 'cartId',
  Id = 'id',
  Price = 'price',
  Rate = 'rate',
  Title = 'title'
}

export type CartTaxScalarWhereInput = {
  AND?: InputMaybe<Array<CartTaxScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartTaxScalarWhereInput>>;
  OR?: InputMaybe<Array<CartTaxScalarWhereInput>>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  rate?: InputMaybe<FloatNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CartTaxUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartTaxUpdateManyWithWhereWithoutCartInput = {
  data: CartTaxUpdateManyMutationInput;
  where: CartTaxScalarWhereInput;
};

export type CartTaxUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartTaxWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartTaxCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartTaxCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartTaxCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartTaxWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartTaxScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartTaxWhereUniqueInput>>;
  set?: InputMaybe<Array<CartTaxWhereUniqueInput>>;
  update?: InputMaybe<Array<CartTaxUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartTaxUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartTaxUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartTaxUpdateWithWhereUniqueWithoutCartInput = {
  data: CartTaxUpdateWithoutCartInput;
  where: CartTaxWhereUniqueInput;
};

export type CartTaxUpdateWithoutCartInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  rate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartTaxUpsertWithWhereUniqueWithoutCartInput = {
  create: CartTaxCreateWithoutCartInput;
  update: CartTaxUpdateWithoutCartInput;
  where: CartTaxWhereUniqueInput;
};

export type CartTaxWhereInput = {
  AND?: InputMaybe<Array<CartTaxWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<CartTaxWhereInput>>;
  OR?: InputMaybe<Array<CartTaxWhereInput>>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<DecimalNullableFilter>;
  rate?: InputMaybe<FloatNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type CartTaxWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartTender = {
  __typename?: 'CartTender';
  Cart: Cart;
  amount?: Maybe<Scalars['Decimal']>;
  cartId: Scalars['BigInt'];
  id: Scalars['BigInt'];
  type?: Maybe<Scalars['String']>;
};

export type CartTenderCreateManyCartInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CartTenderCreateManyCartInputEnvelope = {
  data: Array<CartTenderCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CartTenderCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<CartTenderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartTenderCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartTenderCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartTenderCreateManyCartInputEnvelope>;
};

export type CartTenderCreateOrConnectWithoutCartInput = {
  create: CartTenderCreateWithoutCartInput;
  where: CartTenderWhereUniqueInput;
};

export type CartTenderCreateWithoutCartInput = {
  amount?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CartTenderDto = {
  amount?: InputMaybe<Scalars['Decimal']>;
  cartId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CartTenderListRelationFilter = {
  every?: InputMaybe<CartTenderWhereInput>;
  none?: InputMaybe<CartTenderWhereInput>;
  some?: InputMaybe<CartTenderWhereInput>;
};

export type CartTenderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartTenderOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  amount?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum CartTenderScalarFieldEnum {
  Amount = 'amount',
  CartId = 'cartId',
  Id = 'id',
  Type = 'type'
}

export type CartTenderScalarWhereInput = {
  AND?: InputMaybe<Array<CartTenderScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartTenderScalarWhereInput>>;
  OR?: InputMaybe<Array<CartTenderScalarWhereInput>>;
  amount?: InputMaybe<DecimalNullableFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type CartTenderUpdateManyMutationInput = {
  amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartTenderUpdateManyWithWhereWithoutCartInput = {
  data: CartTenderUpdateManyMutationInput;
  where: CartTenderScalarWhereInput;
};

export type CartTenderUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartTenderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartTenderCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartTenderCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartTenderCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartTenderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartTenderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartTenderWhereUniqueInput>>;
  set?: InputMaybe<Array<CartTenderWhereUniqueInput>>;
  update?: InputMaybe<Array<CartTenderUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartTenderUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartTenderUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartTenderUpdateWithWhereUniqueWithoutCartInput = {
  data: CartTenderUpdateWithoutCartInput;
  where: CartTenderWhereUniqueInput;
};

export type CartTenderUpdateWithoutCartInput = {
  amount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CartTenderUpsertWithWhereUniqueWithoutCartInput = {
  create: CartTenderCreateWithoutCartInput;
  update: CartTenderUpdateWithoutCartInput;
  where: CartTenderWhereUniqueInput;
};

export type CartTenderWhereInput = {
  AND?: InputMaybe<Array<CartTenderWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<CartTenderWhereInput>>;
  OR?: InputMaybe<Array<CartTenderWhereInput>>;
  amount?: InputMaybe<DecimalNullableFilter>;
  cartId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type CartTenderWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CartUpdateManyMutationInput = {
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithWhereWithoutCartInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithWhereWithoutShopifyCustomerInput = {
  data: CartUpdateManyMutationInput;
  where: CartScalarWhereInput;
};

export type CartUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_CreatedByInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput>>;
};

export type CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_RemovedByInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput>>;
};

export type CartUpdateManyWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  create?: InputMaybe<Array<CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  createMany?: InputMaybe<CartCreateManyBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput>>;
};

export type CartUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<CartCreateWithoutCartInput>>;
  createMany?: InputMaybe<CartCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutCartInput>>;
};

export type CartUpdateManyWithoutShopifyCustomerNestedInput = {
  connect?: InputMaybe<Array<CartWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<CartCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<CartCreateManyShopifyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<CartWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartWhereUniqueInput>>;
  set?: InputMaybe<Array<CartWhereUniqueInput>>;
  update?: InputMaybe<Array<CartUpdateWithWhereUniqueWithoutShopifyCustomerInput>>;
  updateMany?: InputMaybe<Array<CartUpdateManyWithWhereWithoutShopifyCustomerInput>>;
  upsert?: InputMaybe<Array<CartUpsertWithWhereUniqueWithoutShopifyCustomerInput>>;
};

export type CartUpdateOneRequiredWithoutCartItemNestedInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<CartCreateWithoutCartItemInput>;
  update?: InputMaybe<CartUpdateWithoutCartItemInput>;
  upsert?: InputMaybe<CartUpsertWithoutCartItemInput>;
};

export type CartUpdateOneWithoutCartItemInventoryAdjustmentNestedInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutCartItemInventoryAdjustmentInput>;
  create?: InputMaybe<CartCreateWithoutCartItemInventoryAdjustmentInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CartUpdateWithoutCartItemInventoryAdjustmentInput>;
  upsert?: InputMaybe<CartUpsertWithoutCartItemInventoryAdjustmentInput>;
};

export type CartUpdateOneWithoutOther_CartNestedInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutOther_CartInput>;
  create?: InputMaybe<CartCreateWithoutOther_CartInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CartUpdateWithoutOther_CartInput>;
  upsert?: InputMaybe<CartUpsertWithoutOther_CartInput>;
};

export type CartUpdateOneWithoutProductsToProcessNestedInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutProductsToProcessInput>;
  create?: InputMaybe<CartCreateWithoutProductsToProcessInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CartUpdateWithoutProductsToProcessInput>;
  upsert?: InputMaybe<CartUpsertWithoutProductsToProcessInput>;
};

export type CartUpdateOneWithoutStoreCreditHistoryNestedInput = {
  connect?: InputMaybe<CartWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CartCreateOrConnectWithoutStoreCreditHistoryInput>;
  create?: InputMaybe<CartCreateWithoutStoreCreditHistoryInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CartUpdateWithoutStoreCreditHistoryInput>;
  upsert?: InputMaybe<CartUpsertWithoutStoreCreditHistoryInput>;
};

export type CartUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: CartUpdateWithoutBinderCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  data: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  data: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  data: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithWhereUniqueWithoutCartInput = {
  data: CartUpdateWithoutCartInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithWhereUniqueWithoutShopifyCustomerInput = {
  data: CartUpdateWithoutShopifyCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartUpdateWithoutBinderCustomerInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutCartInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutCartItemInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutCartItemInventoryAdjustmentInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutOther_CartInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutProductsToProcessInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutShopifyCustomerInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpdateWithoutStoreCreditHistoryInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutCartNestedInput>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillUpdateOneWithoutCartNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_CreatedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_RemovedByNestedInput>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserUpdateOneWithoutCart_BinderCustomerUserToCart_SubmittedByNestedInput>;
  Cart?: InputMaybe<CartUpdateOneWithoutOther_CartNestedInput>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentUpdateManyWithoutCartNestedInput>;
  CartItem?: InputMaybe<CartItemUpdateManyWithoutCartNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutCartNestedInput>;
  CartTax?: InputMaybe<CartTaxUpdateManyWithoutCartNestedInput>;
  CartTender?: InputMaybe<CartTenderUpdateManyWithoutCartNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutCartNestedInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutCartNestedInput>;
  abandoned?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cartName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cartType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateCreated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  discountType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountValue?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  orderNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  other_Cart?: InputMaybe<CartUpdateManyWithoutCartNestedInput>;
  savedCart?: InputMaybe<BoolFieldUpdateOperationsInput>;
  savedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  subTotal?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  taxIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  taxRate?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  totalPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  totalTax?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: CartCreateWithoutBinderCustomerInput;
  update: CartUpdateWithoutBinderCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput;
  update: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_CreatedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput;
  update: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_RemovedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithWhereUniqueWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput = {
  create: CartCreateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput;
  update: CartUpdateWithoutBinderCustomerUser_BinderCustomerUserToCart_SubmittedByInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithWhereUniqueWithoutCartInput = {
  create: CartCreateWithoutCartInput;
  update: CartUpdateWithoutCartInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithWhereUniqueWithoutShopifyCustomerInput = {
  create: CartCreateWithoutShopifyCustomerInput;
  update: CartUpdateWithoutShopifyCustomerInput;
  where: CartWhereUniqueInput;
};

export type CartUpsertWithoutCartItemInput = {
  create: CartCreateWithoutCartItemInput;
  update: CartUpdateWithoutCartItemInput;
};

export type CartUpsertWithoutCartItemInventoryAdjustmentInput = {
  create: CartCreateWithoutCartItemInventoryAdjustmentInput;
  update: CartUpdateWithoutCartItemInventoryAdjustmentInput;
};

export type CartUpsertWithoutOther_CartInput = {
  create: CartCreateWithoutOther_CartInput;
  update: CartUpdateWithoutOther_CartInput;
};

export type CartUpsertWithoutProductsToProcessInput = {
  create: CartCreateWithoutProductsToProcessInput;
  update: CartUpdateWithoutProductsToProcessInput;
};

export type CartUpsertWithoutStoreCreditHistoryInput = {
  create: CartCreateWithoutStoreCreditHistoryInput;
  update: CartUpdateWithoutStoreCreditHistoryInput;
};

export type CartWhereInput = {
  AND?: InputMaybe<Array<CartWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillRelationFilter>;
  BinderCustomerUser_BinderCustomerUserToCart_createdBy?: InputMaybe<BinderCustomerUserRelationFilter>;
  BinderCustomerUser_BinderCustomerUserToCart_removedBy?: InputMaybe<BinderCustomerUserRelationFilter>;
  BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: InputMaybe<BinderCustomerUserRelationFilter>;
  Cart?: InputMaybe<CartRelationFilter>;
  CartIntegratedPayment?: InputMaybe<CartIntegratedPaymentListRelationFilter>;
  CartItem?: InputMaybe<CartItemListRelationFilter>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentListRelationFilter>;
  CartTax?: InputMaybe<CartTaxListRelationFilter>;
  CartTender?: InputMaybe<CartTenderListRelationFilter>;
  NOT?: InputMaybe<Array<CartWhereInput>>;
  OR?: InputMaybe<Array<CartWhereInput>>;
  ProductsToProcess?: InputMaybe<ProductsToProcessListRelationFilter>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerRelationFilter>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryListRelationFilter>;
  abandoned?: InputMaybe<BoolFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerTillId?: InputMaybe<BigIntNullableFilter>;
  cartName?: InputMaybe<StringNullableFilter>;
  cartNotes?: InputMaybe<StringNullableFilter>;
  cartType?: InputMaybe<StringNullableFilter>;
  createdBy?: InputMaybe<BigIntNullableFilter>;
  dateCreated?: InputMaybe<DateTimeNullableFilter>;
  dateSubmitted?: InputMaybe<DateTimeNullableFilter>;
  discountAmount?: InputMaybe<DecimalNullableFilter>;
  discountType?: InputMaybe<StringNullableFilter>;
  discountValue?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdated?: InputMaybe<DateTimeNullableFilter>;
  orderNumber?: InputMaybe<StringNullableFilter>;
  other_Cart?: InputMaybe<CartListRelationFilter>;
  parentCartId?: InputMaybe<BigIntNullableFilter>;
  removedBy?: InputMaybe<BigIntNullableFilter>;
  savedCart?: InputMaybe<BoolFilter>;
  savedName?: InputMaybe<StringNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  shopifyOrderId?: InputMaybe<BigIntNullableFilter>;
  subTotal?: InputMaybe<DecimalNullableFilter>;
  submittedBy?: InputMaybe<BigIntNullableFilter>;
  taxIncluded?: InputMaybe<BoolNullableFilter>;
  taxRate?: InputMaybe<FloatNullableFilter>;
  totalPrice?: InputMaybe<DecimalNullableFilter>;
  totalTax?: InputMaybe<DecimalNullableFilter>;
};

export type CartWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CatalogFilter = {
  customerCatalogProductStatus?: InputMaybe<CustomerCatalogProductStatus>;
  printing?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  rarity?: InputMaybe<Scalars['String']>;
  releaseDate?: InputMaybe<Scalars['String']>;
  setName?: InputMaybe<Scalars['String']>;
};

export type CatalogItem = {
  __typename?: 'CatalogItem';
  id: Scalars['BigInt'];
  imageUrl: Scalars['String'];
  printings: Array<Scalars['String']>;
  rarity: Scalars['String'];
  setName: Scalars['String'];
  title: Scalars['String'];
};

export type CreateVariants = {
  barcode?: InputMaybe<Scalars['String']>;
  inventoryManagement?: InputMaybe<Scalars['String']>;
  position: Scalars['BigInt'];
  price: Scalars['String'];
  sku?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export type CustomerCatalogProductItem = {
  __typename?: 'CustomerCatalogProductItem';
  catalogItem: CatalogItem;
  customerCatalogProductStatus: Scalars['Float'];
  product: Product;
};

export type CustomerCatalogProductSearchResult = {
  __typename?: 'CustomerCatalogProductSearchResult';
  CatalogItems: Array<CustomerCatalogProductItem>;
  count: Scalars['BigInt'];
};

/** CustomerCatalogProductStatus */
export enum CustomerCatalogProductStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Processing = 'PROCESSING'
}

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']>;
  divide?: InputMaybe<Scalars['Decimal']>;
  increment?: InputMaybe<Scalars['Decimal']>;
  multiply?: InputMaybe<Scalars['Decimal']>;
  set?: InputMaybe<Scalars['Decimal']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type EnumReleaseTrainFieldUpdateOperationsInput = {
  set?: InputMaybe<ReleaseTrain>;
};

export type EnumReleaseTrainFilter = {
  equals?: InputMaybe<ReleaseTrain>;
  in?: InputMaybe<Array<ReleaseTrain>>;
  not?: InputMaybe<NestedEnumReleaseTrainFilter>;
  notIn?: InputMaybe<Array<ReleaseTrain>>;
};

export type EventAdditionalInfoListRelationFilter = {
  every?: InputMaybe<EventAdditionalInfoWhereInput>;
  none?: InputMaybe<EventAdditionalInfoWhereInput>;
  some?: InputMaybe<EventAdditionalInfoWhereInput>;
};

export type EventAdditionalInfoRelationFilter = {
  is?: InputMaybe<EventAdditionalInfoWhereInput>;
  isNot?: InputMaybe<EventAdditionalInfoWhereInput>;
};

export type EventAdditionalInfoWhereInput = {
  AND?: InputMaybe<Array<EventAdditionalInfoWhereInput>>;
  EventAdditionalInfo?: InputMaybe<EventAdditionalInfoRelationFilter>;
  EventParticipantAdditionalInfo?: InputMaybe<EventParticipantAdditionalInfoListRelationFilter>;
  NOT?: InputMaybe<Array<EventAdditionalInfoWhereInput>>;
  OR?: InputMaybe<Array<EventAdditionalInfoWhereInput>>;
  binderCustomerEventId?: InputMaybe<BigIntFilter>;
  header?: InputMaybe<StringFilter>;
  headerDescription?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  other_EventAdditionalInfo?: InputMaybe<EventAdditionalInfoListRelationFilter>;
  parentAdditionalInfoId?: InputMaybe<BigIntNullableFilter>;
};

export type EventParticipantAdditionalInfoListRelationFilter = {
  every?: InputMaybe<EventParticipantAdditionalInfoWhereInput>;
  none?: InputMaybe<EventParticipantAdditionalInfoWhereInput>;
  some?: InputMaybe<EventParticipantAdditionalInfoWhereInput>;
};

export type EventParticipantAdditionalInfoWhereInput = {
  AND?: InputMaybe<Array<EventParticipantAdditionalInfoWhereInput>>;
  BinderCustomerEventParticipants?: InputMaybe<BinderCustomerEventParticipantsRelationFilter>;
  EventAdditionalInfo?: InputMaybe<EventAdditionalInfoRelationFilter>;
  NOT?: InputMaybe<Array<EventParticipantAdditionalInfoWhereInput>>;
  OR?: InputMaybe<Array<EventParticipantAdditionalInfoWhereInput>>;
  eventAdditionalInfoId?: InputMaybe<BigIntFilter>;
  eventParticipantId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  value?: InputMaybe<StringFilter>;
};

export type FeatureSwitch = {
  __typename?: 'FeatureSwitch';
  id: Scalars['Int'];
  settingName: Scalars['String'];
  settingValue?: Maybe<Scalars['String']>;
};

export type FeatureSwitchOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  settingName?: InputMaybe<SortOrder>;
  settingValue?: InputMaybe<SortOrder>;
};

export enum FeatureSwitchScalarFieldEnum {
  Id = 'id',
  SettingName = 'settingName',
  SettingValue = 'settingValue'
}

export type FeatureSwitchWhereInput = {
  AND?: InputMaybe<Array<FeatureSwitchWhereInput>>;
  NOT?: InputMaybe<Array<FeatureSwitchWhereInput>>;
  OR?: InputMaybe<Array<FeatureSwitchWhereInput>>;
  id?: InputMaybe<IntFilter>;
  settingName?: InputMaybe<StringFilter>;
  settingValue?: InputMaybe<StringNullableFilter>;
};

export type FeatureSwitchWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type Images = {
  src: Scalars['String'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type JobQueue = {
  __typename?: 'JobQueue';
  ShopifyCustomerProductVariant?: Maybe<ShopifyCustomerProductVariant>;
  binderCustomerId?: Maybe<Scalars['String']>;
  binderCustomerUserId?: Maybe<Scalars['BigInt']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateInserted?: Maybe<Scalars['DateTime']>;
  dateProcessed?: Maybe<Scalars['DateTime']>;
  error?: Maybe<Scalars['String']>;
  fieldsUpdated?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  jobId: Scalars['BigInt'];
  jobUrl?: Maybe<Scalars['String']>;
  priceAfter?: Maybe<Scalars['Decimal']>;
  priceBefore?: Maybe<Scalars['Decimal']>;
  queue?: Maybe<Scalars['String']>;
  searchFilters?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  stockAfter?: Maybe<Scalars['Int']>;
  stockBefore?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  variantId?: Maybe<Scalars['BigInt']>;
};

export type JobQueueCreateManyShopifyCustomerProductVariantInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerUserId?: InputMaybe<Scalars['BigInt']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateInserted?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  fieldsUpdated?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  jobId: Scalars['BigInt'];
  jobUrl?: InputMaybe<Scalars['String']>;
  priceAfter?: InputMaybe<Scalars['Decimal']>;
  priceBefore?: InputMaybe<Scalars['Decimal']>;
  queue?: InputMaybe<Scalars['String']>;
  searchFilters?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stockAfter?: InputMaybe<Scalars['Int']>;
  stockBefore?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type JobQueueCreateManyShopifyCustomerProductVariantInputEnvelope = {
  data: Array<JobQueueCreateManyShopifyCustomerProductVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type JobQueueCreateNestedManyWithoutShopifyCustomerProductVariantInput = {
  connect?: InputMaybe<Array<JobQueueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JobQueueCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<JobQueueCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<JobQueueCreateManyShopifyCustomerProductVariantInputEnvelope>;
};

export type JobQueueCreateOrConnectWithoutShopifyCustomerProductVariantInput = {
  create: JobQueueCreateWithoutShopifyCustomerProductVariantInput;
  where: JobQueueWhereUniqueInput;
};

export type JobQueueCreateWithoutShopifyCustomerProductVariantInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  binderCustomerUserId?: InputMaybe<Scalars['BigInt']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateInserted?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  error?: InputMaybe<Scalars['String']>;
  fieldsUpdated?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  jobId: Scalars['BigInt'];
  jobUrl?: InputMaybe<Scalars['String']>;
  priceAfter?: InputMaybe<Scalars['Decimal']>;
  priceBefore?: InputMaybe<Scalars['Decimal']>;
  queue?: InputMaybe<Scalars['String']>;
  searchFilters?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  stockAfter?: InputMaybe<Scalars['Int']>;
  stockBefore?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type JobQueueListRelationFilter = {
  every?: InputMaybe<JobQueueWhereInput>;
  none?: InputMaybe<JobQueueWhereInput>;
  some?: InputMaybe<JobQueueWhereInput>;
};

export type JobQueueOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type JobQueueOrderByWithRelationInput = {
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantOrderByWithRelationInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  binderCustomerUserId?: InputMaybe<SortOrder>;
  dateCompleted?: InputMaybe<SortOrder>;
  dateInserted?: InputMaybe<SortOrder>;
  dateProcessed?: InputMaybe<SortOrder>;
  error?: InputMaybe<SortOrder>;
  fieldsUpdated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jobId?: InputMaybe<SortOrder>;
  jobUrl?: InputMaybe<SortOrder>;
  priceAfter?: InputMaybe<SortOrder>;
  priceBefore?: InputMaybe<SortOrder>;
  queue?: InputMaybe<SortOrder>;
  searchFilters?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  stockAfter?: InputMaybe<SortOrder>;
  stockBefore?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
};

export enum JobQueueScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  BinderCustomerUserId = 'binderCustomerUserId',
  DateCompleted = 'dateCompleted',
  DateInserted = 'dateInserted',
  DateProcessed = 'dateProcessed',
  Error = 'error',
  FieldsUpdated = 'fieldsUpdated',
  Id = 'id',
  JobId = 'jobId',
  JobUrl = 'jobUrl',
  PriceAfter = 'priceAfter',
  PriceBefore = 'priceBefore',
  Queue = 'queue',
  SearchFilters = 'searchFilters',
  Status = 'status',
  StockAfter = 'stockAfter',
  StockBefore = 'stockBefore',
  Type = 'type',
  VariantId = 'variantId'
}

export type JobQueueScalarWhereInput = {
  AND?: InputMaybe<Array<JobQueueScalarWhereInput>>;
  NOT?: InputMaybe<Array<JobQueueScalarWhereInput>>;
  OR?: InputMaybe<Array<JobQueueScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerUserId?: InputMaybe<BigIntNullableFilter>;
  dateCompleted?: InputMaybe<DateTimeNullableFilter>;
  dateInserted?: InputMaybe<DateTimeNullableFilter>;
  dateProcessed?: InputMaybe<DateTimeNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  fieldsUpdated?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  jobId?: InputMaybe<BigIntFilter>;
  jobUrl?: InputMaybe<StringNullableFilter>;
  priceAfter?: InputMaybe<DecimalNullableFilter>;
  priceBefore?: InputMaybe<DecimalNullableFilter>;
  queue?: InputMaybe<StringNullableFilter>;
  searchFilters?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  stockAfter?: InputMaybe<IntNullableFilter>;
  stockBefore?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type JobQueueUpdateManyMutationInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  binderCustomerUserId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateInserted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateProcessed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fieldsUpdated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  jobId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  jobUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceAfter?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  priceBefore?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  queue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchFilters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stockAfter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockBefore?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type JobQueueUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput = {
  data: JobQueueUpdateManyMutationInput;
  where: JobQueueScalarWhereInput;
};

export type JobQueueUpdateManyWithoutShopifyCustomerProductVariantNestedInput = {
  connect?: InputMaybe<Array<JobQueueWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<JobQueueCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<JobQueueCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<JobQueueCreateManyShopifyCustomerProductVariantInputEnvelope>;
  delete?: InputMaybe<Array<JobQueueWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<JobQueueScalarWhereInput>>;
  disconnect?: InputMaybe<Array<JobQueueWhereUniqueInput>>;
  set?: InputMaybe<Array<JobQueueWhereUniqueInput>>;
  update?: InputMaybe<Array<JobQueueUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
  updateMany?: InputMaybe<Array<JobQueueUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput>>;
  upsert?: InputMaybe<Array<JobQueueUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
};

export type JobQueueUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  data: JobQueueUpdateWithoutShopifyCustomerProductVariantInput;
  where: JobQueueWhereUniqueInput;
};

export type JobQueueUpdateWithoutShopifyCustomerProductVariantInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  binderCustomerUserId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateInserted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateProcessed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fieldsUpdated?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  jobId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  jobUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceAfter?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  priceBefore?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  queue?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  searchFilters?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stockAfter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockBefore?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type JobQueueUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  create: JobQueueCreateWithoutShopifyCustomerProductVariantInput;
  update: JobQueueUpdateWithoutShopifyCustomerProductVariantInput;
  where: JobQueueWhereUniqueInput;
};

export type JobQueueWhereInput = {
  AND?: InputMaybe<Array<JobQueueWhereInput>>;
  NOT?: InputMaybe<Array<JobQueueWhereInput>>;
  OR?: InputMaybe<Array<JobQueueWhereInput>>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantRelationFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerUserId?: InputMaybe<BigIntNullableFilter>;
  dateCompleted?: InputMaybe<DateTimeNullableFilter>;
  dateInserted?: InputMaybe<DateTimeNullableFilter>;
  dateProcessed?: InputMaybe<DateTimeNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  fieldsUpdated?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  jobId?: InputMaybe<BigIntFilter>;
  jobUrl?: InputMaybe<StringNullableFilter>;
  priceAfter?: InputMaybe<DecimalNullableFilter>;
  priceBefore?: InputMaybe<DecimalNullableFilter>;
  queue?: InputMaybe<StringNullableFilter>;
  searchFilters?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
  stockAfter?: InputMaybe<IntNullableFilter>;
  stockBefore?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type JobQueueWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type LineItemProperty = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  CreateBinderCustomerShopifyTheme: BinderCustomerShopifyTheme;
  CreateProduct?: Maybe<Product>;
  CreateShopifyThemeRelease: ShopifyThemeRelease;
  CreateVariant: Product;
  DeleteCart_by_pk?: Maybe<Cart>;
  KeepCartActive?: Maybe<Cart>;
  ReturnCart?: Maybe<Cart>;
  SaveCart?: Maybe<Cart>;
  SubmitCart?: Maybe<Cart>;
  UpdateBinderCustomerShopifyTheme: BinderCustomerShopifyTheme;
  UpdateCart?: Maybe<Cart>;
  UpdateProduct?: Maybe<Product>;
  UpdateVariant: Product;
};


export type MutationCreateBinderCustomerShopifyThemeArgs = {
  data: BinderCustomerShopifyThemeCreateInput;
};


export type MutationCreateProductArgs = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['Float']>;
  images?: InputMaybe<Array<Images>>;
  productType?: InputMaybe<Scalars['String']>;
  published: Scalars['Boolean'];
  tags?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  variants: Array<CreateVariants>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type MutationCreateShopifyThemeReleaseArgs = {
  data: ShopifyThemeReleaseCreateInput;
};


export type MutationCreateVariantArgs = {
  productId: Scalars['BigInt'];
  variant: CreateVariants;
};


export type MutationDeleteCart_By_PkArgs = {
  id: Scalars['Float'];
  removeStock: Scalars['Boolean'];
};


export type MutationKeepCartActiveArgs = {
  id: Scalars['Float'];
};


export type MutationReturnCartArgs = {
  id: Scalars['Float'];
};


export type MutationSaveCartArgs = {
  id: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationSubmitCartArgs = {
  data: UpdateCartDto;
  submit: Scalars['Boolean'];
};


export type MutationUpdateBinderCustomerShopifyThemeArgs = {
  data: BinderCustomerShopifyThemeUpdateInput;
  theme: Scalars['String'];
};


export type MutationUpdateCartArgs = {
  data: UpdateCartDto;
};


export type MutationUpdateProductArgs = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['Float']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['BigInt'];
  images?: InputMaybe<Array<Images>>;
  productType?: InputMaybe<Scalars['String']>;
  published?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<UpdateVariants>>;
  vendor?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateVariantArgs = {
  variant: UpdateVariants;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']>;
  gt?: InputMaybe<Scalars['BigInt']>;
  gte?: InputMaybe<Scalars['BigInt']>;
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  lt?: InputMaybe<Scalars['BigInt']>;
  lte?: InputMaybe<Scalars['BigInt']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedEnumReleaseTrainFilter = {
  equals?: InputMaybe<ReleaseTrain>;
  in?: InputMaybe<Array<ReleaseTrain>>;
  not?: InputMaybe<NestedEnumReleaseTrainFilter>;
  notIn?: InputMaybe<Array<ReleaseTrain>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableBigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']>;
  divide?: InputMaybe<Scalars['BigInt']>;
  increment?: InputMaybe<Scalars['BigInt']>;
  multiply?: InputMaybe<Scalars['BigInt']>;
  set?: InputMaybe<Scalars['BigInt']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableDecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']>;
  divide?: InputMaybe<Scalars['Decimal']>;
  increment?: InputMaybe<Scalars['Decimal']>;
  multiply?: InputMaybe<Scalars['Decimal']>;
  set?: InputMaybe<Scalars['Decimal']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type PosFloat = {
  __typename?: 'POSFloat';
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  POSFloatType: Array<PosFloatType>;
  _count?: Maybe<PosFloatCount>;
  binderCustomerId?: Maybe<Scalars['String']>;
  binderCustomerTill?: Maybe<Scalars['BigInt']>;
  closedDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['BigInt'];
  openedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
};


export type PosFloatPosFloatTypeArgs = {
  cursor?: InputMaybe<PosFloatTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PosFloatTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatTypeWhereInput>;
};

export type PosFloatCount = {
  __typename?: 'POSFloatCount';
  POSFloatType: Scalars['Int'];
};

export type PosFloatCreateManyBinderCustomerTillInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  closedDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  openedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PosFloatCreateManyBinderCustomerTillInputEnvelope = {
  data: Array<PosFloatCreateManyBinderCustomerTillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PosFloatCreateNestedManyWithoutBinderCustomerTillInput = {
  connect?: InputMaybe<Array<PosFloatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PosFloatCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<PosFloatCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<PosFloatCreateManyBinderCustomerTillInputEnvelope>;
};

export type PosFloatCreateOrConnectWithoutBinderCustomerTillInput = {
  create: PosFloatCreateWithoutBinderCustomerTillInput;
  where: PosFloatWhereUniqueInput;
};

export type PosFloatCreateWithoutBinderCustomerTillInput = {
  POSFloatType?: InputMaybe<PosFloatTypeCreateNestedManyWithoutPosFloatInput>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  closedDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  openedDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};

export type PosFloatListRelationFilter = {
  every?: InputMaybe<PosFloatWhereInput>;
  none?: InputMaybe<PosFloatWhereInput>;
  some?: InputMaybe<PosFloatWhereInput>;
};

export type PosFloatOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PosFloatOrderByWithRelationInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillOrderByWithRelationInput>;
  POSFloatType?: InputMaybe<PosFloatTypeOrderByRelationAggregateInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  binderCustomerTill?: InputMaybe<SortOrder>;
  closedDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  openedDate?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PosFloatRelationFilter = {
  is?: InputMaybe<PosFloatWhereInput>;
  isNot?: InputMaybe<PosFloatWhereInput>;
};

export enum PosFloatScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  BinderCustomerTill = 'binderCustomerTill',
  ClosedDate = 'closedDate',
  Id = 'id',
  OpenedDate = 'openedDate',
  Status = 'status'
}

export type PosFloatScalarWhereInput = {
  AND?: InputMaybe<Array<PosFloatScalarWhereInput>>;
  NOT?: InputMaybe<Array<PosFloatScalarWhereInput>>;
  OR?: InputMaybe<Array<PosFloatScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerTill?: InputMaybe<BigIntNullableFilter>;
  closedDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  openedDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
};

export type PosFloatType = {
  __typename?: 'POSFloatType';
  POSFloat: PosFloat;
  closingAmount?: Maybe<Scalars['Decimal']>;
  currentAmount?: Maybe<Scalars['Decimal']>;
  id: Scalars['BigInt'];
  name?: Maybe<Scalars['String']>;
  openingAmount?: Maybe<Scalars['Decimal']>;
  posFloatId: Scalars['BigInt'];
};

export type PosFloatTypeCreateManyPosFloatInput = {
  closingAmount?: InputMaybe<Scalars['Decimal']>;
  currentAmount?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  openingAmount?: InputMaybe<Scalars['Decimal']>;
};

export type PosFloatTypeCreateManyPosFloatInputEnvelope = {
  data: Array<PosFloatTypeCreateManyPosFloatInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PosFloatTypeCreateNestedManyWithoutPosFloatInput = {
  connect?: InputMaybe<Array<PosFloatTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PosFloatTypeCreateOrConnectWithoutPosFloatInput>>;
  create?: InputMaybe<Array<PosFloatTypeCreateWithoutPosFloatInput>>;
  createMany?: InputMaybe<PosFloatTypeCreateManyPosFloatInputEnvelope>;
};

export type PosFloatTypeCreateOrConnectWithoutPosFloatInput = {
  create: PosFloatTypeCreateWithoutPosFloatInput;
  where: PosFloatTypeWhereUniqueInput;
};

export type PosFloatTypeCreateWithoutPosFloatInput = {
  closingAmount?: InputMaybe<Scalars['Decimal']>;
  currentAmount?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  openingAmount?: InputMaybe<Scalars['Decimal']>;
};

export type PosFloatTypeListRelationFilter = {
  every?: InputMaybe<PosFloatTypeWhereInput>;
  none?: InputMaybe<PosFloatTypeWhereInput>;
  some?: InputMaybe<PosFloatTypeWhereInput>;
};

export type PosFloatTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PosFloatTypeOrderByWithRelationInput = {
  POSFloat?: InputMaybe<PosFloatOrderByWithRelationInput>;
  closingAmount?: InputMaybe<SortOrder>;
  currentAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  openingAmount?: InputMaybe<SortOrder>;
  posFloatId?: InputMaybe<SortOrder>;
};

export enum PosFloatTypeScalarFieldEnum {
  ClosingAmount = 'closingAmount',
  CurrentAmount = 'currentAmount',
  Id = 'id',
  Name = 'name',
  OpeningAmount = 'openingAmount',
  PosFloatId = 'posFloatId'
}

export type PosFloatTypeScalarWhereInput = {
  AND?: InputMaybe<Array<PosFloatTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<PosFloatTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<PosFloatTypeScalarWhereInput>>;
  closingAmount?: InputMaybe<DecimalNullableFilter>;
  currentAmount?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringNullableFilter>;
  openingAmount?: InputMaybe<DecimalNullableFilter>;
  posFloatId?: InputMaybe<BigIntFilter>;
};

export type PosFloatTypeUpdateManyMutationInput = {
  closingAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  currentAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PosFloatTypeUpdateManyWithWhereWithoutPosFloatInput = {
  data: PosFloatTypeUpdateManyMutationInput;
  where: PosFloatTypeScalarWhereInput;
};

export type PosFloatTypeUpdateManyWithoutPosFloatNestedInput = {
  connect?: InputMaybe<Array<PosFloatTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PosFloatTypeCreateOrConnectWithoutPosFloatInput>>;
  create?: InputMaybe<Array<PosFloatTypeCreateWithoutPosFloatInput>>;
  createMany?: InputMaybe<PosFloatTypeCreateManyPosFloatInputEnvelope>;
  delete?: InputMaybe<Array<PosFloatTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PosFloatTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PosFloatTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PosFloatTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PosFloatTypeUpdateWithWhereUniqueWithoutPosFloatInput>>;
  updateMany?: InputMaybe<Array<PosFloatTypeUpdateManyWithWhereWithoutPosFloatInput>>;
  upsert?: InputMaybe<Array<PosFloatTypeUpsertWithWhereUniqueWithoutPosFloatInput>>;
};

export type PosFloatTypeUpdateWithWhereUniqueWithoutPosFloatInput = {
  data: PosFloatTypeUpdateWithoutPosFloatInput;
  where: PosFloatTypeWhereUniqueInput;
};

export type PosFloatTypeUpdateWithoutPosFloatInput = {
  closingAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  currentAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openingAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type PosFloatTypeUpsertWithWhereUniqueWithoutPosFloatInput = {
  create: PosFloatTypeCreateWithoutPosFloatInput;
  update: PosFloatTypeUpdateWithoutPosFloatInput;
  where: PosFloatTypeWhereUniqueInput;
};

export type PosFloatTypeWhereInput = {
  AND?: InputMaybe<Array<PosFloatTypeWhereInput>>;
  NOT?: InputMaybe<Array<PosFloatTypeWhereInput>>;
  OR?: InputMaybe<Array<PosFloatTypeWhereInput>>;
  POSFloat?: InputMaybe<PosFloatRelationFilter>;
  closingAmount?: InputMaybe<DecimalNullableFilter>;
  currentAmount?: InputMaybe<DecimalNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<StringNullableFilter>;
  openingAmount?: InputMaybe<DecimalNullableFilter>;
  posFloatId?: InputMaybe<BigIntFilter>;
};

export type PosFloatTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type PosFloatUpdateManyMutationInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  openedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PosFloatUpdateManyWithWhereWithoutBinderCustomerTillInput = {
  data: PosFloatUpdateManyMutationInput;
  where: PosFloatScalarWhereInput;
};

export type PosFloatUpdateManyWithoutBinderCustomerTillNestedInput = {
  connect?: InputMaybe<Array<PosFloatWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PosFloatCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<PosFloatCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<PosFloatCreateManyBinderCustomerTillInputEnvelope>;
  delete?: InputMaybe<Array<PosFloatWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PosFloatScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PosFloatWhereUniqueInput>>;
  set?: InputMaybe<Array<PosFloatWhereUniqueInput>>;
  update?: InputMaybe<Array<PosFloatUpdateWithWhereUniqueWithoutBinderCustomerTillInput>>;
  updateMany?: InputMaybe<Array<PosFloatUpdateManyWithWhereWithoutBinderCustomerTillInput>>;
  upsert?: InputMaybe<Array<PosFloatUpsertWithWhereUniqueWithoutBinderCustomerTillInput>>;
};

export type PosFloatUpdateWithWhereUniqueWithoutBinderCustomerTillInput = {
  data: PosFloatUpdateWithoutBinderCustomerTillInput;
  where: PosFloatWhereUniqueInput;
};

export type PosFloatUpdateWithoutBinderCustomerTillInput = {
  POSFloatType?: InputMaybe<PosFloatTypeUpdateManyWithoutPosFloatNestedInput>;
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  closedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  openedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PosFloatUpsertWithWhereUniqueWithoutBinderCustomerTillInput = {
  create: PosFloatCreateWithoutBinderCustomerTillInput;
  update: PosFloatUpdateWithoutBinderCustomerTillInput;
  where: PosFloatWhereUniqueInput;
};

export type PosFloatWhereInput = {
  AND?: InputMaybe<Array<PosFloatWhereInput>>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillRelationFilter>;
  NOT?: InputMaybe<Array<PosFloatWhereInput>>;
  OR?: InputMaybe<Array<PosFloatWhereInput>>;
  POSFloatType?: InputMaybe<PosFloatTypeListRelationFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  binderCustomerTill?: InputMaybe<BigIntNullableFilter>;
  closedDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  openedDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringNullableFilter>;
};

export type PosFloatWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type PosPaymentTypes = {
  __typename?: 'POSPaymentTypes';
  binderCustomerId?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  paymentType?: Maybe<Scalars['String']>;
};

export type PosPaymentTypesOrderByWithRelationInput = {
  binderCustomerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
};

export enum PosPaymentTypesScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  Id = 'id',
  PaymentType = 'paymentType'
}

export type PosPaymentTypesUKfp4golnwo1bi47091bvx16s1dCompoundUniqueInput = {
  binderCustomerId: Scalars['String'];
  paymentType: Scalars['String'];
};

export type PosPaymentTypesWhereInput = {
  AND?: InputMaybe<Array<PosPaymentTypesWhereInput>>;
  NOT?: InputMaybe<Array<PosPaymentTypesWhereInput>>;
  OR?: InputMaybe<Array<PosPaymentTypesWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  paymentType?: InputMaybe<StringNullableFilter>;
};

export type PosPaymentTypesWhereUniqueInput = {
  UKfp4golnwo1bi47091bvx16s1d?: InputMaybe<PosPaymentTypesUKfp4golnwo1bi47091bvx16s1dCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Product = {
  __typename?: 'Product';
  ProductDescription?: Maybe<ProductDescription>;
  ProductImage: Array<ProductImage>;
  ProductTag: Array<ProductTag>;
  ProductVariant: Array<ProductVariant>;
  customerId?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  productType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};


export type ProductProductImageArgs = {
  cursor?: InputMaybe<ProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductImageWhereInput>;
};


export type ProductProductTagArgs = {
  cursor?: InputMaybe<ProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductTagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductTagWhereInput>;
};


export type ProductProductVariantArgs = {
  cursor?: InputMaybe<ProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductVariantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductDescription = {
  __typename?: 'ProductDescription';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  descriptionHtml?: Maybe<Scalars['String']>;
  productId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductImage = {
  __typename?: 'ProductImage';
  Product?: Maybe<Product>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['BigInt'];
  imageUrl?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  variantIds?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ProductImageListRelationFilter = {
  every?: InputMaybe<ProductImageWhereInput>;
  none?: InputMaybe<ProductImageWhereInput>;
  some?: InputMaybe<ProductImageWhereInput>;
};

export type ProductImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductImageOrderByWithRelationInput = {
  Product?: InputMaybe<ProductOrderByWithRelationInput>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  shopifyId?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export enum ProductImageScalarFieldEnum {
  Height = 'height',
  Id = 'id',
  Position = 'position',
  ProductId = 'productId',
  ShopifyId = 'shopifyId',
  Src = 'src',
  Width = 'width'
}

export type ProductImageWhereInput = {
  AND?: InputMaybe<Array<ProductImageWhereInput>>;
  NOT?: InputMaybe<Array<ProductImageWhereInput>>;
  OR?: InputMaybe<Array<ProductImageWhereInput>>;
  Product?: InputMaybe<ProductRelationFilter>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  position?: InputMaybe<IntNullableFilter>;
  productId?: InputMaybe<BigIntNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  src?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<IntNullableFilter>;
};

export type ProductImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ProductOrderByWithRelationInput = {
  ProductImage?: InputMaybe<ProductImageOrderByRelationAggregateInput>;
  ProductTag?: InputMaybe<ProductTagOrderByRelationAggregateInput>;
  ProductVariant?: InputMaybe<ProductVariantOrderByRelationAggregateInput>;
  archived?: InputMaybe<SortOrder>;
  bodyHtml?: InputMaybe<SortOrder>;
  cardId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  handle?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<SortOrder>;
  metaFieldsGlobalTitleTag?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  templateSuffix?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export enum ProductScalarFieldEnum {
  Archived = 'archived',
  BodyHtml = 'bodyHtml',
  CardId = 'cardId',
  CustomerId = 'customerId',
  Handle = 'handle',
  Id = 'id',
  MetaFieldsGlobalDescriptionTag = 'metaFieldsGlobalDescriptionTag',
  MetaFieldsGlobalTitleTag = 'metaFieldsGlobalTitleTag',
  ProductId = 'productId',
  ProductType = 'productType',
  Tags = 'tags',
  TemplateSuffix = 'templateSuffix',
  Title = 'title',
  TotalQuantity = 'totalQuantity',
  Type = 'type',
  Vendor = 'vendor'
}

export type ProductTag = {
  __typename?: 'ProductTag';
  Product?: Maybe<Product>;
  id: Scalars['BigInt'];
  tag?: Maybe<Scalars['String']>;
};

export type ProductTagListRelationFilter = {
  every?: InputMaybe<ProductTagWhereInput>;
  none?: InputMaybe<ProductTagWhereInput>;
  some?: InputMaybe<ProductTagWhereInput>;
};

export type ProductTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductTagOrderByWithRelationInput = {
  Product?: InputMaybe<ProductOrderByWithRelationInput>;
  ProductId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tag?: InputMaybe<SortOrder>;
};

export enum ProductTagScalarFieldEnum {
  Id = 'id',
  ShopifyCustomerProductId = 'shopifyCustomerProductId',
  Tag = 'tag'
}

export type ProductTagWhereInput = {
  AND?: InputMaybe<Array<ProductTagWhereInput>>;
  NOT?: InputMaybe<Array<ProductTagWhereInput>>;
  OR?: InputMaybe<Array<ProductTagWhereInput>>;
  Product?: InputMaybe<ProductRelationFilter>;
  ProductId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  tag?: InputMaybe<StringNullableFilter>;
};

export type ProductTagWhereUniqueInput = {
  UKaq2w15uah8mj9dsjtbrr2kbp1?: InputMaybe<ShopifyCustomerProductTagUKaq2w15uah8mj9dsjtbrr2kbp1CompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  Product?: Maybe<Product>;
  archived?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  position?: Maybe<Scalars['BigInt']>;
  price?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};

export type ProductVariantListRelationFilter = {
  every?: InputMaybe<ProductVariantWhereInput>;
  none?: InputMaybe<ProductVariantWhereInput>;
  some?: InputMaybe<ProductVariantWhereInput>;
};

export type ProductVariantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductVariantOrderByWithRelationInput = {
  CartItem?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  archived?: InputMaybe<SortOrder>;
  barcode?: InputMaybe<SortOrder>;
  buyPrice?: InputMaybe<SortOrder>;
  buyPricePercent?: InputMaybe<SortOrder>;
  compareAtPrice?: InputMaybe<SortOrder>;
  customerProductId?: InputMaybe<SortOrder>;
  fulfillmentService?: InputMaybe<SortOrder>;
  grams?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inventoryItemId?: InputMaybe<SortOrder>;
  inventoryManagement?: InputMaybe<SortOrder>;
  inventoryPolicy?: InputMaybe<SortOrder>;
  inventoryQuantity?: InputMaybe<SortOrder>;
  maxInstock?: InputMaybe<SortOrder>;
  maxInstockBuyPercent?: InputMaybe<SortOrder>;
  maxInstockBuyPrice?: InputMaybe<SortOrder>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<SortOrder>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<SortOrder>;
  option1?: InputMaybe<SortOrder>;
  option2?: InputMaybe<SortOrder>;
  option3?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOverride?: InputMaybe<SortOrder>;
  requiresShipping?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  storeCreditBuyPrice?: InputMaybe<SortOrder>;
  storeCreditBuyPricePercent?: InputMaybe<SortOrder>;
  taxCode?: InputMaybe<SortOrder>;
  taxable?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  weightUnit?: InputMaybe<SortOrder>;
};

export enum ProductVariantScalarFieldEnum {
  Archived = 'archived',
  Barcode = 'barcode',
  BuyPrice = 'buyPrice',
  BuyPricePercent = 'buyPricePercent',
  CompareAtPrice = 'compareAtPrice',
  CustomerProductId = 'customerProductId',
  FulfillmentService = 'fulfillmentService',
  Grams = 'grams',
  Id = 'id',
  InventoryItemId = 'inventoryItemId',
  InventoryManagement = 'inventoryManagement',
  InventoryPolicy = 'inventoryPolicy',
  InventoryQuantity = 'inventoryQuantity',
  MaxInstock = 'maxInstock',
  MaxInstockBuyPercent = 'maxInstockBuyPercent',
  MaxInstockBuyPrice = 'maxInstockBuyPrice',
  MaxInstockStoreCreditBuyPrice = 'maxInstockStoreCreditBuyPrice',
  MaxInstockStoreCreditBuyPricePercent = 'maxInstockStoreCreditBuyPricePercent',
  Option1 = 'option1',
  Option2 = 'option2',
  Option3 = 'option3',
  Position = 'position',
  Price = 'price',
  PriceOverride = 'priceOverride',
  RequiresShipping = 'requiresShipping',
  Sku = 'sku',
  StoreCreditBuyPrice = 'storeCreditBuyPrice',
  StoreCreditBuyPricePercent = 'storeCreditBuyPricePercent',
  TaxCode = 'taxCode',
  Taxable = 'taxable',
  Title = 'title',
  VariantId = 'variantId',
  Weight = 'weight',
  WeightUnit = 'weightUnit'
}

export type ProductVariantWhereInput = {
  AND?: InputMaybe<Array<ProductVariantWhereInput>>;
  NOT?: InputMaybe<Array<ProductVariantWhereInput>>;
  OR?: InputMaybe<Array<ProductVariantWhereInput>>;
  Product?: InputMaybe<ProductRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  barcode?: InputMaybe<StringNullableFilter>;
  buyPrice?: InputMaybe<DecimalNullableFilter>;
  buyPricePercent?: InputMaybe<FloatNullableFilter>;
  customerProductId?: InputMaybe<BigIntNullableFilter>;
  fulfillmentService?: InputMaybe<StringNullableFilter>;
  grams?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  inventoryItemId?: InputMaybe<BigIntNullableFilter>;
  inventoryManagement?: InputMaybe<StringNullableFilter>;
  inventoryPolicy?: InputMaybe<StringNullableFilter>;
  inventoryQuantity?: InputMaybe<BigIntNullableFilter>;
  maxInstock?: InputMaybe<IntNullableFilter>;
  maxInstockBuyPercent?: InputMaybe<FloatNullableFilter>;
  maxInstockBuyPrice?: InputMaybe<DecimalNullableFilter>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<FloatNullableFilter>;
  position?: InputMaybe<BigIntNullableFilter>;
  price?: InputMaybe<StringNullableFilter>;
  priceOverride?: InputMaybe<DecimalNullableFilter>;
  requiresShipping?: InputMaybe<BoolNullableFilter>;
  sku?: InputMaybe<StringNullableFilter>;
  storeCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  storeCreditBuyPricePercent?: InputMaybe<FloatNullableFilter>;
  taxCode?: InputMaybe<StringNullableFilter>;
  taxable?: InputMaybe<BoolNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
  weightUnit?: InputMaybe<StringNullableFilter>;
};

export type ProductVariantWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  BinderCustomerEvent?: InputMaybe<BinderCustomerEventListRelationFilter>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  ProductImage?: InputMaybe<ProductImageListRelationFilter>;
  ProductTag?: InputMaybe<ProductTagListRelationFilter>;
  ProductVariant?: InputMaybe<ProductVariantListRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  bodyHtml?: InputMaybe<StringNullableFilter>;
  cardId?: InputMaybe<BigIntNullableFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  handle?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<StringNullableFilter>;
  metaFieldsGlobalTitleTag?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<BigIntNullableFilter>;
  productType?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<StringNullableFilter>;
  templateSuffix?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  totalQuantity?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  vendor?: InputMaybe<StringNullableFilter>;
};

export type ProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductsToProcess = {
  __typename?: 'ProductsToProcess';
  Cart?: Maybe<Cart>;
  ShopifyCustomerProductVariant?: Maybe<ShopifyCustomerProductVariant>;
  binderCustomerId?: Maybe<Scalars['String']>;
  cartId?: Maybe<Scalars['BigInt']>;
  dateAdded?: Maybe<Scalars['DateTime']>;
  dateProcessed?: Maybe<Scalars['DateTime']>;
  dateSuccessful?: Maybe<Scalars['DateTime']>;
  failReason?: Maybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  failedStatusCode: Scalars['Int'];
  hasBeenAdded: Scalars['Boolean'];
  id: Scalars['BigInt'];
  quantity: Scalars['Int'];
  response?: Maybe<Scalars['String']>;
  shopifyCustomerBuylistId?: Maybe<Scalars['BigInt']>;
  shopifyCustomerProductVariantId?: Maybe<Scalars['BigInt']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductsToProcessCreateManyCartInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateAdded?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  dateSuccessful?: InputMaybe<Scalars['DateTime']>;
  failReason?: InputMaybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  failedStatusCode: Scalars['Int'];
  hasBeenAdded: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  quantity: Scalars['Int'];
  response?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  shopifyCustomerProductVariantId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProductsToProcessCreateManyCartInputEnvelope = {
  data: Array<ProductsToProcessCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductsToProcessCreateManyShopifyCustomerProductVariantInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  cartId?: InputMaybe<Scalars['BigInt']>;
  dateAdded?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  dateSuccessful?: InputMaybe<Scalars['DateTime']>;
  failReason?: InputMaybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  failedStatusCode: Scalars['Int'];
  hasBeenAdded: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  quantity: Scalars['Int'];
  response?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProductsToProcessCreateManyShopifyCustomerProductVariantInputEnvelope = {
  data: Array<ProductsToProcessCreateManyShopifyCustomerProductVariantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductsToProcessCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductsToProcessCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<ProductsToProcessCreateWithoutCartInput>>;
  createMany?: InputMaybe<ProductsToProcessCreateManyCartInputEnvelope>;
};

export type ProductsToProcessCreateNestedManyWithoutShopifyCustomerProductVariantInput = {
  connect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductsToProcessCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<ProductsToProcessCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<ProductsToProcessCreateManyShopifyCustomerProductVariantInputEnvelope>;
};

export type ProductsToProcessCreateOrConnectWithoutCartInput = {
  create: ProductsToProcessCreateWithoutCartInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessCreateOrConnectWithoutShopifyCustomerProductVariantInput = {
  create: ProductsToProcessCreateWithoutShopifyCustomerProductVariantInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessCreateWithoutCartInput = {
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantCreateNestedOneWithoutProductsToProcessInput>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateAdded?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  dateSuccessful?: InputMaybe<Scalars['DateTime']>;
  failReason?: InputMaybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  failedStatusCode: Scalars['Int'];
  hasBeenAdded: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  quantity: Scalars['Int'];
  response?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProductsToProcessCreateWithoutShopifyCustomerProductVariantInput = {
  Cart?: InputMaybe<CartCreateNestedOneWithoutProductsToProcessInput>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  dateAdded?: InputMaybe<Scalars['DateTime']>;
  dateProcessed?: InputMaybe<Scalars['DateTime']>;
  dateSuccessful?: InputMaybe<Scalars['DateTime']>;
  failReason?: InputMaybe<Scalars['String']>;
  failed: Scalars['Boolean'];
  failedStatusCode: Scalars['Int'];
  hasBeenAdded: Scalars['Boolean'];
  id?: InputMaybe<Scalars['BigInt']>;
  quantity: Scalars['Int'];
  response?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProductsToProcessListRelationFilter = {
  every?: InputMaybe<ProductsToProcessWhereInput>;
  none?: InputMaybe<ProductsToProcessWhereInput>;
  some?: InputMaybe<ProductsToProcessWhereInput>;
};

export type ProductsToProcessOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductsToProcessOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantOrderByWithRelationInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  dateAdded?: InputMaybe<SortOrder>;
  dateProcessed?: InputMaybe<SortOrder>;
  dateSuccessful?: InputMaybe<SortOrder>;
  failReason?: InputMaybe<SortOrder>;
  failed?: InputMaybe<SortOrder>;
  failedStatusCode?: InputMaybe<SortOrder>;
  hasBeenAdded?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  response?: InputMaybe<SortOrder>;
  shopifyCustomerBuylistId?: InputMaybe<SortOrder>;
  shopifyCustomerProductVariantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum ProductsToProcessScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  CartId = 'cartId',
  DateAdded = 'dateAdded',
  DateProcessed = 'dateProcessed',
  DateSuccessful = 'dateSuccessful',
  FailReason = 'failReason',
  Failed = 'failed',
  FailedStatusCode = 'failedStatusCode',
  HasBeenAdded = 'hasBeenAdded',
  Id = 'id',
  Quantity = 'quantity',
  Response = 'response',
  ShopifyCustomerBuylistId = 'shopifyCustomerBuylistId',
  ShopifyCustomerProductVariantId = 'shopifyCustomerProductVariantId',
  Type = 'type'
}

export type ProductsToProcessScalarWhereInput = {
  AND?: InputMaybe<Array<ProductsToProcessScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductsToProcessScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductsToProcessScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  dateAdded?: InputMaybe<DateTimeNullableFilter>;
  dateProcessed?: InputMaybe<DateTimeNullableFilter>;
  dateSuccessful?: InputMaybe<DateTimeNullableFilter>;
  failReason?: InputMaybe<StringNullableFilter>;
  failed?: InputMaybe<BoolFilter>;
  failedStatusCode?: InputMaybe<IntFilter>;
  hasBeenAdded?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  quantity?: InputMaybe<IntFilter>;
  response?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  shopifyCustomerProductVariantId?: InputMaybe<BigIntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type ProductsToProcessUpdateManyMutationInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateAdded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateProcessed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSuccessful?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  failReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  failedStatusCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  hasBeenAdded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  response?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductsToProcessUpdateManyWithWhereWithoutCartInput = {
  data: ProductsToProcessUpdateManyMutationInput;
  where: ProductsToProcessScalarWhereInput;
};

export type ProductsToProcessUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput = {
  data: ProductsToProcessUpdateManyMutationInput;
  where: ProductsToProcessScalarWhereInput;
};

export type ProductsToProcessUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductsToProcessCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<ProductsToProcessCreateWithoutCartInput>>;
  createMany?: InputMaybe<ProductsToProcessCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductsToProcessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductsToProcessUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<ProductsToProcessUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<ProductsToProcessUpsertWithWhereUniqueWithoutCartInput>>;
};

export type ProductsToProcessUpdateManyWithoutShopifyCustomerProductVariantNestedInput = {
  connect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductsToProcessCreateOrConnectWithoutShopifyCustomerProductVariantInput>>;
  create?: InputMaybe<Array<ProductsToProcessCreateWithoutShopifyCustomerProductVariantInput>>;
  createMany?: InputMaybe<ProductsToProcessCreateManyShopifyCustomerProductVariantInputEnvelope>;
  delete?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductsToProcessScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductsToProcessWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductsToProcessUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
  updateMany?: InputMaybe<Array<ProductsToProcessUpdateManyWithWhereWithoutShopifyCustomerProductVariantInput>>;
  upsert?: InputMaybe<Array<ProductsToProcessUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput>>;
};

export type ProductsToProcessUpdateWithWhereUniqueWithoutCartInput = {
  data: ProductsToProcessUpdateWithoutCartInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessUpdateWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  data: ProductsToProcessUpdateWithoutShopifyCustomerProductVariantInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessUpdateWithoutCartInput = {
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantUpdateOneWithoutProductsToProcessNestedInput>;
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateAdded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateProcessed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSuccessful?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  failReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  failedStatusCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  hasBeenAdded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  response?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductsToProcessUpdateWithoutShopifyCustomerProductVariantInput = {
  Cart?: InputMaybe<CartUpdateOneWithoutProductsToProcessNestedInput>;
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dateAdded?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateProcessed?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSuccessful?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  failReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  failed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  failedStatusCode?: InputMaybe<IntFieldUpdateOperationsInput>;
  hasBeenAdded?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  response?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProductsToProcessUpsertWithWhereUniqueWithoutCartInput = {
  create: ProductsToProcessCreateWithoutCartInput;
  update: ProductsToProcessUpdateWithoutCartInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessUpsertWithWhereUniqueWithoutShopifyCustomerProductVariantInput = {
  create: ProductsToProcessCreateWithoutShopifyCustomerProductVariantInput;
  update: ProductsToProcessUpdateWithoutShopifyCustomerProductVariantInput;
  where: ProductsToProcessWhereUniqueInput;
};

export type ProductsToProcessWhereInput = {
  AND?: InputMaybe<Array<ProductsToProcessWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<ProductsToProcessWhereInput>>;
  OR?: InputMaybe<Array<ProductsToProcessWhereInput>>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantRelationFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  dateAdded?: InputMaybe<DateTimeNullableFilter>;
  dateProcessed?: InputMaybe<DateTimeNullableFilter>;
  dateSuccessful?: InputMaybe<DateTimeNullableFilter>;
  failReason?: InputMaybe<StringNullableFilter>;
  failed?: InputMaybe<BoolFilter>;
  failedStatusCode?: InputMaybe<IntFilter>;
  hasBeenAdded?: InputMaybe<BoolFilter>;
  id?: InputMaybe<BigIntFilter>;
  quantity?: InputMaybe<IntFilter>;
  response?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  shopifyCustomerProductVariantId?: InputMaybe<BigIntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type ProductsToProcessWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Query = {
  __typename?: 'Query';
  BinderCustomerLocation: Array<BinderCustomerLocation>;
  BinderCustomerLocation_by_pk?: Maybe<BinderCustomerLocation>;
  BinderCustomerSettings: Array<BinderCustomerSettings>;
  BinderCustomerSettings_by_pk?: Maybe<BinderCustomerSettings>;
  BinderCustomerShopifyTheme?: Maybe<Array<BinderCustomerShopifyTheme>>;
  BinderCustomerShopifyThemeDeploymentAuditLog?: Maybe<Array<BinderCustomerShopifyThemeDeploymentAuditLog>>;
  BinderCustomerTill: Array<BinderCustomerTill>;
  BinderCustomerTillSettings: Array<BinderCustomerTillSettings>;
  BinderCustomerTillSettings_by_pk?: Maybe<BinderCustomerTillSettings>;
  BinderCustomerTill_by_pk?: Maybe<BinderCustomerTill>;
  BinderCustomerUser?: Maybe<Array<BinderCustomerUser>>;
  BinderCustomerUser_by_pk?: Maybe<BinderCustomerUser>;
  BinderCustomer_by_pk?: Maybe<BinderCustomer>;
  Cart: Array<Cart>;
  CartIntegratedPayment: Array<CartIntegratedPayment>;
  CartIntegratedPayment_by_pk?: Maybe<CartIntegratedPayment>;
  CartItem: Array<CartItem>;
  CartItemAdditionalInfo: Array<CartItemAdditionalInfo>;
  CartItemAdditionalInfo_by_pk?: Maybe<CartItemAdditionalInfo>;
  CartItemInventoryAdjustment: Array<CartItemInventoryAdjustment>;
  CartItemInventoryAdjustment_by_pk?: Maybe<CartItemInventoryAdjustment>;
  CartItem_by_pk?: Maybe<CartItem>;
  CartTax: Array<CartTax>;
  CartTax_by_pk?: Maybe<CartTax>;
  CartTender: Array<CartTender>;
  CartTender_by_pk?: Maybe<CartTender>;
  Cart_by_pk?: Maybe<Cart>;
  FeatureSwitch: Array<FeatureSwitch>;
  FeatureSwitch_by_pk?: Maybe<FeatureSwitch>;
  GetLatestCartForTill?: Maybe<Cart>;
  JobQueue: Array<JobQueue>;
  JobQueue_by_pk?: Maybe<JobQueue>;
  POSFloat: Array<PosFloat>;
  POSFloatType: Array<PosFloatType>;
  POSFloatType_by_pk?: Maybe<PosFloatType>;
  POSFloat_by_pk?: Maybe<PosFloat>;
  POSPaymentTypes: Array<PosPaymentTypes>;
  POSPaymentTypes_by_pk?: Maybe<PosPaymentTypes>;
  Product: Array<Product>;
  ProductImage: Array<ProductImage>;
  ProductImage_by_pk?: Maybe<ProductImage>;
  ProductTag: Array<ProductTag>;
  ProductTag_by_pk?: Maybe<ProductTag>;
  ProductVariant: Array<ProductVariant>;
  ProductVariant_by_pk?: Maybe<ProductVariant>;
  Product_by_pk?: Maybe<Product>;
  ProductsToProcess: Array<ProductsToProcess>;
  ProductsToProcess_by_pk?: Maybe<ProductsToProcess>;
  Quicklinks: Array<Quicklinks>;
  Quicklinks_by_pk?: Maybe<Quicklinks>;
  ShopifyCustomer: Array<ShopifyCustomer>;
  ShopifyCustomerBuylist: Array<ShopifyCustomerBuylist>;
  ShopifyCustomerBuylistDetail: Array<ShopifyCustomerBuylistDetail>;
  ShopifyCustomerBuylistDetail_by_pk?: Maybe<ShopifyCustomerBuylistDetail>;
  ShopifyCustomerBuylistStatusCount: Array<ShopifyCustomerBuylistStatusCount>;
  ShopifyCustomerBuylist_by_pk?: Maybe<ShopifyCustomerBuylist>;
  ShopifyCustomerProduct: Array<ShopifyCustomerProduct>;
  ShopifyCustomerProductImage: Array<ShopifyCustomerProductImage>;
  ShopifyCustomerProductImage_by_pk?: Maybe<ShopifyCustomerProductImage>;
  ShopifyCustomerProductTag: Array<ShopifyCustomerProductTag>;
  ShopifyCustomerProductTag_by_pk?: Maybe<ShopifyCustomerProductTag>;
  ShopifyCustomerProductVariant: Array<ShopifyCustomerProductVariant>;
  ShopifyCustomerProductVariant_by_pk?: Maybe<ShopifyCustomerProductVariant>;
  ShopifyCustomerProduct_by_pk?: Maybe<ShopifyCustomerProduct>;
  ShopifyCustomer_by_pk?: Maybe<ShopifyCustomer>;
  ShopifyThemeAvailableRollbacks?: Maybe<Array<ShopifyThemeRelease>>;
  ShopifyThemeAvailableUpdates?: Maybe<Array<ShopifyThemeRelease>>;
  ShopifyThemeRelease?: Maybe<Array<ShopifyThemeRelease>>;
  StoreCreditHistory: Array<StoreCreditHistory>;
  StoreCreditHistory_by_pk?: Maybe<StoreCreditHistory>;
  getActiveCarts: ActiveCarts;
  getAllCarts: Array<Cart>;
  searchCustomerCatalogProducts?: Maybe<CustomerCatalogProductSearchResult>;
};


export type QueryBinderCustomerLocationArgs = {
  cursor?: InputMaybe<BinderCustomerLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerLocationWhereInput>;
};


export type QueryBinderCustomerLocation_By_PkArgs = {
  cursor?: InputMaybe<BinderCustomerLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerLocationScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<BinderCustomerLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerLocationWhereInput>;
};


export type QueryBinderCustomerSettingsArgs = {
  cursor?: InputMaybe<BinderCustomerSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerSettingsWhereInput>;
};


export type QueryBinderCustomerSettings_By_PkArgs = {
  cursor?: InputMaybe<BinderCustomerSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerSettingsScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<BinderCustomerSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerSettingsWhereInput>;
};


export type QueryBinderCustomerShopifyThemeArgs = {
  cursor?: InputMaybe<BinderCustomerShopifyThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerShopifyThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerShopifyThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
};


export type QueryBinderCustomerShopifyThemeDeploymentAuditLogArgs = {
  cursor?: InputMaybe<BinderCustomerShopifyThemeDeploymentAuditLogWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerShopifyThemeDeploymentAuditLogScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerShopifyThemeDeploymentAuditLogOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerShopifyThemeDeploymentAuditLogWhereInput>;
};


export type QueryBinderCustomerTillArgs = {
  cursor?: InputMaybe<BinderCustomerTillWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerTillOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillWhereInput>;
};


export type QueryBinderCustomerTillSettingsArgs = {
  cursor?: InputMaybe<BinderCustomerTillSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillSettingsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerTillSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
};


export type QueryBinderCustomerTillSettings_By_PkArgs = {
  cursor?: InputMaybe<BinderCustomerTillSettingsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillSettingsScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<BinderCustomerTillSettingsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillSettingsWhereInput>;
};


export type QueryBinderCustomerTill_By_PkArgs = {
  cursor?: InputMaybe<BinderCustomerTillWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerTillScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<BinderCustomerTillOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerTillWhereInput>;
};


export type QueryBinderCustomerUserArgs = {
  cursor?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerUserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerUserWhereInput>;
};


export type QueryBinderCustomerUser_By_PkArgs = {
  cursor?: InputMaybe<BinderCustomerUserWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerUserScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<BinderCustomerUserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerUserWhereInput>;
};


export type QueryCartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type QueryCartIntegratedPaymentArgs = {
  cursor?: InputMaybe<CartIntegratedPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartIntegratedPaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartIntegratedPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartIntegratedPaymentWhereInput>;
};


export type QueryCartIntegratedPayment_By_PkArgs = {
  cursor?: InputMaybe<CartIntegratedPaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartIntegratedPaymentScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartIntegratedPaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartIntegratedPaymentWhereInput>;
};


export type QueryCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type QueryCartItemAdditionalInfoArgs = {
  cursor?: InputMaybe<CartItemAdditionalInfoWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemAdditionalInfoScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemAdditionalInfoOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemAdditionalInfoWhereInput>;
};


export type QueryCartItemAdditionalInfo_By_PkArgs = {
  cursor?: InputMaybe<CartItemAdditionalInfoWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemAdditionalInfoScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartItemAdditionalInfoOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemAdditionalInfoWhereInput>;
};


export type QueryCartItemInventoryAdjustmentArgs = {
  cursor?: InputMaybe<CartItemInventoryAdjustmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemInventoryAdjustmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemInventoryAdjustmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};


export type QueryCartItemInventoryAdjustment_By_PkArgs = {
  cursor?: InputMaybe<CartItemInventoryAdjustmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemInventoryAdjustmentScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartItemInventoryAdjustmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};


export type QueryCartItem_By_PkArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type QueryCartTaxArgs = {
  cursor?: InputMaybe<CartTaxWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTaxScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTaxOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTaxWhereInput>;
};


export type QueryCartTax_By_PkArgs = {
  cursor?: InputMaybe<CartTaxWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTaxScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartTaxOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTaxWhereInput>;
};


export type QueryCartTenderArgs = {
  cursor?: InputMaybe<CartTenderWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTenderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartTenderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTenderWhereInput>;
};


export type QueryCartTender_By_PkArgs = {
  cursor?: InputMaybe<CartTenderWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartTenderScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartTenderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartTenderWhereInput>;
};


export type QueryCart_By_PkArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type QueryFeatureSwitchArgs = {
  cursor?: InputMaybe<FeatureSwitchWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeatureSwitchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FeatureSwitchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeatureSwitchWhereInput>;
};


export type QueryFeatureSwitch_By_PkArgs = {
  cursor?: InputMaybe<FeatureSwitchWhereUniqueInput>;
  distinct?: InputMaybe<Array<FeatureSwitchScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<FeatureSwitchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FeatureSwitchWhereInput>;
};


export type QueryGetLatestCartForTillArgs = {
  tillId: Scalars['Float'];
};


export type QueryJobQueueArgs = {
  cursor?: InputMaybe<JobQueueWhereUniqueInput>;
  distinct?: InputMaybe<Array<JobQueueScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JobQueueOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JobQueueWhereInput>;
};


export type QueryJobQueue_By_PkArgs = {
  cursor?: InputMaybe<JobQueueWhereUniqueInput>;
  distinct?: InputMaybe<Array<JobQueueScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<JobQueueOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JobQueueWhereInput>;
};


export type QueryPosFloatArgs = {
  cursor?: InputMaybe<PosFloatWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PosFloatOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatWhereInput>;
};


export type QueryPosFloatTypeArgs = {
  cursor?: InputMaybe<PosFloatTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PosFloatTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatTypeWhereInput>;
};


export type QueryPosFloatType_By_PkArgs = {
  cursor?: InputMaybe<PosFloatTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatTypeScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<PosFloatTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatTypeWhereInput>;
};


export type QueryPosFloat_By_PkArgs = {
  cursor?: InputMaybe<PosFloatWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosFloatScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<PosFloatOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosFloatWhereInput>;
};


export type QueryPosPaymentTypesArgs = {
  cursor?: InputMaybe<PosPaymentTypesWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosPaymentTypesScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PosPaymentTypesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosPaymentTypesWhereInput>;
};


export type QueryPosPaymentTypes_By_PkArgs = {
  cursor?: InputMaybe<PosPaymentTypesWhereUniqueInput>;
  distinct?: InputMaybe<Array<PosPaymentTypesScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<PosPaymentTypesOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PosPaymentTypesWhereInput>;
};


export type QueryProductArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryProductImageArgs = {
  cursor?: InputMaybe<ProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductImageWhereInput>;
};


export type QueryProductImage_By_PkArgs = {
  cursor?: InputMaybe<ProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductImageScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductImageWhereInput>;
};


export type QueryProductTagArgs = {
  cursor?: InputMaybe<ProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductTagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductTagWhereInput>;
};


export type QueryProductTag_By_PkArgs = {
  cursor?: InputMaybe<ProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductTagScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductTagWhereInput>;
};


export type QueryProductVariantArgs = {
  cursor?: InputMaybe<ProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductVariantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductVariantWhereInput>;
};


export type QueryProductVariant_By_PkArgs = {
  cursor?: InputMaybe<ProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductVariantScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductVariantWhereInput>;
};


export type QueryProduct_By_PkArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryProductsToProcessArgs = {
  cursor?: InputMaybe<ProductsToProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductsToProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductsToProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsToProcessWhereInput>;
};


export type QueryProductsToProcess_By_PkArgs = {
  cursor?: InputMaybe<ProductsToProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductsToProcessScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ProductsToProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsToProcessWhereInput>;
};


export type QueryQuicklinksArgs = {
  cursor?: InputMaybe<QuicklinksWhereUniqueInput>;
  distinct?: InputMaybe<Array<QuicklinksScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<QuicklinksOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuicklinksWhereInput>;
};


export type QueryQuicklinks_By_PkArgs = {
  cursor?: InputMaybe<QuicklinksWhereUniqueInput>;
  distinct?: InputMaybe<Array<QuicklinksScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<QuicklinksOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<QuicklinksWhereInput>;
};


export type QueryShopifyCustomerArgs = {
  cursor?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerWhereInput>;
};


export type QueryShopifyCustomerBuylistArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};


export type QueryShopifyCustomerBuylistDetailArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
};


export type QueryShopifyCustomerBuylistDetail_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
};


export type QueryShopifyCustomerBuylist_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};


export type QueryShopifyCustomerProductArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductWhereInput>;
};


export type QueryShopifyCustomerProductImageArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
};


export type QueryShopifyCustomerProductImage_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductImageScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
};


export type QueryShopifyCustomerProductTagArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductTagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
};


export type QueryShopifyCustomerProductTag_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductTagScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
};


export type QueryShopifyCustomerProductVariantArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductVariantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
};


export type QueryShopifyCustomerProductVariant_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductVariantScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
};


export type QueryShopifyCustomerProduct_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductWhereInput>;
};


export type QueryShopifyCustomer_By_PkArgs = {
  cursor?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<ShopifyCustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerWhereInput>;
};


export type QueryShopifyThemeAvailableRollbacksArgs = {
  currentVersion: Scalars['String'];
  theme: Scalars['String'];
};


export type QueryShopifyThemeAvailableUpdatesArgs = {
  currentVersion: Scalars['String'];
  theme: Scalars['String'];
};


export type QueryShopifyThemeReleaseArgs = {
  cursor?: InputMaybe<ShopifyThemeReleaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyThemeReleaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyThemeReleaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyThemeReleaseWhereInput>;
};


export type QueryStoreCreditHistoryArgs = {
  cursor?: InputMaybe<StoreCreditHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StoreCreditHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StoreCreditHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoreCreditHistoryWhereInput>;
};


export type QueryStoreCreditHistory_By_PkArgs = {
  cursor?: InputMaybe<StoreCreditHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StoreCreditHistoryScalarFieldEnum>>;
  id: Scalars['Float'];
  orderBy?: InputMaybe<Array<StoreCreditHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoreCreditHistoryWhereInput>;
};


export type QueryGetActiveCartsArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AllCartsWhereInput>;
};


export type QueryGetAllCartsArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AllCartsWhereInput>;
};


export type QuerySearchCustomerCatalogProductsArgs = {
  cursor?: InputMaybe<Scalars['Int']>;
  filter: CatalogFilter;
  next?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type Quicklinks = {
  __typename?: 'Quicklinks';
  BinderCustomerTill?: Maybe<BinderCustomerTill>;
  binderCustomerId?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  tillId?: Maybe<Scalars['BigInt']>;
  value?: Maybe<Scalars['String']>;
};

export type QuicklinksCreateManyBinderCustomerTillInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type QuicklinksCreateManyBinderCustomerTillInputEnvelope = {
  data: Array<QuicklinksCreateManyBinderCustomerTillInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type QuicklinksCreateNestedManyWithoutBinderCustomerTillInput = {
  connect?: InputMaybe<Array<QuicklinksWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuicklinksCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<QuicklinksCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<QuicklinksCreateManyBinderCustomerTillInputEnvelope>;
};

export type QuicklinksCreateOrConnectWithoutBinderCustomerTillInput = {
  create: QuicklinksCreateWithoutBinderCustomerTillInput;
  where: QuicklinksWhereUniqueInput;
};

export type QuicklinksCreateWithoutBinderCustomerTillInput = {
  binderCustomerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type QuicklinksListRelationFilter = {
  every?: InputMaybe<QuicklinksWhereInput>;
  none?: InputMaybe<QuicklinksWhereInput>;
  some?: InputMaybe<QuicklinksWhereInput>;
};

export type QuicklinksOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type QuicklinksOrderByWithRelationInput = {
  BinderCustomerTill?: InputMaybe<BinderCustomerTillOrderByWithRelationInput>;
  binderCustomerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  tillId?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum QuicklinksScalarFieldEnum {
  BinderCustomerId = 'binderCustomerId',
  Id = 'id',
  TillId = 'tillId',
  Value = 'value'
}

export type QuicklinksScalarWhereInput = {
  AND?: InputMaybe<Array<QuicklinksScalarWhereInput>>;
  NOT?: InputMaybe<Array<QuicklinksScalarWhereInput>>;
  OR?: InputMaybe<Array<QuicklinksScalarWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
  value?: InputMaybe<StringNullableFilter>;
};

export type QuicklinksUKbles89y0a6bs90f3hfod00k2CompoundUniqueInput = {
  binderCustomerId: Scalars['String'];
  tillId: Scalars['BigInt'];
};

export type QuicklinksUpdateManyMutationInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuicklinksUpdateManyWithWhereWithoutBinderCustomerTillInput = {
  data: QuicklinksUpdateManyMutationInput;
  where: QuicklinksScalarWhereInput;
};

export type QuicklinksUpdateManyWithoutBinderCustomerTillNestedInput = {
  connect?: InputMaybe<Array<QuicklinksWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<QuicklinksCreateOrConnectWithoutBinderCustomerTillInput>>;
  create?: InputMaybe<Array<QuicklinksCreateWithoutBinderCustomerTillInput>>;
  createMany?: InputMaybe<QuicklinksCreateManyBinderCustomerTillInputEnvelope>;
  delete?: InputMaybe<Array<QuicklinksWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<QuicklinksScalarWhereInput>>;
  disconnect?: InputMaybe<Array<QuicklinksWhereUniqueInput>>;
  set?: InputMaybe<Array<QuicklinksWhereUniqueInput>>;
  update?: InputMaybe<Array<QuicklinksUpdateWithWhereUniqueWithoutBinderCustomerTillInput>>;
  updateMany?: InputMaybe<Array<QuicklinksUpdateManyWithWhereWithoutBinderCustomerTillInput>>;
  upsert?: InputMaybe<Array<QuicklinksUpsertWithWhereUniqueWithoutBinderCustomerTillInput>>;
};

export type QuicklinksUpdateWithWhereUniqueWithoutBinderCustomerTillInput = {
  data: QuicklinksUpdateWithoutBinderCustomerTillInput;
  where: QuicklinksWhereUniqueInput;
};

export type QuicklinksUpdateWithoutBinderCustomerTillInput = {
  binderCustomerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type QuicklinksUpsertWithWhereUniqueWithoutBinderCustomerTillInput = {
  create: QuicklinksCreateWithoutBinderCustomerTillInput;
  update: QuicklinksUpdateWithoutBinderCustomerTillInput;
  where: QuicklinksWhereUniqueInput;
};

export type QuicklinksWhereInput = {
  AND?: InputMaybe<Array<QuicklinksWhereInput>>;
  BinderCustomerTill?: InputMaybe<BinderCustomerTillRelationFilter>;
  NOT?: InputMaybe<Array<QuicklinksWhereInput>>;
  OR?: InputMaybe<Array<QuicklinksWhereInput>>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  tillId?: InputMaybe<BigIntNullableFilter>;
  value?: InputMaybe<StringNullableFilter>;
};

export type QuicklinksWhereUniqueInput = {
  UKbles89y0a6bs90f3hfod00k2?: InputMaybe<QuicklinksUKbles89y0a6bs90f3hfod00k2CompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export enum ReleaseTrain {
  All = 'ALL',
  Fortnightly = 'FORTNIGHTLY',
  NoUpdates = 'NO_UPDATES',
  Weekly = 'WEEKLY'
}

export type ShopifyCustomer = {
  __typename?: 'ShopifyCustomer';
  Cart: Array<Cart>;
  ShopifyCustomerBuylist: Array<ShopifyCustomerBuylist>;
  StoreCreditHistory: Array<StoreCreditHistory>;
  _count?: Maybe<ShopifyCustomerCount>;
  customerId?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  lastName?: Maybe<Scalars['String']>;
  lastOrderId?: Maybe<Scalars['BigInt']>;
  lastOrderName?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  storeCredit: Scalars['Decimal'];
  taxExempt?: Maybe<Scalars['Boolean']>;
  totalSpent?: Maybe<Scalars['Decimal']>;
};


export type ShopifyCustomerCartArgs = {
  cursor?: InputMaybe<CartWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartWhereInput>;
};


export type ShopifyCustomerShopifyCustomerBuylistArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};


export type ShopifyCustomerStoreCreditHistoryArgs = {
  cursor?: InputMaybe<StoreCreditHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<StoreCreditHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StoreCreditHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StoreCreditHistoryWhereInput>;
};

export type ShopifyCustomerBuylist = {
  __typename?: 'ShopifyCustomerBuylist';
  BinderCustomer?: Maybe<BinderCustomer>;
  ShopifyCustomer?: Maybe<ShopifyCustomer>;
  ShopifyCustomerBuylistDetail: Array<ShopifyCustomerBuylistDetail>;
  _count?: Maybe<ShopifyCustomerBuylistCount>;
  approved: Scalars['Boolean'];
  approvedNotes?: Maybe<Scalars['String']>;
  binderCustomerId?: Maybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  dateApproved?: Maybe<Scalars['DateTime']>;
  dateCompleted?: Maybe<Scalars['DateTime']>;
  dateSubmitted?: Maybe<Scalars['DateTime']>;
  declinedReason?: Maybe<Scalars['String']>;
  hasStartedToPush?: Maybe<Scalars['Boolean']>;
  id: Scalars['BigInt'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  paymentType?: Maybe<Scalars['String']>;
  shopifyCustomerId?: Maybe<Scalars['BigInt']>;
  stockPushed?: Maybe<Scalars['Boolean']>;
  storeCreditApplied?: Maybe<Scalars['Boolean']>;
  submitted: Scalars['Boolean'];
};


export type ShopifyCustomerBuylistShopifyCustomerBuylistDetailArgs = {
  cursor?: InputMaybe<ShopifyCustomerBuylistDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
};

export type ShopifyCustomerBuylistCount = {
  __typename?: 'ShopifyCustomerBuylistCount';
  ShopifyCustomerBuylistDetail: Scalars['Int'];
};

export type ShopifyCustomerBuylistCreateManyBinderCustomerInput = {
  approved: Scalars['Boolean'];
  approvedNotes?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  dateApproved?: InputMaybe<Scalars['DateTime']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  declinedReason?: InputMaybe<Scalars['String']>;
  hasStartedToPush?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  paymentType?: InputMaybe<Scalars['String']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  stockPushed?: InputMaybe<Scalars['Boolean']>;
  storeCreditApplied?: InputMaybe<Scalars['Boolean']>;
  submitted: Scalars['Boolean'];
};

export type ShopifyCustomerBuylistCreateManyBinderCustomerInputEnvelope = {
  data: Array<ShopifyCustomerBuylistCreateManyBinderCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyCustomerBuylistCreateManyShopifyCustomerInput = {
  approved: Scalars['Boolean'];
  approvedNotes?: InputMaybe<Scalars['String']>;
  binderCustomerId?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  dateApproved?: InputMaybe<Scalars['DateTime']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  declinedReason?: InputMaybe<Scalars['String']>;
  hasStartedToPush?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  paymentType?: InputMaybe<Scalars['String']>;
  stockPushed?: InputMaybe<Scalars['Boolean']>;
  storeCreditApplied?: InputMaybe<Scalars['Boolean']>;
  submitted: Scalars['Boolean'];
};

export type ShopifyCustomerBuylistCreateManyShopifyCustomerInputEnvelope = {
  data: Array<ShopifyCustomerBuylistCreateManyShopifyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyCustomerBuylistCreateNestedManyWithoutBinderCustomerInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistCreateManyBinderCustomerInputEnvelope>;
};

export type ShopifyCustomerBuylistCreateNestedManyWithoutShopifyCustomerInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistCreateManyShopifyCustomerInputEnvelope>;
};

export type ShopifyCustomerBuylistCreateOrConnectWithoutBinderCustomerInput = {
  create: ShopifyCustomerBuylistCreateWithoutBinderCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistCreateOrConnectWithoutShopifyCustomerInput = {
  create: ShopifyCustomerBuylistCreateWithoutShopifyCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistCreateWithoutBinderCustomerInput = {
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutShopifyCustomerBuylistInput>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailCreateNestedManyWithoutShopifyCustomerBuylistInput>;
  approved: Scalars['Boolean'];
  approvedNotes?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  dateApproved?: InputMaybe<Scalars['DateTime']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  declinedReason?: InputMaybe<Scalars['String']>;
  hasStartedToPush?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  paymentType?: InputMaybe<Scalars['String']>;
  stockPushed?: InputMaybe<Scalars['Boolean']>;
  storeCreditApplied?: InputMaybe<Scalars['Boolean']>;
  submitted: Scalars['Boolean'];
};

export type ShopifyCustomerBuylistCreateWithoutShopifyCustomerInput = {
  BinderCustomer?: InputMaybe<BinderCustomerCreateNestedOneWithoutShopifyCustomerBuylistInput>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailCreateNestedManyWithoutShopifyCustomerBuylistInput>;
  approved: Scalars['Boolean'];
  approvedNotes?: InputMaybe<Scalars['String']>;
  completed: Scalars['Boolean'];
  dateApproved?: InputMaybe<Scalars['DateTime']>;
  dateCompleted?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  declinedReason?: InputMaybe<Scalars['String']>;
  hasStartedToPush?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  paymentType?: InputMaybe<Scalars['String']>;
  stockPushed?: InputMaybe<Scalars['Boolean']>;
  storeCreditApplied?: InputMaybe<Scalars['Boolean']>;
  submitted: Scalars['Boolean'];
};

export type ShopifyCustomerBuylistDetail = {
  __typename?: 'ShopifyCustomerBuylistDetail';
  ShopifyCustomerBuylist?: Maybe<ShopifyCustomerBuylist>;
  cardId: Scalars['BigInt'];
  cardName?: Maybe<Scalars['String']>;
  cashBuyPrice?: Maybe<Scalars['Decimal']>;
  game?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  imageUrl?: Maybe<Scalars['String']>;
  isFoil?: Maybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  setName?: Maybe<Scalars['String']>;
  shopifyCustomerBuylistId?: Maybe<Scalars['BigInt']>;
  storeCreditBuyPrice?: Maybe<Scalars['Decimal']>;
  type?: Maybe<Scalars['String']>;
  variantId?: Maybe<Scalars['BigInt']>;
};

export type ShopifyCustomerBuylistDetailCreateManyShopifyCustomerBuylistInput = {
  cardId: Scalars['BigInt'];
  cardName?: InputMaybe<Scalars['String']>;
  cashBuyPrice?: InputMaybe<Scalars['Decimal']>;
  game?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isFoil?: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  setName?: InputMaybe<Scalars['String']>;
  storeCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  type?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerBuylistDetailCreateManyShopifyCustomerBuylistInputEnvelope = {
  data: Array<ShopifyCustomerBuylistDetailCreateManyShopifyCustomerBuylistInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyCustomerBuylistDetailCreateNestedManyWithoutShopifyCustomerBuylistInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistDetailCreateOrConnectWithoutShopifyCustomerBuylistInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistDetailCreateWithoutShopifyCustomerBuylistInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistDetailCreateManyShopifyCustomerBuylistInputEnvelope>;
};

export type ShopifyCustomerBuylistDetailCreateOrConnectWithoutShopifyCustomerBuylistInput = {
  create: ShopifyCustomerBuylistDetailCreateWithoutShopifyCustomerBuylistInput;
  where: ShopifyCustomerBuylistDetailWhereUniqueInput;
};

export type ShopifyCustomerBuylistDetailCreateWithoutShopifyCustomerBuylistInput = {
  cardId: Scalars['BigInt'];
  cardName?: InputMaybe<Scalars['String']>;
  cashBuyPrice?: InputMaybe<Scalars['Decimal']>;
  game?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isFoil?: InputMaybe<Scalars['Boolean']>;
  quantity: Scalars['Int'];
  setName?: InputMaybe<Scalars['String']>;
  storeCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  type?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerBuylistDetailListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
  none?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
  some?: InputMaybe<ShopifyCustomerBuylistDetailWhereInput>;
};

export type ShopifyCustomerBuylistDetailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerBuylistDetailOrderByWithRelationInput = {
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistOrderByWithRelationInput>;
  cardId?: InputMaybe<SortOrder>;
  cardName?: InputMaybe<SortOrder>;
  cashBuyPrice?: InputMaybe<SortOrder>;
  game?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isFoil?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  setName?: InputMaybe<SortOrder>;
  shopifyCustomerBuylistId?: InputMaybe<SortOrder>;
  storeCreditBuyPrice?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
};

export enum ShopifyCustomerBuylistDetailScalarFieldEnum {
  CardId = 'cardId',
  CardName = 'cardName',
  CashBuyPrice = 'cashBuyPrice',
  Game = 'game',
  Id = 'id',
  ImageUrl = 'imageUrl',
  IsFoil = 'isFoil',
  Quantity = 'quantity',
  SetName = 'setName',
  ShopifyCustomerBuylistId = 'shopifyCustomerBuylistId',
  StoreCreditBuyPrice = 'storeCreditBuyPrice',
  Type = 'type',
  VariantId = 'variantId'
}

export type ShopifyCustomerBuylistDetailScalarWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarWhereInput>>;
  cardId?: InputMaybe<BigIntFilter>;
  cardName?: InputMaybe<StringNullableFilter>;
  cashBuyPrice?: InputMaybe<DecimalNullableFilter>;
  game?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isFoil?: InputMaybe<BoolNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  setName?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  storeCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type ShopifyCustomerBuylistDetailUpdateManyMutationInput = {
  cardId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  cardName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cashBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  game?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isFoil?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  setName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  storeCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
};

export type ShopifyCustomerBuylistDetailUpdateManyWithWhereWithoutShopifyCustomerBuylistInput = {
  data: ShopifyCustomerBuylistDetailUpdateManyMutationInput;
  where: ShopifyCustomerBuylistDetailScalarWhereInput;
};

export type ShopifyCustomerBuylistDetailUpdateManyWithoutShopifyCustomerBuylistNestedInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistDetailCreateOrConnectWithoutShopifyCustomerBuylistInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistDetailCreateWithoutShopifyCustomerBuylistInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistDetailCreateManyShopifyCustomerBuylistInputEnvelope>;
  delete?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShopifyCustomerBuylistDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<ShopifyCustomerBuylistDetailUpdateWithWhereUniqueWithoutShopifyCustomerBuylistInput>>;
  updateMany?: InputMaybe<Array<ShopifyCustomerBuylistDetailUpdateManyWithWhereWithoutShopifyCustomerBuylistInput>>;
  upsert?: InputMaybe<Array<ShopifyCustomerBuylistDetailUpsertWithWhereUniqueWithoutShopifyCustomerBuylistInput>>;
};

export type ShopifyCustomerBuylistDetailUpdateWithWhereUniqueWithoutShopifyCustomerBuylistInput = {
  data: ShopifyCustomerBuylistDetailUpdateWithoutShopifyCustomerBuylistInput;
  where: ShopifyCustomerBuylistDetailWhereUniqueInput;
};

export type ShopifyCustomerBuylistDetailUpdateWithoutShopifyCustomerBuylistInput = {
  cardId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  cardName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cashBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  game?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isFoil?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  setName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  storeCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
};

export type ShopifyCustomerBuylistDetailUpsertWithWhereUniqueWithoutShopifyCustomerBuylistInput = {
  create: ShopifyCustomerBuylistDetailCreateWithoutShopifyCustomerBuylistInput;
  update: ShopifyCustomerBuylistDetailUpdateWithoutShopifyCustomerBuylistInput;
  where: ShopifyCustomerBuylistDetailWhereUniqueInput;
};

export type ShopifyCustomerBuylistDetailWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerBuylistDetailWhereInput>>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistRelationFilter>;
  cardId?: InputMaybe<BigIntFilter>;
  cardName?: InputMaybe<StringNullableFilter>;
  cashBuyPrice?: InputMaybe<DecimalNullableFilter>;
  game?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isFoil?: InputMaybe<BoolNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  setName?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  storeCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
};

export type ShopifyCustomerBuylistDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerBuylistListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
  none?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
  some?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};

export type ShopifyCustomerBuylistOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerBuylistOrderByWithRelationInput = {
  BinderCustomer?: InputMaybe<BinderCustomerOrderByWithRelationInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerOrderByWithRelationInput>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailOrderByRelationAggregateInput>;
  approved?: InputMaybe<SortOrder>;
  approvedNotes?: InputMaybe<SortOrder>;
  binderCustomerId?: InputMaybe<SortOrder>;
  completed?: InputMaybe<SortOrder>;
  dateApproved?: InputMaybe<SortOrder>;
  dateCompleted?: InputMaybe<SortOrder>;
  dateSubmitted?: InputMaybe<SortOrder>;
  declinedReason?: InputMaybe<SortOrder>;
  hasStartedToPush?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastUpdated?: InputMaybe<SortOrder>;
  paymentType?: InputMaybe<SortOrder>;
  shopifyCustomerId?: InputMaybe<SortOrder>;
  stockPushed?: InputMaybe<SortOrder>;
  storeCreditApplied?: InputMaybe<SortOrder>;
  submitted?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerBuylistRelationFilter = {
  is?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
  isNot?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
};

export enum ShopifyCustomerBuylistScalarFieldEnum {
  Approved = 'approved',
  ApprovedNotes = 'approvedNotes',
  BinderCustomerId = 'binderCustomerId',
  Completed = 'completed',
  DateApproved = 'dateApproved',
  DateCompleted = 'dateCompleted',
  DateSubmitted = 'dateSubmitted',
  DeclinedReason = 'declinedReason',
  HasStartedToPush = 'hasStartedToPush',
  Id = 'id',
  LastUpdated = 'lastUpdated',
  PaymentType = 'paymentType',
  ShopifyCustomerId = 'shopifyCustomerId',
  StockPushed = 'stockPushed',
  StoreCreditApplied = 'storeCreditApplied',
  Submitted = 'submitted'
}

export type ShopifyCustomerBuylistScalarWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerBuylistScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerBuylistScalarWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerBuylistScalarWhereInput>>;
  approved?: InputMaybe<BoolFilter>;
  approvedNotes?: InputMaybe<StringNullableFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolFilter>;
  dateApproved?: InputMaybe<DateTimeNullableFilter>;
  dateCompleted?: InputMaybe<DateTimeNullableFilter>;
  dateSubmitted?: InputMaybe<DateTimeNullableFilter>;
  declinedReason?: InputMaybe<StringNullableFilter>;
  hasStartedToPush?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdated?: InputMaybe<DateTimeNullableFilter>;
  paymentType?: InputMaybe<StringNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  stockPushed?: InputMaybe<BoolNullableFilter>;
  storeCreditApplied?: InputMaybe<BoolNullableFilter>;
  submitted?: InputMaybe<BoolFilter>;
};

export type ShopifyCustomerBuylistStatusCount = {
  __typename?: 'ShopifyCustomerBuylistStatusCount';
  approvedCount: Scalars['Int'];
  completedCount: Scalars['Int'];
  declinedCount: Scalars['Int'];
  pendingCount: Scalars['Int'];
};

export type ShopifyCustomerBuylistUpdateManyMutationInput = {
  approved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  approvedNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dateApproved?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declinedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasStartedToPush?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stockPushed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  storeCreditApplied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  submitted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ShopifyCustomerBuylistUpdateManyWithWhereWithoutBinderCustomerInput = {
  data: ShopifyCustomerBuylistUpdateManyMutationInput;
  where: ShopifyCustomerBuylistScalarWhereInput;
};

export type ShopifyCustomerBuylistUpdateManyWithWhereWithoutShopifyCustomerInput = {
  data: ShopifyCustomerBuylistUpdateManyMutationInput;
  where: ShopifyCustomerBuylistScalarWhereInput;
};

export type ShopifyCustomerBuylistUpdateManyWithoutBinderCustomerNestedInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistCreateOrConnectWithoutBinderCustomerInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistCreateWithoutBinderCustomerInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistCreateManyBinderCustomerInputEnvelope>;
  delete?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShopifyCustomerBuylistScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  set?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  update?: InputMaybe<Array<ShopifyCustomerBuylistUpdateWithWhereUniqueWithoutBinderCustomerInput>>;
  updateMany?: InputMaybe<Array<ShopifyCustomerBuylistUpdateManyWithWhereWithoutBinderCustomerInput>>;
  upsert?: InputMaybe<Array<ShopifyCustomerBuylistUpsertWithWhereUniqueWithoutBinderCustomerInput>>;
};

export type ShopifyCustomerBuylistUpdateManyWithoutShopifyCustomerNestedInput = {
  connect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerBuylistCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<ShopifyCustomerBuylistCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<ShopifyCustomerBuylistCreateManyShopifyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShopifyCustomerBuylistScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  set?: InputMaybe<Array<ShopifyCustomerBuylistWhereUniqueInput>>;
  update?: InputMaybe<Array<ShopifyCustomerBuylistUpdateWithWhereUniqueWithoutShopifyCustomerInput>>;
  updateMany?: InputMaybe<Array<ShopifyCustomerBuylistUpdateManyWithWhereWithoutShopifyCustomerInput>>;
  upsert?: InputMaybe<Array<ShopifyCustomerBuylistUpsertWithWhereUniqueWithoutShopifyCustomerInput>>;
};

export type ShopifyCustomerBuylistUpdateWithWhereUniqueWithoutBinderCustomerInput = {
  data: ShopifyCustomerBuylistUpdateWithoutBinderCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistUpdateWithWhereUniqueWithoutShopifyCustomerInput = {
  data: ShopifyCustomerBuylistUpdateWithoutShopifyCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistUpdateWithoutBinderCustomerInput = {
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutShopifyCustomerBuylistNestedInput>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailUpdateManyWithoutShopifyCustomerBuylistNestedInput>;
  approved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  approvedNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dateApproved?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declinedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasStartedToPush?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stockPushed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  storeCreditApplied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  submitted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ShopifyCustomerBuylistUpdateWithoutShopifyCustomerInput = {
  BinderCustomer?: InputMaybe<BinderCustomerUpdateOneWithoutShopifyCustomerBuylistNestedInput>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailUpdateManyWithoutShopifyCustomerBuylistNestedInput>;
  approved?: InputMaybe<BoolFieldUpdateOperationsInput>;
  approvedNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  completed?: InputMaybe<BoolFieldUpdateOperationsInput>;
  dateApproved?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateCompleted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dateSubmitted?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  declinedReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hasStartedToPush?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastUpdated?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  paymentType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  stockPushed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  storeCreditApplied?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  submitted?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ShopifyCustomerBuylistUpsertWithWhereUniqueWithoutBinderCustomerInput = {
  create: ShopifyCustomerBuylistCreateWithoutBinderCustomerInput;
  update: ShopifyCustomerBuylistUpdateWithoutBinderCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistUpsertWithWhereUniqueWithoutShopifyCustomerInput = {
  create: ShopifyCustomerBuylistCreateWithoutShopifyCustomerInput;
  update: ShopifyCustomerBuylistUpdateWithoutShopifyCustomerInput;
  where: ShopifyCustomerBuylistWhereUniqueInput;
};

export type ShopifyCustomerBuylistWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerBuylistWhereInput>>;
  BinderCustomer?: InputMaybe<BinderCustomerRelationFilter>;
  NOT?: InputMaybe<Array<ShopifyCustomerBuylistWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerBuylistWhereInput>>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerRelationFilter>;
  ShopifyCustomerBuylistDetail?: InputMaybe<ShopifyCustomerBuylistDetailListRelationFilter>;
  approved?: InputMaybe<BoolFilter>;
  approvedNotes?: InputMaybe<StringNullableFilter>;
  binderCustomerId?: InputMaybe<StringNullableFilter>;
  completed?: InputMaybe<BoolFilter>;
  dateApproved?: InputMaybe<DateTimeNullableFilter>;
  dateCompleted?: InputMaybe<DateTimeNullableFilter>;
  dateSubmitted?: InputMaybe<DateTimeNullableFilter>;
  declinedReason?: InputMaybe<StringNullableFilter>;
  hasStartedToPush?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastUpdated?: InputMaybe<DateTimeNullableFilter>;
  paymentType?: InputMaybe<StringNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  stockPushed?: InputMaybe<BoolNullableFilter>;
  storeCreditApplied?: InputMaybe<BoolNullableFilter>;
  submitted?: InputMaybe<BoolFilter>;
};

export type ShopifyCustomerBuylistWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerCount = {
  __typename?: 'ShopifyCustomerCount';
  Cart: Scalars['Int'];
  ShopifyCustomerBuylist: Scalars['Int'];
  StoreCreditHistory: Scalars['Int'];
};

export type ShopifyCustomerCreateNestedOneWithoutCartInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutCartInput>;
};

export type ShopifyCustomerCreateNestedOneWithoutShopifyCustomerBuylistInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutShopifyCustomerBuylistInput>;
};

export type ShopifyCustomerCreateNestedOneWithoutStoreCreditHistoryInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutStoreCreditHistoryInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutStoreCreditHistoryInput>;
};

export type ShopifyCustomerCreateOrConnectWithoutCartInput = {
  create: ShopifyCustomerCreateWithoutCartInput;
  where: ShopifyCustomerWhereUniqueInput;
};

export type ShopifyCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput = {
  create: ShopifyCustomerCreateWithoutShopifyCustomerBuylistInput;
  where: ShopifyCustomerWhereUniqueInput;
};

export type ShopifyCustomerCreateOrConnectWithoutStoreCreditHistoryInput = {
  create: ShopifyCustomerCreateWithoutStoreCreditHistoryInput;
  where: ShopifyCustomerWhereUniqueInput;
};

export type ShopifyCustomerCreateWithoutCartInput = {
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistCreateNestedManyWithoutShopifyCustomerInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutShopifyCustomerInput>;
  customerId?: InputMaybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastOrderId?: InputMaybe<Scalars['BigInt']>;
  lastOrderName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  storeCredit?: InputMaybe<Scalars['Decimal']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  totalSpent?: InputMaybe<Scalars['Decimal']>;
};

export type ShopifyCustomerCreateWithoutShopifyCustomerBuylistInput = {
  Cart?: InputMaybe<CartCreateNestedManyWithoutShopifyCustomerInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryCreateNestedManyWithoutShopifyCustomerInput>;
  customerId?: InputMaybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastOrderId?: InputMaybe<Scalars['BigInt']>;
  lastOrderName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  storeCredit?: InputMaybe<Scalars['Decimal']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  totalSpent?: InputMaybe<Scalars['Decimal']>;
};

export type ShopifyCustomerCreateWithoutStoreCreditHistoryInput = {
  Cart?: InputMaybe<CartCreateNestedManyWithoutShopifyCustomerInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistCreateNestedManyWithoutShopifyCustomerInput>;
  customerId?: InputMaybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastOrderId?: InputMaybe<Scalars['BigInt']>;
  lastOrderName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  shopifyId: Scalars['BigInt'];
  storeCredit?: InputMaybe<Scalars['Decimal']>;
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  totalSpent?: InputMaybe<Scalars['Decimal']>;
};

export type ShopifyCustomerCustomerIdAndShopifyIdUniqueCompoundUniqueInput = {
  customerId: Scalars['String'];
  shopifyId: Scalars['BigInt'];
};

export type ShopifyCustomerDto = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastName?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  storeCredit?: InputMaybe<Scalars['Decimal']>;
};

export type ShopifyCustomerOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByRelationAggregateInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistOrderByRelationAggregateInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryOrderByRelationAggregateInput>;
  customerId?: InputMaybe<SortOrder>;
  disabled?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  lastOrderId?: InputMaybe<SortOrder>;
  lastOrderName?: InputMaybe<SortOrder>;
  notes?: InputMaybe<SortOrder>;
  phone?: InputMaybe<SortOrder>;
  shopifyId?: InputMaybe<SortOrder>;
  storeCredit?: InputMaybe<SortOrder>;
  taxExempt?: InputMaybe<SortOrder>;
  totalSpent?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProduct = {
  __typename?: 'ShopifyCustomerProduct';
  ShopifyCustomerProductDescription?: Maybe<ShopifyCustomerProductDescription>;
  ShopifyCustomerProductImage: Array<ShopifyCustomerProductImage>;
  ShopifyCustomerProductTag: Array<ShopifyCustomerProductTag>;
  ShopifyCustomerProductVariant: Array<ShopifyCustomerProductVariant>;
  _count?: Maybe<ShopifyCustomerProductCount>;
  archived?: Maybe<Scalars['Boolean']>;
  bodyHtml?: Maybe<Scalars['String']>;
  bodyHtmlMd5?: Maybe<Scalars['String']>;
  cardId?: Maybe<Scalars['BigInt']>;
  customerId: Scalars['String'];
  handle?: Maybe<Scalars['String']>;
  id: Scalars['BigInt'];
  metaFieldsGlobalDescriptionTag?: Maybe<Scalars['String']>;
  metaFieldsGlobalTitleTag?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productType?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  templateSuffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  totalQuantity?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  vendor?: Maybe<Scalars['String']>;
};


export type ShopifyCustomerProductShopifyCustomerProductImageArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductImageWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductImageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductImageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
};


export type ShopifyCustomerProductShopifyCustomerProductTagArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductTagWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductTagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductTagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
};


export type ShopifyCustomerProductShopifyCustomerProductVariantArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductVariantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductVariantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
};

export type ShopifyCustomerProductCount = {
  __typename?: 'ShopifyCustomerProductCount';
  ShopifyCustomerProductImage: Scalars['Int'];
  ShopifyCustomerProductTag: Scalars['Int'];
  ShopifyCustomerProductVariant: Scalars['Int'];
};

export type ShopifyCustomerProductCreateNestedOneWithoutShopifyCustomerProductVariantInput = {
  connect?: InputMaybe<ShopifyCustomerProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductCreateOrConnectWithoutShopifyCustomerProductVariantInput>;
  create?: InputMaybe<ShopifyCustomerProductCreateWithoutShopifyCustomerProductVariantInput>;
};

export type ShopifyCustomerProductCreateOrConnectWithoutShopifyCustomerProductVariantInput = {
  create: ShopifyCustomerProductCreateWithoutShopifyCustomerProductVariantInput;
  where: ShopifyCustomerProductWhereUniqueInput;
};

export type ShopifyCustomerProductCreateWithoutShopifyCustomerProductVariantInput = {
  ShopifyCustomerProductDescription?: InputMaybe<ShopifyCustomerProductDescriptionCreateNestedOneWithoutShopifyCustomerProductInput>;
  ShopifyCustomerProductImage?: InputMaybe<ShopifyCustomerProductImageCreateNestedManyWithoutShopifyCustomerProductInput>;
  ShopifyCustomerProductTag?: InputMaybe<ShopifyCustomerProductTagCreateNestedManyWithoutShopifyCustomerProductInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  bodyHtml?: InputMaybe<Scalars['String']>;
  bodyHtmlMd5?: InputMaybe<Scalars['String']>;
  cardId?: InputMaybe<Scalars['BigInt']>;
  customerId: Scalars['String'];
  handle?: InputMaybe<Scalars['String']>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<Scalars['String']>;
  metaFieldsGlobalTitleTag?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  productType?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
  templateSuffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  totalQuantity?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductCustomerIdIdCompoundUniqueInput = {
  customerId: Scalars['String'];
  id: Scalars['BigInt'];
};

export type ShopifyCustomerProductDescription = {
  __typename?: 'ShopifyCustomerProductDescription';
  ShopifyCustomerProduct: Array<ShopifyCustomerProduct>;
  _count?: Maybe<ShopifyCustomerProductDescriptionCount>;
  bodyHtml?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  productId: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ShopifyCustomerProductDescriptionShopifyCustomerProductArgs = {
  cursor?: InputMaybe<ShopifyCustomerProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ShopifyCustomerProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ShopifyCustomerProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ShopifyCustomerProductWhereInput>;
};

export type ShopifyCustomerProductDescriptionCount = {
  __typename?: 'ShopifyCustomerProductDescriptionCount';
  ShopifyCustomerProduct: Scalars['Int'];
};

export type ShopifyCustomerProductDescriptionCreateNestedOneWithoutShopifyCustomerProductInput = {
  connect?: InputMaybe<ShopifyCustomerProductDescriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductDescriptionCreateOrConnectWithoutShopifyCustomerProductInput>;
  create?: InputMaybe<ShopifyCustomerProductDescriptionCreateWithoutShopifyCustomerProductInput>;
};

export type ShopifyCustomerProductDescriptionCreateOrConnectWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductDescriptionCreateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductDescriptionWhereUniqueInput;
};

export type ShopifyCustomerProductDescriptionCreateWithoutShopifyCustomerProductInput = {
  bodyHtml?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  productId: Scalars['BigInt'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ShopifyCustomerProductDescriptionCustomerIdProductIdCompoundUniqueInput = {
  customerId: Scalars['String'];
  productId: Scalars['BigInt'];
};

export type ShopifyCustomerProductDescriptionOrderByWithRelationInput = {
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductOrderByRelationAggregateInput>;
  bodyHtml?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductDescriptionPrimaryCompoundUniqueInput = {
  customerId: Scalars['String'];
  productId: Scalars['BigInt'];
};

export type ShopifyCustomerProductDescriptionRelationFilter = {
  is?: InputMaybe<ShopifyCustomerProductDescriptionWhereInput>;
  isNot?: InputMaybe<ShopifyCustomerProductDescriptionWhereInput>;
};

export type ShopifyCustomerProductDescriptionUpdateOneWithoutShopifyCustomerProductNestedInput = {
  connect?: InputMaybe<ShopifyCustomerProductDescriptionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductDescriptionCreateOrConnectWithoutShopifyCustomerProductInput>;
  create?: InputMaybe<ShopifyCustomerProductDescriptionCreateWithoutShopifyCustomerProductInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerProductDescriptionUpdateWithoutShopifyCustomerProductInput>;
  upsert?: InputMaybe<ShopifyCustomerProductDescriptionUpsertWithoutShopifyCustomerProductInput>;
};

export type ShopifyCustomerProductDescriptionUpdateWithoutShopifyCustomerProductInput = {
  bodyHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  productId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductDescriptionUpsertWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductDescriptionCreateWithoutShopifyCustomerProductInput;
  update: ShopifyCustomerProductDescriptionUpdateWithoutShopifyCustomerProductInput;
};

export type ShopifyCustomerProductDescriptionWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductDescriptionWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductDescriptionWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductDescriptionWhereInput>>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductListRelationFilter>;
  bodyHtml?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  customerId?: InputMaybe<StringFilter>;
  productId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ShopifyCustomerProductDescriptionWhereUniqueInput = {
  Primary?: InputMaybe<ShopifyCustomerProductDescriptionPrimaryCompoundUniqueInput>;
  customerId_productId?: InputMaybe<ShopifyCustomerProductDescriptionCustomerIdProductIdCompoundUniqueInput>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerProductImage = {
  __typename?: 'ShopifyCustomerProductImage';
  ShopifyCustomerProduct?: Maybe<ShopifyCustomerProduct>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['BigInt'];
  position?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['BigInt']>;
  shopifyId: Scalars['BigInt'];
  src?: Maybe<Scalars['String']>;
  variantIds?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ShopifyCustomerProductImageCreateManyShopifyCustomerProductInput = {
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['Int']>;
  shopifyId: Scalars['BigInt'];
  src?: InputMaybe<Scalars['String']>;
  variantIds?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ShopifyCustomerProductImageCreateManyShopifyCustomerProductInputEnvelope = {
  data: Array<ShopifyCustomerProductImageCreateManyShopifyCustomerProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyCustomerProductImageCreateNestedManyWithoutShopifyCustomerProductInput = {
  connect?: InputMaybe<Array<ShopifyCustomerProductImageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerProductImageCreateOrConnectWithoutShopifyCustomerProductInput>>;
  create?: InputMaybe<Array<ShopifyCustomerProductImageCreateWithoutShopifyCustomerProductInput>>;
  createMany?: InputMaybe<ShopifyCustomerProductImageCreateManyShopifyCustomerProductInputEnvelope>;
};

export type ShopifyCustomerProductImageCreateOrConnectWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductImageCreateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductImageWhereUniqueInput;
};

export type ShopifyCustomerProductImageCreateWithoutShopifyCustomerProductInput = {
  height?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['Int']>;
  shopifyId: Scalars['BigInt'];
  src?: InputMaybe<Scalars['String']>;
  variantIds?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type ShopifyCustomerProductImageListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
  none?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
  some?: InputMaybe<ShopifyCustomerProductImageWhereInput>;
};

export type ShopifyCustomerProductImageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductImageOrderByWithRelationInput = {
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductOrderByWithRelationInput>;
  height?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  shopifyId?: InputMaybe<SortOrder>;
  src?: InputMaybe<SortOrder>;
  variantIds?: InputMaybe<SortOrder>;
  width?: InputMaybe<SortOrder>;
};

export enum ShopifyCustomerProductImageScalarFieldEnum {
  Height = 'height',
  Id = 'id',
  Position = 'position',
  ProductId = 'productId',
  ShopifyId = 'shopifyId',
  Src = 'src',
  VariantIds = 'variantIds',
  Width = 'width'
}

export type ShopifyCustomerProductImageScalarWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductImageScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductImageScalarWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductImageScalarWhereInput>>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  position?: InputMaybe<IntNullableFilter>;
  productId?: InputMaybe<BigIntNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  src?: InputMaybe<StringNullableFilter>;
  variantIds?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<IntNullableFilter>;
};

export type ShopifyCustomerProductImageUpdateManyMutationInput = {
  height?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  src?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductImageUpdateManyWithWhereWithoutShopifyCustomerProductInput = {
  data: ShopifyCustomerProductImageUpdateManyMutationInput;
  where: ShopifyCustomerProductImageScalarWhereInput;
};

export type ShopifyCustomerProductImageUpdateManyWithoutShopifyCustomerProductNestedInput = {
  connect?: InputMaybe<Array<ShopifyCustomerProductImageWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerProductImageCreateOrConnectWithoutShopifyCustomerProductInput>>;
  create?: InputMaybe<Array<ShopifyCustomerProductImageCreateWithoutShopifyCustomerProductInput>>;
  createMany?: InputMaybe<ShopifyCustomerProductImageCreateManyShopifyCustomerProductInputEnvelope>;
  delete?: InputMaybe<Array<ShopifyCustomerProductImageWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShopifyCustomerProductImageScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShopifyCustomerProductImageWhereUniqueInput>>;
  set?: InputMaybe<Array<ShopifyCustomerProductImageWhereUniqueInput>>;
  update?: InputMaybe<Array<ShopifyCustomerProductImageUpdateWithWhereUniqueWithoutShopifyCustomerProductInput>>;
  updateMany?: InputMaybe<Array<ShopifyCustomerProductImageUpdateManyWithWhereWithoutShopifyCustomerProductInput>>;
  upsert?: InputMaybe<Array<ShopifyCustomerProductImageUpsertWithWhereUniqueWithoutShopifyCustomerProductInput>>;
};

export type ShopifyCustomerProductImageUpdateWithWhereUniqueWithoutShopifyCustomerProductInput = {
  data: ShopifyCustomerProductImageUpdateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductImageWhereUniqueInput;
};

export type ShopifyCustomerProductImageUpdateWithoutShopifyCustomerProductInput = {
  height?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  src?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantIds?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  width?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductImageUpsertWithWhereUniqueWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductImageCreateWithoutShopifyCustomerProductInput;
  update: ShopifyCustomerProductImageUpdateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductImageWhereUniqueInput;
};

export type ShopifyCustomerProductImageWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductImageWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductImageWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductImageWhereInput>>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductRelationFilter>;
  height?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  position?: InputMaybe<IntNullableFilter>;
  productId?: InputMaybe<BigIntNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  src?: InputMaybe<StringNullableFilter>;
  variantIds?: InputMaybe<StringNullableFilter>;
  width?: InputMaybe<IntNullableFilter>;
};

export type ShopifyCustomerProductImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerProductListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerProductWhereInput>;
  none?: InputMaybe<ShopifyCustomerProductWhereInput>;
  some?: InputMaybe<ShopifyCustomerProductWhereInput>;
};

export type ShopifyCustomerProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductOrderByWithRelationInput = {
  ShopifyCustomerProductDescription?: InputMaybe<ShopifyCustomerProductDescriptionOrderByWithRelationInput>;
  ShopifyCustomerProductImage?: InputMaybe<ShopifyCustomerProductImageOrderByRelationAggregateInput>;
  ShopifyCustomerProductTag?: InputMaybe<ShopifyCustomerProductTagOrderByRelationAggregateInput>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantOrderByRelationAggregateInput>;
  archived?: InputMaybe<SortOrder>;
  bodyHtml?: InputMaybe<SortOrder>;
  bodyHtmlMd5?: InputMaybe<SortOrder>;
  cardId?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  handle?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<SortOrder>;
  metaFieldsGlobalTitleTag?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productType?: InputMaybe<SortOrder>;
  tags?: InputMaybe<SortOrder>;
  templateSuffix?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductRelationFilter = {
  is?: InputMaybe<ShopifyCustomerProductWhereInput>;
  isNot?: InputMaybe<ShopifyCustomerProductWhereInput>;
};

export enum ShopifyCustomerProductScalarFieldEnum {
  Archived = 'archived',
  BodyHtml = 'bodyHtml',
  BodyHtmlMd5 = 'bodyHtmlMd5',
  CardId = 'cardId',
  CustomerId = 'customerId',
  Handle = 'handle',
  Id = 'id',
  MetaFieldsGlobalDescriptionTag = 'metaFieldsGlobalDescriptionTag',
  MetaFieldsGlobalTitleTag = 'metaFieldsGlobalTitleTag',
  ProductId = 'productId',
  ProductType = 'productType',
  Tags = 'tags',
  TemplateSuffix = 'templateSuffix',
  Title = 'title',
  TotalQuantity = 'totalQuantity',
  Type = 'type',
  Vendor = 'vendor'
}

export type ShopifyCustomerProductTag = {
  __typename?: 'ShopifyCustomerProductTag';
  ShopifyCustomerProduct?: Maybe<ShopifyCustomerProduct>;
  id: Scalars['BigInt'];
  shopifyCustomerProductId?: Maybe<Scalars['BigInt']>;
  tag?: Maybe<Scalars['String']>;
};

export type ShopifyCustomerProductTagCreateManyShopifyCustomerProductInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductTagCreateManyShopifyCustomerProductInputEnvelope = {
  data: Array<ShopifyCustomerProductTagCreateManyShopifyCustomerProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ShopifyCustomerProductTagCreateNestedManyWithoutShopifyCustomerProductInput = {
  connect?: InputMaybe<Array<ShopifyCustomerProductTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerProductTagCreateOrConnectWithoutShopifyCustomerProductInput>>;
  create?: InputMaybe<Array<ShopifyCustomerProductTagCreateWithoutShopifyCustomerProductInput>>;
  createMany?: InputMaybe<ShopifyCustomerProductTagCreateManyShopifyCustomerProductInputEnvelope>;
};

export type ShopifyCustomerProductTagCreateOrConnectWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductTagCreateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductTagWhereUniqueInput;
};

export type ShopifyCustomerProductTagCreateWithoutShopifyCustomerProductInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductTagListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
  none?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
  some?: InputMaybe<ShopifyCustomerProductTagWhereInput>;
};

export type ShopifyCustomerProductTagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductTagOrderByWithRelationInput = {
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  shopifyCustomerProductId?: InputMaybe<SortOrder>;
  tag?: InputMaybe<SortOrder>;
};

export enum ShopifyCustomerProductTagScalarFieldEnum {
  Id = 'id',
  ShopifyCustomerProductId = 'shopifyCustomerProductId',
  Tag = 'tag'
}

export type ShopifyCustomerProductTagScalarWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductTagScalarWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductTagScalarWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductTagScalarWhereInput>>;
  id?: InputMaybe<BigIntFilter>;
  shopifyCustomerProductId?: InputMaybe<BigIntNullableFilter>;
  tag?: InputMaybe<StringNullableFilter>;
};

export type ShopifyCustomerProductTagUKaq2w15uah8mj9dsjtbrr2kbp1CompoundUniqueInput = {
  shopifyCustomerProductId: Scalars['BigInt'];
  tag: Scalars['String'];
};

export type ShopifyCustomerProductTagUpdateManyMutationInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  tag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductTagUpdateManyWithWhereWithoutShopifyCustomerProductInput = {
  data: ShopifyCustomerProductTagUpdateManyMutationInput;
  where: ShopifyCustomerProductTagScalarWhereInput;
};

export type ShopifyCustomerProductTagUpdateManyWithoutShopifyCustomerProductNestedInput = {
  connect?: InputMaybe<Array<ShopifyCustomerProductTagWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ShopifyCustomerProductTagCreateOrConnectWithoutShopifyCustomerProductInput>>;
  create?: InputMaybe<Array<ShopifyCustomerProductTagCreateWithoutShopifyCustomerProductInput>>;
  createMany?: InputMaybe<ShopifyCustomerProductTagCreateManyShopifyCustomerProductInputEnvelope>;
  delete?: InputMaybe<Array<ShopifyCustomerProductTagWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ShopifyCustomerProductTagScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ShopifyCustomerProductTagWhereUniqueInput>>;
  set?: InputMaybe<Array<ShopifyCustomerProductTagWhereUniqueInput>>;
  update?: InputMaybe<Array<ShopifyCustomerProductTagUpdateWithWhereUniqueWithoutShopifyCustomerProductInput>>;
  updateMany?: InputMaybe<Array<ShopifyCustomerProductTagUpdateManyWithWhereWithoutShopifyCustomerProductInput>>;
  upsert?: InputMaybe<Array<ShopifyCustomerProductTagUpsertWithWhereUniqueWithoutShopifyCustomerProductInput>>;
};

export type ShopifyCustomerProductTagUpdateWithWhereUniqueWithoutShopifyCustomerProductInput = {
  data: ShopifyCustomerProductTagUpdateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductTagWhereUniqueInput;
};

export type ShopifyCustomerProductTagUpdateWithoutShopifyCustomerProductInput = {
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  tag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductTagUpsertWithWhereUniqueWithoutShopifyCustomerProductInput = {
  create: ShopifyCustomerProductTagCreateWithoutShopifyCustomerProductInput;
  update: ShopifyCustomerProductTagUpdateWithoutShopifyCustomerProductInput;
  where: ShopifyCustomerProductTagWhereUniqueInput;
};

export type ShopifyCustomerProductTagWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductTagWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductTagWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductTagWhereInput>>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductRelationFilter>;
  id?: InputMaybe<BigIntFilter>;
  shopifyCustomerProductId?: InputMaybe<BigIntNullableFilter>;
  tag?: InputMaybe<StringNullableFilter>;
};

export type ShopifyCustomerProductTagWhereUniqueInput = {
  UKaq2w15uah8mj9dsjtbrr2kbp1?: InputMaybe<ShopifyCustomerProductTagUKaq2w15uah8mj9dsjtbrr2kbp1CompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerProductUpdateOneWithoutShopifyCustomerProductVariantNestedInput = {
  connect?: InputMaybe<ShopifyCustomerProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductCreateOrConnectWithoutShopifyCustomerProductVariantInput>;
  create?: InputMaybe<ShopifyCustomerProductCreateWithoutShopifyCustomerProductVariantInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerProductUpdateWithoutShopifyCustomerProductVariantInput>;
  upsert?: InputMaybe<ShopifyCustomerProductUpsertWithoutShopifyCustomerProductVariantInput>;
};

export type ShopifyCustomerProductUpdateWithoutShopifyCustomerProductVariantInput = {
  ShopifyCustomerProductDescription?: InputMaybe<ShopifyCustomerProductDescriptionUpdateOneWithoutShopifyCustomerProductNestedInput>;
  ShopifyCustomerProductImage?: InputMaybe<ShopifyCustomerProductImageUpdateManyWithoutShopifyCustomerProductNestedInput>;
  ShopifyCustomerProductTag?: InputMaybe<ShopifyCustomerProductTagUpdateManyWithoutShopifyCustomerProductNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  bodyHtml?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  bodyHtmlMd5?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  handle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metaFieldsGlobalTitleTag?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  productId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  productType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tags?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  templateSuffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductUpsertWithoutShopifyCustomerProductVariantInput = {
  create: ShopifyCustomerProductCreateWithoutShopifyCustomerProductVariantInput;
  update: ShopifyCustomerProductUpdateWithoutShopifyCustomerProductVariantInput;
};

export type ShopifyCustomerProductVariant = {
  __typename?: 'ShopifyCustomerProductVariant';
  CartItem: Array<CartItem>;
  CartItemInventoryAdjustment: Array<CartItemInventoryAdjustment>;
  JobQueue: Array<JobQueue>;
  ProductsToProcess: Array<ProductsToProcess>;
  ShopifyCustomerProduct?: Maybe<ShopifyCustomerProduct>;
  _count?: Maybe<ShopifyCustomerProductVariantCount>;
  archived?: Maybe<Scalars['Boolean']>;
  barcode?: Maybe<Scalars['String']>;
  buyPrice?: Maybe<Scalars['Decimal']>;
  buyPricePercent?: Maybe<Scalars['Float']>;
  compareAtPrice?: Maybe<Scalars['String']>;
  customerProductId?: Maybe<Scalars['BigInt']>;
  fulfillmentService?: Maybe<Scalars['String']>;
  grams?: Maybe<Scalars['Float']>;
  id: Scalars['BigInt'];
  inventoryItemId?: Maybe<Scalars['BigInt']>;
  inventoryManagement?: Maybe<Scalars['String']>;
  inventoryPolicy?: Maybe<Scalars['String']>;
  inventoryQuantity?: Maybe<Scalars['BigInt']>;
  maxInstock?: Maybe<Scalars['Int']>;
  maxInstockBuyPercent?: Maybe<Scalars['Float']>;
  maxInstockBuyPrice?: Maybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPrice?: Maybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPricePercent?: Maybe<Scalars['Float']>;
  option1?: Maybe<Scalars['String']>;
  option2?: Maybe<Scalars['String']>;
  option3?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['BigInt']>;
  price?: Maybe<Scalars['String']>;
  priceOverride?: Maybe<Scalars['Decimal']>;
  requiresShipping?: Maybe<Scalars['Boolean']>;
  sku?: Maybe<Scalars['String']>;
  storeCreditBuyPrice?: Maybe<Scalars['Decimal']>;
  storeCreditBuyPricePercent?: Maybe<Scalars['Float']>;
  taxCode?: Maybe<Scalars['String']>;
  taxable?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
  variantId?: Maybe<Scalars['BigInt']>;
  weight?: Maybe<Scalars['Float']>;
  weightUnit?: Maybe<Scalars['String']>;
};


export type ShopifyCustomerProductVariantCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type ShopifyCustomerProductVariantCartItemInventoryAdjustmentArgs = {
  cursor?: InputMaybe<CartItemInventoryAdjustmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemInventoryAdjustmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemInventoryAdjustmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CartItemInventoryAdjustmentWhereInput>;
};


export type ShopifyCustomerProductVariantJobQueueArgs = {
  cursor?: InputMaybe<JobQueueWhereUniqueInput>;
  distinct?: InputMaybe<Array<JobQueueScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<JobQueueOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<JobQueueWhereInput>;
};


export type ShopifyCustomerProductVariantProductsToProcessArgs = {
  cursor?: InputMaybe<ProductsToProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductsToProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductsToProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsToProcessWhereInput>;
};

export type ShopifyCustomerProductVariantCount = {
  __typename?: 'ShopifyCustomerProductVariantCount';
  CartItem: Scalars['Int'];
  CartItemInventoryAdjustment: Scalars['Int'];
  JobQueue: Scalars['Int'];
  ProductsToProcess: Scalars['Int'];
};

export type ShopifyCustomerProductVariantCreateNestedOneWithoutCartItemInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutCartItemInput>;
};

export type ShopifyCustomerProductVariantCreateNestedOneWithoutCartItemInventoryAdjustmentInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInventoryAdjustmentInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutCartItemInventoryAdjustmentInput>;
};

export type ShopifyCustomerProductVariantCreateNestedOneWithoutProductsToProcessInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutProductsToProcessInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutProductsToProcessInput>;
};

export type ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInput = {
  create: ShopifyCustomerProductVariantCreateWithoutCartItemInput;
  where: ShopifyCustomerProductVariantWhereUniqueInput;
};

export type ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInventoryAdjustmentInput = {
  create: ShopifyCustomerProductVariantCreateWithoutCartItemInventoryAdjustmentInput;
  where: ShopifyCustomerProductVariantWhereUniqueInput;
};

export type ShopifyCustomerProductVariantCreateOrConnectWithoutProductsToProcessInput = {
  create: ShopifyCustomerProductVariantCreateWithoutProductsToProcessInput;
  where: ShopifyCustomerProductVariantWhereUniqueInput;
};

export type ShopifyCustomerProductVariantCreateWithoutCartItemInput = {
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  JobQueue?: InputMaybe<JobQueueCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductCreateNestedOneWithoutShopifyCustomerProductVariantInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  buyPrice?: InputMaybe<Scalars['Decimal']>;
  buyPricePercent?: InputMaybe<Scalars['Float']>;
  compareAtPrice?: InputMaybe<Scalars['String']>;
  fulfillmentService?: InputMaybe<Scalars['String']>;
  grams?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  inventoryItemId?: InputMaybe<Scalars['BigInt']>;
  inventoryManagement?: InputMaybe<Scalars['String']>;
  inventoryPolicy?: InputMaybe<Scalars['String']>;
  inventoryQuantity?: InputMaybe<Scalars['BigInt']>;
  maxInstock?: InputMaybe<Scalars['Int']>;
  maxInstockBuyPercent?: InputMaybe<Scalars['Float']>;
  maxInstockBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  option1?: InputMaybe<Scalars['String']>;
  option2?: InputMaybe<Scalars['String']>;
  option3?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['String']>;
  priceOverride?: InputMaybe<Scalars['Decimal']>;
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  storeCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  storeCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  taxCode?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductVariantCreateWithoutCartItemInventoryAdjustmentInput = {
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  JobQueue?: InputMaybe<JobQueueCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductCreateNestedOneWithoutShopifyCustomerProductVariantInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  buyPrice?: InputMaybe<Scalars['Decimal']>;
  buyPricePercent?: InputMaybe<Scalars['Float']>;
  compareAtPrice?: InputMaybe<Scalars['String']>;
  fulfillmentService?: InputMaybe<Scalars['String']>;
  grams?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  inventoryItemId?: InputMaybe<Scalars['BigInt']>;
  inventoryManagement?: InputMaybe<Scalars['String']>;
  inventoryPolicy?: InputMaybe<Scalars['String']>;
  inventoryQuantity?: InputMaybe<Scalars['BigInt']>;
  maxInstock?: InputMaybe<Scalars['Int']>;
  maxInstockBuyPercent?: InputMaybe<Scalars['Float']>;
  maxInstockBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  option1?: InputMaybe<Scalars['String']>;
  option2?: InputMaybe<Scalars['String']>;
  option3?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['String']>;
  priceOverride?: InputMaybe<Scalars['Decimal']>;
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  storeCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  storeCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  taxCode?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductVariantCreateWithoutProductsToProcessInput = {
  CartItem?: InputMaybe<CartItemCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  JobQueue?: InputMaybe<JobQueueCreateNestedManyWithoutShopifyCustomerProductVariantInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductCreateNestedOneWithoutShopifyCustomerProductVariantInput>;
  archived?: InputMaybe<Scalars['Boolean']>;
  barcode?: InputMaybe<Scalars['String']>;
  buyPrice?: InputMaybe<Scalars['Decimal']>;
  buyPricePercent?: InputMaybe<Scalars['Float']>;
  compareAtPrice?: InputMaybe<Scalars['String']>;
  fulfillmentService?: InputMaybe<Scalars['String']>;
  grams?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['BigInt']>;
  inventoryItemId?: InputMaybe<Scalars['BigInt']>;
  inventoryManagement?: InputMaybe<Scalars['String']>;
  inventoryPolicy?: InputMaybe<Scalars['String']>;
  inventoryQuantity?: InputMaybe<Scalars['BigInt']>;
  maxInstock?: InputMaybe<Scalars['Int']>;
  maxInstockBuyPercent?: InputMaybe<Scalars['Float']>;
  maxInstockBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  option1?: InputMaybe<Scalars['String']>;
  option2?: InputMaybe<Scalars['String']>;
  option3?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['String']>;
  priceOverride?: InputMaybe<Scalars['Decimal']>;
  requiresShipping?: InputMaybe<Scalars['Boolean']>;
  sku?: InputMaybe<Scalars['String']>;
  storeCreditBuyPrice?: InputMaybe<Scalars['Decimal']>;
  storeCreditBuyPricePercent?: InputMaybe<Scalars['Float']>;
  taxCode?: InputMaybe<Scalars['String']>;
  taxable?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<Scalars['String']>;
};

export type ShopifyCustomerProductVariantListRelationFilter = {
  every?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
  none?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
  some?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
};

export type ShopifyCustomerProductVariantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductVariantOrderByWithRelationInput = {
  CartItem?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentOrderByRelationAggregateInput>;
  JobQueue?: InputMaybe<JobQueueOrderByRelationAggregateInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessOrderByRelationAggregateInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductOrderByWithRelationInput>;
  archived?: InputMaybe<SortOrder>;
  barcode?: InputMaybe<SortOrder>;
  buyPrice?: InputMaybe<SortOrder>;
  buyPricePercent?: InputMaybe<SortOrder>;
  compareAtPrice?: InputMaybe<SortOrder>;
  customerProductId?: InputMaybe<SortOrder>;
  fulfillmentService?: InputMaybe<SortOrder>;
  grams?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  inventoryItemId?: InputMaybe<SortOrder>;
  inventoryManagement?: InputMaybe<SortOrder>;
  inventoryPolicy?: InputMaybe<SortOrder>;
  inventoryQuantity?: InputMaybe<SortOrder>;
  maxInstock?: InputMaybe<SortOrder>;
  maxInstockBuyPercent?: InputMaybe<SortOrder>;
  maxInstockBuyPrice?: InputMaybe<SortOrder>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<SortOrder>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<SortOrder>;
  option1?: InputMaybe<SortOrder>;
  option2?: InputMaybe<SortOrder>;
  option3?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceOverride?: InputMaybe<SortOrder>;
  requiresShipping?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  storeCreditBuyPrice?: InputMaybe<SortOrder>;
  storeCreditBuyPricePercent?: InputMaybe<SortOrder>;
  taxCode?: InputMaybe<SortOrder>;
  taxable?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  variantId?: InputMaybe<SortOrder>;
  weight?: InputMaybe<SortOrder>;
  weightUnit?: InputMaybe<SortOrder>;
};

export type ShopifyCustomerProductVariantRelationFilter = {
  is?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
  isNot?: InputMaybe<ShopifyCustomerProductVariantWhereInput>;
};

export enum ShopifyCustomerProductVariantScalarFieldEnum {
  Archived = 'archived',
  Barcode = 'barcode',
  BuyPrice = 'buyPrice',
  BuyPricePercent = 'buyPricePercent',
  CompareAtPrice = 'compareAtPrice',
  CustomerProductId = 'customerProductId',
  FulfillmentService = 'fulfillmentService',
  Grams = 'grams',
  Id = 'id',
  InventoryItemId = 'inventoryItemId',
  InventoryManagement = 'inventoryManagement',
  InventoryPolicy = 'inventoryPolicy',
  InventoryQuantity = 'inventoryQuantity',
  MaxInstock = 'maxInstock',
  MaxInstockBuyPercent = 'maxInstockBuyPercent',
  MaxInstockBuyPrice = 'maxInstockBuyPrice',
  MaxInstockStoreCreditBuyPrice = 'maxInstockStoreCreditBuyPrice',
  MaxInstockStoreCreditBuyPricePercent = 'maxInstockStoreCreditBuyPricePercent',
  Option1 = 'option1',
  Option2 = 'option2',
  Option3 = 'option3',
  Position = 'position',
  Price = 'price',
  PriceOverride = 'priceOverride',
  RequiresShipping = 'requiresShipping',
  Sku = 'sku',
  StoreCreditBuyPrice = 'storeCreditBuyPrice',
  StoreCreditBuyPricePercent = 'storeCreditBuyPricePercent',
  TaxCode = 'taxCode',
  Taxable = 'taxable',
  Title = 'title',
  VariantId = 'variantId',
  Weight = 'weight',
  WeightUnit = 'weightUnit'
}

export type ShopifyCustomerProductVariantUpdateOneWithoutCartItemInventoryAdjustmentNestedInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInventoryAdjustmentInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutCartItemInventoryAdjustmentInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerProductVariantUpdateWithoutCartItemInventoryAdjustmentInput>;
  upsert?: InputMaybe<ShopifyCustomerProductVariantUpsertWithoutCartItemInventoryAdjustmentInput>;
};

export type ShopifyCustomerProductVariantUpdateOneWithoutCartItemNestedInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutCartItemInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerProductVariantUpdateWithoutCartItemInput>;
  upsert?: InputMaybe<ShopifyCustomerProductVariantUpsertWithoutCartItemInput>;
};

export type ShopifyCustomerProductVariantUpdateOneWithoutProductsToProcessNestedInput = {
  connect?: InputMaybe<ShopifyCustomerProductVariantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerProductVariantCreateOrConnectWithoutProductsToProcessInput>;
  create?: InputMaybe<ShopifyCustomerProductVariantCreateWithoutProductsToProcessInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerProductVariantUpdateWithoutProductsToProcessInput>;
  upsert?: InputMaybe<ShopifyCustomerProductVariantUpsertWithoutProductsToProcessInput>;
};

export type ShopifyCustomerProductVariantUpdateWithoutCartItemInput = {
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  JobQueue?: InputMaybe<JobQueueUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductUpdateOneWithoutShopifyCustomerProductVariantNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  barcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  compareAtPrice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grams?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  inventoryItemId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  inventoryManagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryQuantity?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  maxInstock?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maxInstockBuyPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxInstockBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  option1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceOverride?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requiresShipping?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  storeCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  storeCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  taxCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  weightUnit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductVariantUpdateWithoutCartItemInventoryAdjustmentInput = {
  CartItem?: InputMaybe<CartItemUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  JobQueue?: InputMaybe<JobQueueUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  ProductsToProcess?: InputMaybe<ProductsToProcessUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductUpdateOneWithoutShopifyCustomerProductVariantNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  barcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  compareAtPrice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grams?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  inventoryItemId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  inventoryManagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryQuantity?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  maxInstock?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maxInstockBuyPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxInstockBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  option1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceOverride?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requiresShipping?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  storeCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  storeCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  taxCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  weightUnit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductVariantUpdateWithoutProductsToProcessInput = {
  CartItem?: InputMaybe<CartItemUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  JobQueue?: InputMaybe<JobQueueUpdateManyWithoutShopifyCustomerProductVariantNestedInput>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductUpdateOneWithoutShopifyCustomerProductVariantNestedInput>;
  archived?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  barcode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  buyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  compareAtPrice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fulfillmentService?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  grams?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  inventoryItemId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  inventoryManagement?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryPolicy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  inventoryQuantity?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  maxInstock?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  maxInstockBuyPercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  maxInstockBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  option1?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option2?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  option3?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  position?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  price?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceOverride?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requiresShipping?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  storeCreditBuyPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  storeCreditBuyPricePercent?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  taxCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  taxable?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  variantId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  weight?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  weightUnit?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ShopifyCustomerProductVariantUpsertWithoutCartItemInput = {
  create: ShopifyCustomerProductVariantCreateWithoutCartItemInput;
  update: ShopifyCustomerProductVariantUpdateWithoutCartItemInput;
};

export type ShopifyCustomerProductVariantUpsertWithoutCartItemInventoryAdjustmentInput = {
  create: ShopifyCustomerProductVariantCreateWithoutCartItemInventoryAdjustmentInput;
  update: ShopifyCustomerProductVariantUpdateWithoutCartItemInventoryAdjustmentInput;
};

export type ShopifyCustomerProductVariantUpsertWithoutProductsToProcessInput = {
  create: ShopifyCustomerProductVariantCreateWithoutProductsToProcessInput;
  update: ShopifyCustomerProductVariantUpdateWithoutProductsToProcessInput;
};

export type ShopifyCustomerProductVariantWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductVariantWhereInput>>;
  CartItem?: InputMaybe<CartItemListRelationFilter>;
  CartItemInventoryAdjustment?: InputMaybe<CartItemInventoryAdjustmentListRelationFilter>;
  JobQueue?: InputMaybe<JobQueueListRelationFilter>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductVariantWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductVariantWhereInput>>;
  ProductsToProcess?: InputMaybe<ProductsToProcessListRelationFilter>;
  ShopifyCustomerProduct?: InputMaybe<ShopifyCustomerProductRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  barcode?: InputMaybe<StringNullableFilter>;
  buyPrice?: InputMaybe<DecimalNullableFilter>;
  buyPricePercent?: InputMaybe<FloatNullableFilter>;
  compareAtPrice?: InputMaybe<StringNullableFilter>;
  customerProductId?: InputMaybe<BigIntNullableFilter>;
  fulfillmentService?: InputMaybe<StringNullableFilter>;
  grams?: InputMaybe<FloatNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  inventoryItemId?: InputMaybe<BigIntNullableFilter>;
  inventoryManagement?: InputMaybe<StringNullableFilter>;
  inventoryPolicy?: InputMaybe<StringNullableFilter>;
  inventoryQuantity?: InputMaybe<BigIntNullableFilter>;
  maxInstock?: InputMaybe<IntNullableFilter>;
  maxInstockBuyPercent?: InputMaybe<FloatNullableFilter>;
  maxInstockBuyPrice?: InputMaybe<DecimalNullableFilter>;
  maxInstockStoreCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  maxInstockStoreCreditBuyPricePercent?: InputMaybe<FloatNullableFilter>;
  option1?: InputMaybe<StringNullableFilter>;
  option2?: InputMaybe<StringNullableFilter>;
  option3?: InputMaybe<StringNullableFilter>;
  position?: InputMaybe<BigIntNullableFilter>;
  price?: InputMaybe<StringNullableFilter>;
  priceOverride?: InputMaybe<DecimalNullableFilter>;
  requiresShipping?: InputMaybe<BoolNullableFilter>;
  sku?: InputMaybe<StringNullableFilter>;
  storeCreditBuyPrice?: InputMaybe<DecimalNullableFilter>;
  storeCreditBuyPricePercent?: InputMaybe<FloatNullableFilter>;
  taxCode?: InputMaybe<StringNullableFilter>;
  taxable?: InputMaybe<BoolNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  variantId?: InputMaybe<BigIntNullableFilter>;
  weight?: InputMaybe<FloatNullableFilter>;
  weightUnit?: InputMaybe<StringNullableFilter>;
};

export type ShopifyCustomerProductVariantWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  variantId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerProductWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerProductWhereInput>>;
  NOT?: InputMaybe<Array<ShopifyCustomerProductWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerProductWhereInput>>;
  ShopifyCustomerProductDescription?: InputMaybe<ShopifyCustomerProductDescriptionRelationFilter>;
  ShopifyCustomerProductImage?: InputMaybe<ShopifyCustomerProductImageListRelationFilter>;
  ShopifyCustomerProductTag?: InputMaybe<ShopifyCustomerProductTagListRelationFilter>;
  ShopifyCustomerProductVariant?: InputMaybe<ShopifyCustomerProductVariantListRelationFilter>;
  archived?: InputMaybe<BoolNullableFilter>;
  bodyHtml?: InputMaybe<StringNullableFilter>;
  bodyHtmlMd5?: InputMaybe<StringNullableFilter>;
  cardId?: InputMaybe<BigIntNullableFilter>;
  customerId?: InputMaybe<StringFilter>;
  handle?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  metaFieldsGlobalDescriptionTag?: InputMaybe<StringNullableFilter>;
  metaFieldsGlobalTitleTag?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<BigIntNullableFilter>;
  productType?: InputMaybe<StringNullableFilter>;
  tags?: InputMaybe<StringNullableFilter>;
  templateSuffix?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  totalQuantity?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
  vendor?: InputMaybe<StringNullableFilter>;
};

export type ShopifyCustomerProductWhereUniqueInput = {
  customerId_id?: InputMaybe<ShopifyCustomerProductCustomerIdIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyCustomerRelationFilter = {
  is?: InputMaybe<ShopifyCustomerWhereInput>;
  isNot?: InputMaybe<ShopifyCustomerWhereInput>;
};

export enum ShopifyCustomerScalarFieldEnum {
  CustomerId = 'customerId',
  Disabled = 'disabled',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  LastOrderId = 'lastOrderId',
  LastOrderName = 'lastOrderName',
  Notes = 'notes',
  Phone = 'phone',
  ShopifyId = 'shopifyId',
  StoreCredit = 'storeCredit',
  TaxExempt = 'taxExempt',
  TotalSpent = 'totalSpent'
}

export type ShopifyCustomerUpdateOneWithoutCartNestedInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutCartInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutCartInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerUpdateWithoutCartInput>;
  upsert?: InputMaybe<ShopifyCustomerUpsertWithoutCartInput>;
};

export type ShopifyCustomerUpdateOneWithoutShopifyCustomerBuylistNestedInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutShopifyCustomerBuylistInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutShopifyCustomerBuylistInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerUpdateWithoutShopifyCustomerBuylistInput>;
  upsert?: InputMaybe<ShopifyCustomerUpsertWithoutShopifyCustomerBuylistInput>;
};

export type ShopifyCustomerUpdateOneWithoutStoreCreditHistoryNestedInput = {
  connect?: InputMaybe<ShopifyCustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyCustomerCreateOrConnectWithoutStoreCreditHistoryInput>;
  create?: InputMaybe<ShopifyCustomerCreateWithoutStoreCreditHistoryInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ShopifyCustomerUpdateWithoutStoreCreditHistoryInput>;
  upsert?: InputMaybe<ShopifyCustomerUpsertWithoutStoreCreditHistoryInput>;
};

export type ShopifyCustomerUpdateWithoutCartInput = {
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistUpdateManyWithoutShopifyCustomerNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutShopifyCustomerNestedInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  lastOrderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storeCredit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  taxExempt?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  totalSpent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type ShopifyCustomerUpdateWithoutShopifyCustomerBuylistInput = {
  Cart?: InputMaybe<CartUpdateManyWithoutShopifyCustomerNestedInput>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryUpdateManyWithoutShopifyCustomerNestedInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  lastOrderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storeCredit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  taxExempt?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  totalSpent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type ShopifyCustomerUpdateWithoutStoreCreditHistoryInput = {
  Cart?: InputMaybe<CartUpdateManyWithoutShopifyCustomerNestedInput>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistUpdateManyWithoutShopifyCustomerNestedInput>;
  customerId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastOrderId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  lastOrderName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  notes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyId?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  storeCredit?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  taxExempt?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  totalSpent?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type ShopifyCustomerUpsertWithoutCartInput = {
  create: ShopifyCustomerCreateWithoutCartInput;
  update: ShopifyCustomerUpdateWithoutCartInput;
};

export type ShopifyCustomerUpsertWithoutShopifyCustomerBuylistInput = {
  create: ShopifyCustomerCreateWithoutShopifyCustomerBuylistInput;
  update: ShopifyCustomerUpdateWithoutShopifyCustomerBuylistInput;
};

export type ShopifyCustomerUpsertWithoutStoreCreditHistoryInput = {
  create: ShopifyCustomerCreateWithoutStoreCreditHistoryInput;
  update: ShopifyCustomerUpdateWithoutStoreCreditHistoryInput;
};

export type ShopifyCustomerWhereInput = {
  AND?: InputMaybe<Array<ShopifyCustomerWhereInput>>;
  Cart?: InputMaybe<CartListRelationFilter>;
  NOT?: InputMaybe<Array<ShopifyCustomerWhereInput>>;
  OR?: InputMaybe<Array<ShopifyCustomerWhereInput>>;
  ShopifyCustomerBuylist?: InputMaybe<ShopifyCustomerBuylistListRelationFilter>;
  StoreCreditHistory?: InputMaybe<StoreCreditHistoryListRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<BoolFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  lastOrderId?: InputMaybe<BigIntNullableFilter>;
  lastOrderName?: InputMaybe<StringNullableFilter>;
  notes?: InputMaybe<StringNullableFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  shopifyId?: InputMaybe<BigIntFilter>;
  storeCredit?: InputMaybe<DecimalFilter>;
  taxExempt?: InputMaybe<BoolNullableFilter>;
  totalSpent?: InputMaybe<DecimalNullableFilter>;
};

export type ShopifyCustomerWhereUniqueInput = {
  customerIdAndShopifyIdUnique?: InputMaybe<ShopifyCustomerCustomerIdAndShopifyIdUniqueCompoundUniqueInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  shopifyId?: InputMaybe<Scalars['BigInt']>;
};

export type ShopifyThemeRelease = {
  __typename?: 'ShopifyThemeRelease';
  BinderCustomerShopifyTheme: Array<BinderCustomerShopifyTheme>;
  _count?: Maybe<ShopifyThemeReleaseCount>;
  releaseDate: Scalars['DateTime'];
  summary?: Maybe<Scalars['String']>;
  theme: Scalars['String'];
  version: Scalars['String'];
};


export type ShopifyThemeReleaseBinderCustomerShopifyThemeArgs = {
  cursor?: InputMaybe<BinderCustomerShopifyThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<BinderCustomerShopifyThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BinderCustomerShopifyThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
};

export type ShopifyThemeReleaseCount = {
  __typename?: 'ShopifyThemeReleaseCount';
  BinderCustomerShopifyTheme: Scalars['Int'];
};

export type ShopifyThemeReleaseCreateInput = {
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeCreateNestedManyWithoutShopifyThemeReleaseInput>;
  releaseDate: Scalars['DateTime'];
  summary?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  version: Scalars['String'];
};

export type ShopifyThemeReleaseCreateNestedOneWithoutBinderCustomerShopifyThemeInput = {
  connect?: InputMaybe<ShopifyThemeReleaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyThemeReleaseCreateOrConnectWithoutBinderCustomerShopifyThemeInput>;
  create?: InputMaybe<ShopifyThemeReleaseCreateWithoutBinderCustomerShopifyThemeInput>;
};

export type ShopifyThemeReleaseCreateOrConnectWithoutBinderCustomerShopifyThemeInput = {
  create: ShopifyThemeReleaseCreateWithoutBinderCustomerShopifyThemeInput;
  where: ShopifyThemeReleaseWhereUniqueInput;
};

export type ShopifyThemeReleaseCreateWithoutBinderCustomerShopifyThemeInput = {
  releaseDate: Scalars['DateTime'];
  summary?: InputMaybe<Scalars['String']>;
  theme: Scalars['String'];
  version: Scalars['String'];
};

export type ShopifyThemeReleaseOrderByWithRelationInput = {
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeOrderByRelationAggregateInput>;
  releaseDate?: InputMaybe<SortOrder>;
  summary?: InputMaybe<SortOrder>;
  theme?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type ShopifyThemeReleaseRelationFilter = {
  is?: InputMaybe<ShopifyThemeReleaseWhereInput>;
  isNot?: InputMaybe<ShopifyThemeReleaseWhereInput>;
};

export enum ShopifyThemeReleaseScalarFieldEnum {
  ReleaseDate = 'releaseDate',
  Summary = 'summary',
  Theme = 'theme',
  Version = 'version'
}

export type ShopifyThemeReleaseThemeVersionCompoundUniqueInput = {
  theme: Scalars['String'];
  version: Scalars['String'];
};

export type ShopifyThemeReleaseUpdateOneRequiredWithoutBinderCustomerShopifyThemeNestedInput = {
  connect?: InputMaybe<ShopifyThemeReleaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ShopifyThemeReleaseCreateOrConnectWithoutBinderCustomerShopifyThemeInput>;
  create?: InputMaybe<ShopifyThemeReleaseCreateWithoutBinderCustomerShopifyThemeInput>;
  update?: InputMaybe<ShopifyThemeReleaseUpdateWithoutBinderCustomerShopifyThemeInput>;
  upsert?: InputMaybe<ShopifyThemeReleaseUpsertWithoutBinderCustomerShopifyThemeInput>;
};

export type ShopifyThemeReleaseUpdateWithoutBinderCustomerShopifyThemeInput = {
  releaseDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  summary?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  theme?: InputMaybe<StringFieldUpdateOperationsInput>;
  version?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ShopifyThemeReleaseUpsertWithoutBinderCustomerShopifyThemeInput = {
  create: ShopifyThemeReleaseCreateWithoutBinderCustomerShopifyThemeInput;
  update: ShopifyThemeReleaseUpdateWithoutBinderCustomerShopifyThemeInput;
};

export type ShopifyThemeReleaseWhereInput = {
  AND?: InputMaybe<Array<ShopifyThemeReleaseWhereInput>>;
  BinderCustomerShopifyTheme?: InputMaybe<BinderCustomerShopifyThemeListRelationFilter>;
  NOT?: InputMaybe<Array<ShopifyThemeReleaseWhereInput>>;
  OR?: InputMaybe<Array<ShopifyThemeReleaseWhereInput>>;
  releaseDate?: InputMaybe<DateTimeFilter>;
  summary?: InputMaybe<StringNullableFilter>;
  theme?: InputMaybe<StringFilter>;
  version?: InputMaybe<StringFilter>;
};

export type ShopifyThemeReleaseWhereUniqueInput = {
  theme_version?: InputMaybe<ShopifyThemeReleaseThemeVersionCompoundUniqueInput>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StoreCreditHistory = {
  __typename?: 'StoreCreditHistory';
  Cart?: Maybe<Cart>;
  ShopifyCustomer?: Maybe<ShopifyCustomer>;
  actionNotes?: Maybe<Scalars['String']>;
  actionedBy?: Maybe<Scalars['String']>;
  amountAfterChange?: Maybe<Scalars['Decimal']>;
  amountBeforeChange?: Maybe<Scalars['Decimal']>;
  amountChanged?: Maybe<Scalars['Decimal']>;
  cartId?: Maybe<Scalars['BigInt']>;
  id: Scalars['BigInt'];
  invoiceNumber?: Maybe<Scalars['String']>;
  privateNotes?: Maybe<Scalars['String']>;
  publicNotes?: Maybe<Scalars['String']>;
  shopifyCustomerBuylistId?: Maybe<Scalars['BigInt']>;
  shopifyCustomerId?: Maybe<Scalars['BigInt']>;
  updatedDate?: Maybe<Scalars['DateTime']>;
};

export type StoreCreditHistoryCreateManyCartInput = {
  actionNotes?: InputMaybe<Scalars['String']>;
  actionedBy?: InputMaybe<Scalars['String']>;
  amountAfterChange?: InputMaybe<Scalars['Decimal']>;
  amountBeforeChange?: InputMaybe<Scalars['Decimal']>;
  amountChanged?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  shopifyCustomerId?: InputMaybe<Scalars['BigInt']>;
  updatedDate?: InputMaybe<Scalars['DateTime']>;
};

export type StoreCreditHistoryCreateManyCartInputEnvelope = {
  data: Array<StoreCreditHistoryCreateManyCartInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type StoreCreditHistoryCreateManyShopifyCustomerInput = {
  actionNotes?: InputMaybe<Scalars['String']>;
  actionedBy?: InputMaybe<Scalars['String']>;
  amountAfterChange?: InputMaybe<Scalars['Decimal']>;
  amountBeforeChange?: InputMaybe<Scalars['Decimal']>;
  amountChanged?: InputMaybe<Scalars['Decimal']>;
  cartId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  updatedDate?: InputMaybe<Scalars['DateTime']>;
};

export type StoreCreditHistoryCreateManyShopifyCustomerInputEnvelope = {
  data: Array<StoreCreditHistoryCreateManyShopifyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type StoreCreditHistoryCreateNestedManyWithoutCartInput = {
  connect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StoreCreditHistoryCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<StoreCreditHistoryCreateWithoutCartInput>>;
  createMany?: InputMaybe<StoreCreditHistoryCreateManyCartInputEnvelope>;
};

export type StoreCreditHistoryCreateNestedManyWithoutShopifyCustomerInput = {
  connect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StoreCreditHistoryCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<StoreCreditHistoryCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<StoreCreditHistoryCreateManyShopifyCustomerInputEnvelope>;
};

export type StoreCreditHistoryCreateOrConnectWithoutCartInput = {
  create: StoreCreditHistoryCreateWithoutCartInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryCreateOrConnectWithoutShopifyCustomerInput = {
  create: StoreCreditHistoryCreateWithoutShopifyCustomerInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryCreateWithoutCartInput = {
  ShopifyCustomer?: InputMaybe<ShopifyCustomerCreateNestedOneWithoutStoreCreditHistoryInput>;
  actionNotes?: InputMaybe<Scalars['String']>;
  actionedBy?: InputMaybe<Scalars['String']>;
  amountAfterChange?: InputMaybe<Scalars['Decimal']>;
  amountBeforeChange?: InputMaybe<Scalars['Decimal']>;
  amountChanged?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  updatedDate?: InputMaybe<Scalars['DateTime']>;
};

export type StoreCreditHistoryCreateWithoutShopifyCustomerInput = {
  Cart?: InputMaybe<CartCreateNestedOneWithoutStoreCreditHistoryInput>;
  actionNotes?: InputMaybe<Scalars['String']>;
  actionedBy?: InputMaybe<Scalars['String']>;
  amountAfterChange?: InputMaybe<Scalars['Decimal']>;
  amountBeforeChange?: InputMaybe<Scalars['Decimal']>;
  amountChanged?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['BigInt']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  privateNotes?: InputMaybe<Scalars['String']>;
  publicNotes?: InputMaybe<Scalars['String']>;
  shopifyCustomerBuylistId?: InputMaybe<Scalars['BigInt']>;
  updatedDate?: InputMaybe<Scalars['DateTime']>;
};

export type StoreCreditHistoryListRelationFilter = {
  every?: InputMaybe<StoreCreditHistoryWhereInput>;
  none?: InputMaybe<StoreCreditHistoryWhereInput>;
  some?: InputMaybe<StoreCreditHistoryWhereInput>;
};

export type StoreCreditHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StoreCreditHistoryOrderByWithRelationInput = {
  Cart?: InputMaybe<CartOrderByWithRelationInput>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerOrderByWithRelationInput>;
  actionNotes?: InputMaybe<SortOrder>;
  actionedBy?: InputMaybe<SortOrder>;
  amountAfterChange?: InputMaybe<SortOrder>;
  amountBeforeChange?: InputMaybe<SortOrder>;
  amountChanged?: InputMaybe<SortOrder>;
  cartId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  privateNotes?: InputMaybe<SortOrder>;
  publicNotes?: InputMaybe<SortOrder>;
  shopifyCustomerBuylistId?: InputMaybe<SortOrder>;
  shopifyCustomerId?: InputMaybe<SortOrder>;
  updatedDate?: InputMaybe<SortOrder>;
};

export enum StoreCreditHistoryScalarFieldEnum {
  ActionNotes = 'actionNotes',
  ActionedBy = 'actionedBy',
  AmountAfterChange = 'amountAfterChange',
  AmountBeforeChange = 'amountBeforeChange',
  AmountChanged = 'amountChanged',
  CartId = 'cartId',
  Id = 'id',
  InvoiceNumber = 'invoiceNumber',
  PrivateNotes = 'privateNotes',
  PublicNotes = 'publicNotes',
  ShopifyCustomerBuylistId = 'shopifyCustomerBuylistId',
  ShopifyCustomerId = 'shopifyCustomerId',
  UpdatedDate = 'updatedDate'
}

export type StoreCreditHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<StoreCreditHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<StoreCreditHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<StoreCreditHistoryScalarWhereInput>>;
  actionNotes?: InputMaybe<StringNullableFilter>;
  actionedBy?: InputMaybe<StringNullableFilter>;
  amountAfterChange?: InputMaybe<DecimalNullableFilter>;
  amountBeforeChange?: InputMaybe<DecimalNullableFilter>;
  amountChanged?: InputMaybe<DecimalNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  privateNotes?: InputMaybe<StringNullableFilter>;
  publicNotes?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  updatedDate?: InputMaybe<DateTimeNullableFilter>;
};

export type StoreCreditHistoryUpdateManyMutationInput = {
  actionNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  amountAfterChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountBeforeChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountChanged?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privateNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  updatedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type StoreCreditHistoryUpdateManyWithWhereWithoutCartInput = {
  data: StoreCreditHistoryUpdateManyMutationInput;
  where: StoreCreditHistoryScalarWhereInput;
};

export type StoreCreditHistoryUpdateManyWithWhereWithoutShopifyCustomerInput = {
  data: StoreCreditHistoryUpdateManyMutationInput;
  where: StoreCreditHistoryScalarWhereInput;
};

export type StoreCreditHistoryUpdateManyWithoutCartNestedInput = {
  connect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StoreCreditHistoryCreateOrConnectWithoutCartInput>>;
  create?: InputMaybe<Array<StoreCreditHistoryCreateWithoutCartInput>>;
  createMany?: InputMaybe<StoreCreditHistoryCreateManyCartInputEnvelope>;
  delete?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StoreCreditHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<StoreCreditHistoryUpdateWithWhereUniqueWithoutCartInput>>;
  updateMany?: InputMaybe<Array<StoreCreditHistoryUpdateManyWithWhereWithoutCartInput>>;
  upsert?: InputMaybe<Array<StoreCreditHistoryUpsertWithWhereUniqueWithoutCartInput>>;
};

export type StoreCreditHistoryUpdateManyWithoutShopifyCustomerNestedInput = {
  connect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StoreCreditHistoryCreateOrConnectWithoutShopifyCustomerInput>>;
  create?: InputMaybe<Array<StoreCreditHistoryCreateWithoutShopifyCustomerInput>>;
  createMany?: InputMaybe<StoreCreditHistoryCreateManyShopifyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StoreCreditHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<StoreCreditHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<StoreCreditHistoryUpdateWithWhereUniqueWithoutShopifyCustomerInput>>;
  updateMany?: InputMaybe<Array<StoreCreditHistoryUpdateManyWithWhereWithoutShopifyCustomerInput>>;
  upsert?: InputMaybe<Array<StoreCreditHistoryUpsertWithWhereUniqueWithoutShopifyCustomerInput>>;
};

export type StoreCreditHistoryUpdateWithWhereUniqueWithoutCartInput = {
  data: StoreCreditHistoryUpdateWithoutCartInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryUpdateWithWhereUniqueWithoutShopifyCustomerInput = {
  data: StoreCreditHistoryUpdateWithoutShopifyCustomerInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryUpdateWithoutCartInput = {
  ShopifyCustomer?: InputMaybe<ShopifyCustomerUpdateOneWithoutStoreCreditHistoryNestedInput>;
  actionNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  amountAfterChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountBeforeChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountChanged?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privateNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  updatedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type StoreCreditHistoryUpdateWithoutShopifyCustomerInput = {
  Cart?: InputMaybe<CartUpdateOneWithoutStoreCreditHistoryNestedInput>;
  actionNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  actionedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  amountAfterChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountBeforeChange?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  amountChanged?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  id?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  privateNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  publicNotes?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shopifyCustomerBuylistId?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  updatedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type StoreCreditHistoryUpsertWithWhereUniqueWithoutCartInput = {
  create: StoreCreditHistoryCreateWithoutCartInput;
  update: StoreCreditHistoryUpdateWithoutCartInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryUpsertWithWhereUniqueWithoutShopifyCustomerInput = {
  create: StoreCreditHistoryCreateWithoutShopifyCustomerInput;
  update: StoreCreditHistoryUpdateWithoutShopifyCustomerInput;
  where: StoreCreditHistoryWhereUniqueInput;
};

export type StoreCreditHistoryWhereInput = {
  AND?: InputMaybe<Array<StoreCreditHistoryWhereInput>>;
  Cart?: InputMaybe<CartRelationFilter>;
  NOT?: InputMaybe<Array<StoreCreditHistoryWhereInput>>;
  OR?: InputMaybe<Array<StoreCreditHistoryWhereInput>>;
  ShopifyCustomer?: InputMaybe<ShopifyCustomerRelationFilter>;
  actionNotes?: InputMaybe<StringNullableFilter>;
  actionedBy?: InputMaybe<StringNullableFilter>;
  amountAfterChange?: InputMaybe<DecimalNullableFilter>;
  amountBeforeChange?: InputMaybe<DecimalNullableFilter>;
  amountChanged?: InputMaybe<DecimalNullableFilter>;
  cartId?: InputMaybe<BigIntNullableFilter>;
  id?: InputMaybe<BigIntFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  privateNotes?: InputMaybe<StringNullableFilter>;
  publicNotes?: InputMaybe<StringNullableFilter>;
  shopifyCustomerBuylistId?: InputMaybe<BigIntNullableFilter>;
  shopifyCustomerId?: InputMaybe<BigIntNullableFilter>;
  updatedDate?: InputMaybe<DateTimeNullableFilter>;
};

export type StoreCreditHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type UpdateCartDto = {
  abandoned?: InputMaybe<Scalars['Boolean']>;
  cartIntegratedPayments?: InputMaybe<Array<CartIntegratedPaymentDto>>;
  cartItems?: InputMaybe<Array<CartItemDto>>;
  cartName?: InputMaybe<Scalars['String']>;
  cartNotes?: InputMaybe<Scalars['String']>;
  cartType?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['BigInt']>;
  customer?: InputMaybe<ShopifyCustomerDto>;
  dateCreated?: InputMaybe<Scalars['DateTime']>;
  dateSubmitted?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Decimal']>;
  discountType?: InputMaybe<Scalars['String']>;
  discountValue?: InputMaybe<Scalars['Float']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lastUpdated?: InputMaybe<Scalars['DateTime']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  parentCartId?: InputMaybe<Scalars['BigInt']>;
  returnCarts?: InputMaybe<Array<UpdateCartDto>>;
  savedCart?: InputMaybe<Scalars['Boolean']>;
  savedName?: InputMaybe<Scalars['String']>;
  shopifyOrderId?: InputMaybe<Scalars['BigInt']>;
  subTotal?: InputMaybe<Scalars['Decimal']>;
  submittedBy?: InputMaybe<Scalars['BigInt']>;
  taxIncluded?: InputMaybe<Scalars['Boolean']>;
  taxLines?: InputMaybe<Array<CartTaxDto>>;
  taxRate?: InputMaybe<Scalars['Decimal']>;
  tenders?: InputMaybe<Array<CartTenderDto>>;
  till?: InputMaybe<BinderCustomerTillDto>;
  tillId?: InputMaybe<Scalars['BigInt']>;
  totalPrice?: InputMaybe<Scalars['Decimal']>;
  totalTax?: InputMaybe<Scalars['Decimal']>;
};

export type UpdateVariants = {
  barcode?: InputMaybe<Scalars['String']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['BigInt'];
  inventoryManagement?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['BigInt']>;
  price?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
  weightUnit?: InputMaybe<WeightUnit>;
};

export enum WeightUnit {
  G = 'g',
  Kg = 'kg',
  Lb = 'lb',
  Oz = 'oz'
}

export type GetBuylistCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuylistCountQuery = { __typename?: 'Query', ShopifyCustomerBuylistStatusCount: Array<{ __typename?: 'ShopifyCustomerBuylistStatusCount', completedCount: number, approvedCount: number, pendingCount: number }> };

export type GetBuylistsQueryVariables = Exact<{
  where?: InputMaybe<ShopifyCustomerBuylistWhereInput>;
  orderBy?: InputMaybe<Array<ShopifyCustomerBuylistOrderByWithRelationInput> | ShopifyCustomerBuylistOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetBuylistsQuery = { __typename?: 'Query', ShopifyCustomerBuylist: Array<{ __typename?: 'ShopifyCustomerBuylist', id: any, dateApproved?: any | null, dateCompleted?: any | null, dateSubmitted?: any | null, paymentType?: string | null, approved: boolean, completed: boolean, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', email?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type Cart_By_PkQueryVariables = Exact<{
  cartByPkId: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
}>;


export type Cart_By_PkQuery = { __typename?: 'Query', Cart_by_pk?: { __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, BinderCustomer?: { __typename?: 'BinderCustomer', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', id: any, editable: boolean, settingName?: string | null, settingValue?: string | null, binderCustomerId?: string | null }> } | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }>, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, ShopifyCustomerProductVariant?: { __typename?: 'ShopifyCustomerProductVariant', inventoryQuantity?: any | null, ShopifyCustomerProduct?: { __typename?: 'ShopifyCustomerProduct', type?: string | null } | null } | null, CartItemAdditionalInfo: Array<{ __typename?: 'CartItemAdditionalInfo', id: any, name?: string | null, value?: string | null }> }>, other_Cart: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null }>, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, shopifyId: any, storeCredit: any, customerId?: string | null, disabled: boolean, notes?: string | null, lastOrderId?: any | null, lastOrderName?: string | null, taxExempt?: boolean | null, totalSpent?: any | null } | null, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }> }>, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, BinderCustomerUser_BinderCustomerUserToCart_createdBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetActiveCartsQueryVariables = Exact<{
  where?: InputMaybe<AllCartsWhereInput>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput> | CartOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetActiveCartsQuery = { __typename?: 'Query', getActiveCarts: { __typename?: 'ActiveCarts', totalRows: any, carts: Array<{ __typename?: 'ActiveCart', id: any, lastUpdated?: any | null, savedCart: boolean, savedName?: string | null, cartName?: string | null, cartType?: string | null, itemCount: any, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', firstName?: string | null, lastName?: string | null } | null }> } };

export type GetAllCartsQueryVariables = Exact<{
  where?: InputMaybe<AllCartsWhereInput>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput> | CartOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllCartsQuery = { __typename?: 'Query', getAllCarts: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, BinderCustomer?: { __typename?: 'BinderCustomer', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', id: any, editable: boolean, settingName?: string | null, settingValue?: string | null, binderCustomerId?: string | null }> } | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }>, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null }>, other_Cart: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null }>, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, customerId: string, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_createdBy?: { __typename?: 'BinderCustomerUser', id: any, customerId: string, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null }> };

export type GetCartNotesReportQueryVariables = Exact<{
  where?: InputMaybe<AllCartsWhereInput>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput> | CartOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetCartNotesReportQuery = { __typename?: 'Query', getAllCarts: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, createdBy?: any | null, submittedBy?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', email?: string | null, firstName?: string | null, lastName?: string | null } | null }> };

export type GetLatestCartForTillQueryVariables = Exact<{
  tillId: Scalars['Float'];
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
}>;


export type GetLatestCartForTillQuery = { __typename?: 'Query', GetLatestCartForTill?: { __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, BinderCustomer?: { __typename?: 'BinderCustomer', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', id: any, editable: boolean, settingName?: string | null, settingValue?: string | null, binderCustomerId?: string | null }> } | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }>, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, ShopifyCustomerProductVariant?: { __typename?: 'ShopifyCustomerProductVariant', inventoryQuantity?: any | null } | null, CartItemAdditionalInfo: Array<{ __typename?: 'CartItemAdditionalInfo', id: any, name?: string | null, value?: string | null }> }>, other_Cart: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null }>, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, shopifyId: any, storeCredit: any, customerId?: string | null, disabled: boolean, notes?: string | null, lastOrderId?: any | null, lastOrderName?: string | null, taxExempt?: boolean | null, totalSpent?: any | null } | null, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }> }>, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, BinderCustomerUser_BinderCustomerUserToCart_createdBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null } | null };

export type GetSubmittedCartsQueryVariables = Exact<{
  where?: InputMaybe<AllCartsWhereInput>;
  orderBy?: InputMaybe<Array<CartOrderByWithRelationInput> | CartOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetSubmittedCartsQuery = { __typename?: 'Query', getAllCarts: Array<{ __typename?: 'Cart', id: any, dateSubmitted?: any | null, totalPrice?: any | null, submittedBy?: any | null, shopifyOrderId?: any | null, cartNotes?: string | null, cartType?: string | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', firstName?: string | null, lastName?: string | null } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, name?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, customerId: string, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null }> };

export type KeepCartActiveMutationVariables = Exact<{
  cartId: Scalars['Float'];
}>;


export type KeepCartActiveMutation = { __typename?: 'Mutation', KeepCartActive?: { __typename?: 'Cart', lastUpdated?: any | null } | null };

export type SubmitCartMutationVariables = Exact<{
  data: UpdateCartDto;
  submit: Scalars['Boolean'];
}>;


export type SubmitCartMutation = { __typename?: 'Mutation', SubmitCart?: { __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, BinderCustomer?: { __typename?: 'BinderCustomer', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', id: any, editable: boolean, settingName?: string | null, settingValue?: string | null, binderCustomerId?: string | null }> } | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }>, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, ShopifyCustomerProductVariant?: { __typename?: 'ShopifyCustomerProductVariant', inventoryQuantity?: any | null } | null, CartItemAdditionalInfo: Array<{ __typename?: 'CartItemAdditionalInfo', id: any, name?: string | null, value?: string | null }> }>, other_Cart: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null }>, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, shopifyId: any, storeCredit: any, customerId?: string | null, disabled: boolean, notes?: string | null, lastOrderId?: any | null, lastOrderName?: string | null, taxExempt?: boolean | null, totalSpent?: any | null } | null, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }> }>, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, BinderCustomerUser_BinderCustomerUserToCart_createdBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null } | null };

export type UpdateCartMutationVariables = Exact<{
  data: UpdateCartDto;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
}>;


export type UpdateCartMutation = { __typename?: 'Mutation', UpdateCart?: { __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, BinderCustomer?: { __typename?: 'BinderCustomer', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', id: any, editable: boolean, settingName?: string | null, settingValue?: string | null, binderCustomerId?: string | null }> } | null, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }>, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, ShopifyCustomerProductVariant?: { __typename?: 'ShopifyCustomerProductVariant', inventoryQuantity?: any | null } | null, CartItemAdditionalInfo: Array<{ __typename?: 'CartItemAdditionalInfo', id: any, name?: string | null, value?: string | null }> }>, other_Cart: Array<{ __typename?: 'Cart', id: any, dateCreated?: any | null, dateSubmitted?: any | null, lastUpdated?: any | null, totalPrice?: any | null, binderCustomerId?: string | null, binderCustomerTillId?: any | null, createdBy?: any | null, shopifyCustomerId?: any | null, submittedBy?: any | null, abandoned: boolean, taxIncluded?: boolean | null, totalTax?: any | null, savedCart: boolean, savedName?: string | null, orderNumber?: string | null, shopifyOrderId?: any | null, subTotal?: any | null, taxRate?: number | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, cartName?: string | null, cartNotes?: string | null, cartType?: string | null, parentCartId?: any | null, removedBy?: any | null, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, BinderCustomerTill?: { __typename?: 'BinderCustomerTill', id: any, createdAt?: any | null, description?: string | null, isActive: boolean, name?: string | null, customerId?: string | null, archived: boolean } | null, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null }>, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null, shopifyId: any, storeCredit: any, customerId?: string | null, disabled: boolean, notes?: string | null, lastOrderId?: any | null, lastOrderName?: string | null, taxExempt?: boolean | null, totalSpent?: any | null } | null, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, approveAmount?: any | null, batchNumber?: any | null, cardHolder?: string | null, fullResponseObject?: string | null, hostResponseMessage?: string | null, lastFour?: number | null, surchargeFee?: any | null, timeStamp?: any | null, transactionNumber?: any | null, cartId: any }> }>, CartTender: Array<{ __typename?: 'CartTender', id: any, amount?: any | null, type?: string | null, cartId: any }>, CartTax: Array<{ __typename?: 'CartTax', id: any, price?: any | null, rate?: number | null, title?: string | null, cartId?: any | null }>, BinderCustomerUser_BinderCustomerUserToCart_createdBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null, BinderCustomerUser_BinderCustomerUserToCart_submittedBy?: { __typename?: 'BinderCustomerUser', id: any, userId: string, email: string, enabled: boolean, firstName?: string | null, lastName?: string | null } | null } | null };

export type DeleteCartMutationVariables = Exact<{
  removeStock: Scalars['Boolean'];
  deleteCartByPkId: Scalars['Float'];
}>;


export type DeleteCartMutation = { __typename?: 'Mutation', DeleteCart_by_pk?: { __typename?: 'Cart', id: any } | null };

export type ReturnCartMutationVariables = Exact<{
  returnCartId: Scalars['Float'];
}>;


export type ReturnCartMutation = { __typename?: 'Mutation', ReturnCart?: { __typename?: 'Cart', id: any, cartType?: string | null, cartNotes?: string | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, CartItem: Array<{ __typename?: 'CartItem', id: any, buying: boolean, imageSrc?: string | null, price?: any | null, productTitle?: string | null, quantity?: number | null, variantTitle?: string | null, cartId: any, variantId?: any | null, itemTax?: any | null, taxable?: boolean | null, tags?: string | null, shopifyPrice?: any | null, shopifyTaxable?: boolean | null, actualPrice?: any | null, discountAmount?: any | null, discountType?: string | null, discountValue?: number | null, ShopifyCustomerProductVariant?: { __typename?: 'ShopifyCustomerProductVariant', inventoryQuantity?: any | null } | null, CartItemAdditionalInfo: Array<{ __typename?: 'CartItemAdditionalInfo', id: any, name?: string | null, value?: string | null }> }>, ShopifyCustomer?: { __typename?: 'ShopifyCustomer', id: any, email?: string | null, firstName?: string | null, lastName?: string | null, storeCredit: any } | null, Cart?: { __typename?: 'Cart', CartIntegratedPayment: Array<{ __typename?: 'CartIntegratedPayment', id: any, lastFour?: number | null, fullResponseObject?: string | null }> } | null } | null };

export type GetActiveTillsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveTillsQuery = { __typename?: 'Query', BinderCustomerTill: Array<{ __typename?: 'BinderCustomerTill', id: any, name?: string | null, archived: boolean }> };

export type GetTillSettingsQueryVariables = Exact<{
  tillId?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetTillSettingsQuery = { __typename?: 'Query', BinderCustomerTillSettings: Array<{ __typename?: 'BinderCustomerTillSettings', id: any, settingName?: string | null, settingValue?: string | null, tillId?: any | null }> };

export type CreateProductMutationVariables = Exact<{
  title: Scalars['String'];
  variants: Array<CreateVariants> | CreateVariants;
  published: Scalars['Boolean'];
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  bodyHtml?: InputMaybe<Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
}>;


export type CreateProductMutation = { __typename?: 'Mutation', CreateProduct?: { __typename?: 'Product', title?: string | null, productType?: string | null, id: any, vendor?: string | null, ProductDescription?: { __typename?: 'ProductDescription', descriptionHtml?: string | null, customerId: string, productId: any } | null, ProductTag: Array<{ __typename?: 'ProductTag', id: any, tag?: string | null }>, ProductImage: Array<{ __typename?: 'ProductImage', height?: number | null, id: any, imageUrl?: string | null, width?: number | null, position?: number | null }>, ProductVariant: Array<{ __typename?: 'ProductVariant', title?: string | null, sku?: string | null, barcode?: string | null, id: any, weight?: number | null, weightUnit?: string | null, price?: string | null, position?: any | null }> } | null };

export type CreateProductVariantMutationVariables = Exact<{
  variant: CreateVariants;
  productId: Scalars['BigInt'];
}>;


export type CreateProductVariantMutation = { __typename?: 'Mutation', CreateVariant: { __typename?: 'Product', title?: string | null, productType?: string | null, id: any, vendor?: string | null, ProductDescription?: { __typename?: 'ProductDescription', descriptionHtml?: string | null, customerId: string, productId: any } | null, ProductTag: Array<{ __typename?: 'ProductTag', id: any, tag?: string | null }>, ProductImage: Array<{ __typename?: 'ProductImage', height?: number | null, id: any, imageUrl?: string | null, width?: number | null, position?: number | null }>, ProductVariant: Array<{ __typename?: 'ProductVariant', title?: string | null, sku?: string | null, barcode?: string | null, id: any, weight?: number | null, weightUnit?: string | null, price?: string | null, position?: any | null }> } };

export type DeleteProductMutationVariables = Exact<{
  id: Scalars['BigInt'];
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', UpdateProduct?: { __typename?: 'Product', id: any } | null };

export type ProductTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductTypesQuery = { __typename?: 'Query', Product: Array<{ __typename?: 'Product', productType?: string | null }> };

export type ProductVendorsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductVendorsQuery = { __typename?: 'Query', Product: Array<{ __typename?: 'Product', vendor?: string | null }> };

export type ProductByIdQueryVariables = Exact<{
  productByPkId: Scalars['Float'];
}>;


export type ProductByIdQuery = { __typename?: 'Query', Product_by_pk?: { __typename?: 'Product', title?: string | null, productType?: string | null, id: any, vendor?: string | null, ProductDescription?: { __typename?: 'ProductDescription', descriptionHtml?: string | null, customerId: string, productId: any } | null, ProductTag: Array<{ __typename?: 'ProductTag', id: any, tag?: string | null }>, ProductImage: Array<{ __typename?: 'ProductImage', height?: number | null, id: any, imageUrl?: string | null, width?: number | null, position?: number | null }>, ProductVariant: Array<{ __typename?: 'ProductVariant', title?: string | null, sku?: string | null, barcode?: string | null, id: any, weight?: number | null, weightUnit?: string | null, price?: string | null, position?: any | null }> } | null };

export type UpdateProductMutationVariables = Exact<{
  updateProductId: Scalars['BigInt'];
  published?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
  variants?: InputMaybe<Array<UpdateVariants> | UpdateVariants>;
  bodyHtml?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<Array<Images> | Images>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  vendor?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', UpdateProduct?: { __typename?: 'Product', title?: string | null, productType?: string | null, id: any, vendor?: string | null, ProductDescription?: { __typename?: 'ProductDescription', descriptionHtml?: string | null, customerId: string, productId: any } | null, ProductTag: Array<{ __typename?: 'ProductTag', id: any, tag?: string | null }>, ProductImage: Array<{ __typename?: 'ProductImage', height?: number | null, id: any, imageUrl?: string | null, width?: number | null, position?: number | null }>, ProductVariant: Array<{ __typename?: 'ProductVariant', title?: string | null, sku?: string | null, barcode?: string | null, id: any, weight?: number | null, weightUnit?: string | null, price?: string | null, position?: any | null }> } | null };

export type GetInstalledShopifyThemeVersionQueryVariables = Exact<{
  where?: InputMaybe<BinderCustomerShopifyThemeWhereInput>;
}>;


export type GetInstalledShopifyThemeVersionQuery = { __typename?: 'Query', BinderCustomerShopifyTheme?: Array<{ __typename?: 'BinderCustomerShopifyTheme', ShopifyThemeRelease: { __typename?: 'ShopifyThemeRelease', version: string, theme: string, releaseDate: any } }> | null };

export type GetInstalledShopifyThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInstalledShopifyThemesQuery = { __typename?: 'Query', BinderCustomerSettings: Array<{ __typename?: 'BinderCustomerSettings', settingName?: string | null }> };

export type ShopifyThemeAvailableRollbacksQueryVariables = Exact<{
  currentVersion: Scalars['String'];
  theme: Scalars['String'];
}>;


export type ShopifyThemeAvailableRollbacksQuery = { __typename?: 'Query', ShopifyThemeAvailableRollbacks?: Array<{ __typename?: 'ShopifyThemeRelease', version: string, releaseDate: any, summary?: string | null }> | null };

export type ShopifyThemeAvailableUpdatesQueryVariables = Exact<{
  currentVersion: Scalars['String'];
  theme: Scalars['String'];
}>;


export type ShopifyThemeAvailableUpdatesQuery = { __typename?: 'Query', ShopifyThemeAvailableUpdates?: Array<{ __typename?: 'ShopifyThemeRelease', summary?: string | null, version: string, releaseDate: any }> | null };

export type GetShopifyThemesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopifyThemesQuery = { __typename?: 'Query', BinderCustomerShopifyTheme?: Array<{ __typename?: 'BinderCustomerShopifyTheme', customerId: string, theme: string, currentVersion: string, releaseTrain: ReleaseTrain, lastUpdate?: any | null }> | null };

export type UpdateBinderCustomerShopifyThemeMutationVariables = Exact<{
  data: BinderCustomerShopifyThemeUpdateInput;
  theme: Scalars['String'];
}>;


export type UpdateBinderCustomerShopifyThemeMutation = { __typename?: 'Mutation', UpdateBinderCustomerShopifyTheme: { __typename?: 'BinderCustomerShopifyTheme', theme: string, releaseTrain: ReleaseTrain, lastUpdate?: any | null } };


export const GetBuylistCountDocument = `
    query GetBuylistCount {
  ShopifyCustomerBuylistStatusCount {
    completedCount
    approvedCount
    pendingCount
  }
}
    `;
export const useGetBuylistCountQuery = <
      TData = GetBuylistCountQuery,
      TError = unknown
    >(
      variables?: GetBuylistCountQueryVariables,
      options?: UseQueryOptions<GetBuylistCountQuery, TError, TData>
    ) =>
    useQuery<GetBuylistCountQuery, TError, TData>(
      variables === undefined ? ['GetBuylistCount'] : ['GetBuylistCount', variables],
      graphQlFetcher<GetBuylistCountQuery, GetBuylistCountQueryVariables>(GetBuylistCountDocument, variables),
      options
    );
export const GetBuylistsDocument = `
    query GetBuylists($where: ShopifyCustomerBuylistWhereInput, $orderBy: [ShopifyCustomerBuylistOrderByWithRelationInput!], $take: Int, $skip: Int) {
  ShopifyCustomerBuylist(
    take: $take
    skip: $skip
    where: $where
    orderBy: $orderBy
  ) {
    id
    ShopifyCustomer {
      email
      firstName
      lastName
    }
    dateApproved
    dateCompleted
    dateSubmitted
    paymentType
    approved
    completed
  }
}
    `;
export const useGetBuylistsQuery = <
      TData = GetBuylistsQuery,
      TError = unknown
    >(
      variables?: GetBuylistsQueryVariables,
      options?: UseQueryOptions<GetBuylistsQuery, TError, TData>
    ) =>
    useQuery<GetBuylistsQuery, TError, TData>(
      variables === undefined ? ['GetBuylists'] : ['GetBuylists', variables],
      graphQlFetcher<GetBuylistsQuery, GetBuylistsQueryVariables>(GetBuylistsDocument, variables),
      options
    );
export const Cart_By_PkDocument = `
    query Cart_by_pk($cartByPkId: Float!, $orderBy: [CartItemOrderByWithRelationInput!]) {
  Cart_by_pk(id: $cartByPkId) {
    id
    dateCreated
    dateSubmitted
    lastUpdated
    totalPrice
    binderCustomerId
    binderCustomerTillId
    createdBy
    shopifyCustomerId
    submittedBy
    abandoned
    taxIncluded
    totalTax
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    subTotal
    taxRate
    discountAmount
    discountType
    discountValue
    cartName
    cartNotes
    cartType
    parentCartId
    removedBy
    BinderCustomer {
      BinderCustomerSettings {
        id
        editable
        settingName
        settingValue
        binderCustomerId
      }
    }
    ShopifyCustomer {
      id
      email
      firstName
      lastName
      storeCredit
    }
    BinderCustomerTill {
      id
      createdAt
      description
      isActive
      name
      customerId
      archived
    }
    CartIntegratedPayment {
      id
      approveAmount
      batchNumber
      cardHolder
      fullResponseObject
      hostResponseMessage
      lastFour
      surchargeFee
      timeStamp
      transactionNumber
      cartId
    }
    CartItem(orderBy: $orderBy) {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
      ShopifyCustomerProductVariant {
        inventoryQuantity
        ShopifyCustomerProduct {
          type
        }
      }
      CartItemAdditionalInfo {
        id
        name
        value
      }
    }
    other_Cart {
      id
      dateCreated
      dateSubmitted
      lastUpdated
      totalPrice
      binderCustomerId
      binderCustomerTillId
      createdBy
      shopifyCustomerId
      submittedBy
      abandoned
      taxIncluded
      totalTax
      savedCart
      savedName
      orderNumber
      shopifyOrderId
      subTotal
      taxRate
      discountAmount
      discountType
      discountValue
      cartName
      cartNotes
      cartType
      parentCartId
      removedBy
      CartTender {
        id
        amount
        type
        cartId
      }
      BinderCustomerTill {
        id
        createdAt
        description
        isActive
        name
        customerId
        archived
      }
      CartItem {
        id
        buying
        imageSrc
        price
        productTitle
        quantity
        variantTitle
        cartId
        variantId
        itemTax
        taxable
        tags
        shopifyPrice
        shopifyTaxable
        actualPrice
        discountAmount
        discountType
        discountValue
      }
      ShopifyCustomer {
        id
        email
        firstName
        lastName
        phone
        shopifyId
        storeCredit
        customerId
        disabled
        notes
        lastOrderId
        lastOrderName
        taxExempt
        totalSpent
      }
      CartTax {
        id
        price
        rate
        title
        cartId
      }
      CartIntegratedPayment {
        id
        approveAmount
        batchNumber
        cardHolder
        fullResponseObject
        hostResponseMessage
        lastFour
        surchargeFee
        timeStamp
        transactionNumber
        cartId
      }
    }
    CartTender {
      id
      amount
      type
      cartId
    }
    CartTax {
      id
      price
      rate
      title
      cartId
    }
    BinderCustomerUser_BinderCustomerUserToCart_createdBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useCart_By_PkQuery = <
      TData = Cart_By_PkQuery,
      TError = unknown
    >(
      variables: Cart_By_PkQueryVariables,
      options?: UseQueryOptions<Cart_By_PkQuery, TError, TData>
    ) =>
    useQuery<Cart_By_PkQuery, TError, TData>(
      ['Cart_by_pk', variables],
      graphQlFetcher<Cart_By_PkQuery, Cart_By_PkQueryVariables>(Cart_By_PkDocument, variables),
      options
    );
export const GetActiveCartsDocument = `
    query GetActiveCarts($where: AllCartsWhereInput, $orderBy: [CartOrderByWithRelationInput!], $take: Int, $skip: Int) {
  getActiveCarts(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    totalRows
    carts {
      id
      lastUpdated
      savedCart
      savedName
      cartName
      cartType
      ShopifyCustomer {
        firstName
        lastName
      }
      itemCount
    }
  }
}
    `;
export const useGetActiveCartsQuery = <
      TData = GetActiveCartsQuery,
      TError = unknown
    >(
      variables?: GetActiveCartsQueryVariables,
      options?: UseQueryOptions<GetActiveCartsQuery, TError, TData>
    ) =>
    useQuery<GetActiveCartsQuery, TError, TData>(
      variables === undefined ? ['GetActiveCarts'] : ['GetActiveCarts', variables],
      graphQlFetcher<GetActiveCartsQuery, GetActiveCartsQueryVariables>(GetActiveCartsDocument, variables),
      options
    );
export const GetAllCartsDocument = `
    query GetAllCarts($where: AllCartsWhereInput, $orderBy: [CartOrderByWithRelationInput!], $take: Int, $skip: Int) {
  getAllCarts(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    dateCreated
    dateSubmitted
    lastUpdated
    totalPrice
    binderCustomerId
    binderCustomerTillId
    createdBy
    shopifyCustomerId
    submittedBy
    abandoned
    taxIncluded
    totalTax
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    subTotal
    taxRate
    discountAmount
    discountType
    discountValue
    cartName
    cartNotes
    cartType
    parentCartId
    removedBy
    BinderCustomer {
      BinderCustomerSettings {
        id
        editable
        settingName
        settingValue
        binderCustomerId
      }
    }
    ShopifyCustomer {
      email
      firstName
      lastName
      storeCredit
    }
    BinderCustomerTill {
      id
      createdAt
      description
      isActive
      name
      customerId
      archived
    }
    CartIntegratedPayment {
      id
      approveAmount
      batchNumber
      cardHolder
      fullResponseObject
      hostResponseMessage
      lastFour
      surchargeFee
      timeStamp
      transactionNumber
      cartId
    }
    CartItem {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
    }
    other_Cart {
      id
      dateCreated
      dateSubmitted
      lastUpdated
      totalPrice
      binderCustomerId
      binderCustomerTillId
      createdBy
      shopifyCustomerId
      submittedBy
      abandoned
      taxIncluded
      totalTax
      savedCart
      savedName
      orderNumber
      shopifyOrderId
      subTotal
      taxRate
      discountAmount
      discountType
      discountValue
      cartName
      cartNotes
      cartType
      parentCartId
      removedBy
    }
    CartTender {
      id
      amount
      type
      cartId
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      customerId
      userId
      email
      enabled
      firstName
      lastName
    }
    BinderCustomerUser_BinderCustomerUserToCart_createdBy {
      id
      customerId
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useGetAllCartsQuery = <
      TData = GetAllCartsQuery,
      TError = unknown
    >(
      variables?: GetAllCartsQueryVariables,
      options?: UseQueryOptions<GetAllCartsQuery, TError, TData>
    ) =>
    useQuery<GetAllCartsQuery, TError, TData>(
      variables === undefined ? ['GetAllCarts'] : ['GetAllCarts', variables],
      graphQlFetcher<GetAllCartsQuery, GetAllCartsQueryVariables>(GetAllCartsDocument, variables),
      options
    );
export const GetCartNotesReportDocument = `
    query GetCartNotesReport($where: AllCartsWhereInput, $orderBy: [CartOrderByWithRelationInput!], $take: Int, $skip: Int) {
  getAllCarts(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    dateCreated
    dateSubmitted
    createdBy
    submittedBy
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    cartName
    cartNotes
    cartType
    ShopifyCustomer {
      email
      firstName
      lastName
    }
  }
}
    `;
export const useGetCartNotesReportQuery = <
      TData = GetCartNotesReportQuery,
      TError = unknown
    >(
      variables?: GetCartNotesReportQueryVariables,
      options?: UseQueryOptions<GetCartNotesReportQuery, TError, TData>
    ) =>
    useQuery<GetCartNotesReportQuery, TError, TData>(
      variables === undefined ? ['GetCartNotesReport'] : ['GetCartNotesReport', variables],
      graphQlFetcher<GetCartNotesReportQuery, GetCartNotesReportQueryVariables>(GetCartNotesReportDocument, variables),
      options
    );
export const GetLatestCartForTillDocument = `
    query GetLatestCartForTill($tillId: Float!, $orderBy: [CartItemOrderByWithRelationInput!]) {
  GetLatestCartForTill(tillId: $tillId) {
    id
    dateCreated
    dateSubmitted
    lastUpdated
    totalPrice
    binderCustomerId
    binderCustomerTillId
    createdBy
    shopifyCustomerId
    submittedBy
    abandoned
    taxIncluded
    totalTax
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    subTotal
    taxRate
    discountAmount
    discountType
    discountValue
    cartName
    cartNotes
    cartType
    parentCartId
    removedBy
    BinderCustomer {
      BinderCustomerSettings {
        id
        editable
        settingName
        settingValue
        binderCustomerId
      }
    }
    ShopifyCustomer {
      email
      firstName
      lastName
      storeCredit
    }
    BinderCustomerTill {
      id
      createdAt
      description
      isActive
      name
      customerId
      archived
    }
    CartIntegratedPayment {
      id
      approveAmount
      batchNumber
      cardHolder
      fullResponseObject
      hostResponseMessage
      lastFour
      surchargeFee
      timeStamp
      transactionNumber
      cartId
    }
    CartItem(orderBy: $orderBy) {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
      ShopifyCustomerProductVariant {
        inventoryQuantity
      }
      CartItemAdditionalInfo {
        id
        name
        value
      }
    }
    other_Cart {
      id
      dateCreated
      dateSubmitted
      lastUpdated
      totalPrice
      binderCustomerId
      binderCustomerTillId
      createdBy
      shopifyCustomerId
      submittedBy
      abandoned
      taxIncluded
      totalTax
      savedCart
      savedName
      orderNumber
      shopifyOrderId
      subTotal
      taxRate
      discountAmount
      discountType
      discountValue
      cartName
      cartNotes
      cartType
      parentCartId
      removedBy
      CartTender {
        id
        amount
        type
        cartId
      }
      BinderCustomerTill {
        id
        createdAt
        description
        isActive
        name
        customerId
        archived
      }
      CartItem {
        id
        buying
        imageSrc
        price
        productTitle
        quantity
        variantTitle
        cartId
        variantId
        itemTax
        taxable
        tags
        shopifyPrice
        shopifyTaxable
        actualPrice
        discountAmount
        discountType
        discountValue
      }
      ShopifyCustomer {
        id
        email
        firstName
        lastName
        phone
        shopifyId
        storeCredit
        customerId
        disabled
        notes
        lastOrderId
        lastOrderName
        taxExempt
        totalSpent
      }
      CartTax {
        id
        price
        rate
        title
        cartId
      }
      CartIntegratedPayment {
        id
        approveAmount
        batchNumber
        cardHolder
        fullResponseObject
        hostResponseMessage
        lastFour
        surchargeFee
        timeStamp
        transactionNumber
        cartId
      }
    }
    CartTender {
      id
      amount
      type
      cartId
    }
    CartTax {
      id
      price
      rate
      title
      cartId
    }
    BinderCustomerUser_BinderCustomerUserToCart_createdBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useGetLatestCartForTillQuery = <
      TData = GetLatestCartForTillQuery,
      TError = unknown
    >(
      variables: GetLatestCartForTillQueryVariables,
      options?: UseQueryOptions<GetLatestCartForTillQuery, TError, TData>
    ) =>
    useQuery<GetLatestCartForTillQuery, TError, TData>(
      ['GetLatestCartForTill', variables],
      graphQlFetcher<GetLatestCartForTillQuery, GetLatestCartForTillQueryVariables>(GetLatestCartForTillDocument, variables),
      options
    );
export const GetSubmittedCartsDocument = `
    query GetSubmittedCarts($where: AllCartsWhereInput, $orderBy: [CartOrderByWithRelationInput!], $take: Int, $skip: Int) {
  getAllCarts(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    dateSubmitted
    totalPrice
    submittedBy
    shopifyOrderId
    cartNotes
    cartType
    ShopifyCustomer {
      firstName
      lastName
    }
    BinderCustomerTill {
      id
      name
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      customerId
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useGetSubmittedCartsQuery = <
      TData = GetSubmittedCartsQuery,
      TError = unknown
    >(
      variables?: GetSubmittedCartsQueryVariables,
      options?: UseQueryOptions<GetSubmittedCartsQuery, TError, TData>
    ) =>
    useQuery<GetSubmittedCartsQuery, TError, TData>(
      variables === undefined ? ['GetSubmittedCarts'] : ['GetSubmittedCarts', variables],
      graphQlFetcher<GetSubmittedCartsQuery, GetSubmittedCartsQueryVariables>(GetSubmittedCartsDocument, variables),
      options
    );
export const KeepCartActiveDocument = `
    mutation KeepCartActive($cartId: Float!) {
  KeepCartActive(id: $cartId) {
    lastUpdated
  }
}
    `;
export const useKeepCartActiveMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<KeepCartActiveMutation, TError, KeepCartActiveMutationVariables, TContext>) =>
    useMutation<KeepCartActiveMutation, TError, KeepCartActiveMutationVariables, TContext>(
      ['KeepCartActive'],
      (variables?: KeepCartActiveMutationVariables) => graphQlFetcher<KeepCartActiveMutation, KeepCartActiveMutationVariables>(KeepCartActiveDocument, variables)(),
      options
    );
export const SubmitCartDocument = `
    mutation SubmitCart($data: UpdateCartDto!, $submit: Boolean!) {
  SubmitCart(data: $data, submit: $submit) {
    id
    dateCreated
    dateSubmitted
    lastUpdated
    totalPrice
    binderCustomerId
    binderCustomerTillId
    createdBy
    shopifyCustomerId
    submittedBy
    abandoned
    taxIncluded
    totalTax
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    subTotal
    taxRate
    discountAmount
    discountType
    discountValue
    cartName
    cartNotes
    cartType
    parentCartId
    removedBy
    BinderCustomer {
      BinderCustomerSettings {
        id
        editable
        settingName
        settingValue
        binderCustomerId
      }
    }
    ShopifyCustomer {
      id
      email
      firstName
      lastName
      storeCredit
    }
    BinderCustomerTill {
      id
      createdAt
      description
      isActive
      name
      customerId
      archived
    }
    CartIntegratedPayment {
      id
      approveAmount
      batchNumber
      cardHolder
      fullResponseObject
      hostResponseMessage
      lastFour
      surchargeFee
      timeStamp
      transactionNumber
      cartId
    }
    CartItem {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
      ShopifyCustomerProductVariant {
        inventoryQuantity
      }
      CartItemAdditionalInfo {
        id
        name
        value
      }
    }
    other_Cart {
      id
      dateCreated
      dateSubmitted
      lastUpdated
      totalPrice
      binderCustomerId
      binderCustomerTillId
      createdBy
      shopifyCustomerId
      submittedBy
      abandoned
      taxIncluded
      totalTax
      savedCart
      savedName
      orderNumber
      shopifyOrderId
      subTotal
      taxRate
      discountAmount
      discountType
      discountValue
      cartName
      cartNotes
      cartType
      parentCartId
      removedBy
      CartTender {
        id
        amount
        type
        cartId
      }
      BinderCustomerTill {
        id
        createdAt
        description
        isActive
        name
        customerId
        archived
      }
      CartItem {
        id
        buying
        imageSrc
        price
        productTitle
        quantity
        variantTitle
        cartId
        variantId
        itemTax
        taxable
        tags
        shopifyPrice
        shopifyTaxable
        actualPrice
        discountAmount
        discountType
        discountValue
      }
      ShopifyCustomer {
        id
        email
        firstName
        lastName
        phone
        shopifyId
        storeCredit
        customerId
        disabled
        notes
        lastOrderId
        lastOrderName
        taxExempt
        totalSpent
      }
      CartTax {
        id
        price
        rate
        title
        cartId
      }
      CartIntegratedPayment {
        id
        approveAmount
        batchNumber
        cardHolder
        fullResponseObject
        hostResponseMessage
        lastFour
        surchargeFee
        timeStamp
        transactionNumber
        cartId
      }
    }
    CartTender {
      id
      amount
      type
      cartId
    }
    CartTax {
      id
      price
      rate
      title
      cartId
    }
    BinderCustomerUser_BinderCustomerUserToCart_createdBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useSubmitCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitCartMutation, TError, SubmitCartMutationVariables, TContext>) =>
    useMutation<SubmitCartMutation, TError, SubmitCartMutationVariables, TContext>(
      ['SubmitCart'],
      (variables?: SubmitCartMutationVariables) => graphQlFetcher<SubmitCartMutation, SubmitCartMutationVariables>(SubmitCartDocument, variables)(),
      options
    );
export const UpdateCartDocument = `
    mutation UpdateCart($data: UpdateCartDto!, $orderBy: [CartItemOrderByWithRelationInput!]) {
  UpdateCart(data: $data) {
    id
    dateCreated
    dateSubmitted
    lastUpdated
    totalPrice
    binderCustomerId
    binderCustomerTillId
    createdBy
    shopifyCustomerId
    submittedBy
    abandoned
    taxIncluded
    totalTax
    savedCart
    savedName
    orderNumber
    shopifyOrderId
    subTotal
    taxRate
    discountAmount
    discountType
    discountValue
    cartName
    cartNotes
    cartType
    parentCartId
    removedBy
    BinderCustomer {
      BinderCustomerSettings {
        id
        editable
        settingName
        settingValue
        binderCustomerId
      }
    }
    ShopifyCustomer {
      id
      email
      firstName
      lastName
      storeCredit
    }
    BinderCustomerTill {
      id
      createdAt
      description
      isActive
      name
      customerId
      archived
    }
    CartIntegratedPayment {
      id
      approveAmount
      batchNumber
      cardHolder
      fullResponseObject
      hostResponseMessage
      lastFour
      surchargeFee
      timeStamp
      transactionNumber
      cartId
    }
    CartItem(orderBy: $orderBy) {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
      ShopifyCustomerProductVariant {
        inventoryQuantity
      }
      CartItemAdditionalInfo {
        id
        name
        value
      }
    }
    other_Cart {
      id
      dateCreated
      dateSubmitted
      lastUpdated
      totalPrice
      binderCustomerId
      binderCustomerTillId
      createdBy
      shopifyCustomerId
      submittedBy
      abandoned
      taxIncluded
      totalTax
      savedCart
      savedName
      orderNumber
      shopifyOrderId
      subTotal
      taxRate
      discountAmount
      discountType
      discountValue
      cartName
      cartNotes
      cartType
      parentCartId
      removedBy
      CartTender {
        id
        amount
        type
        cartId
      }
      BinderCustomerTill {
        id
        createdAt
        description
        isActive
        name
        customerId
        archived
      }
      CartItem {
        id
        buying
        imageSrc
        price
        productTitle
        quantity
        variantTitle
        cartId
        variantId
        itemTax
        taxable
        tags
        shopifyPrice
        shopifyTaxable
        actualPrice
        discountAmount
        discountType
        discountValue
      }
      ShopifyCustomer {
        id
        email
        firstName
        lastName
        phone
        shopifyId
        storeCredit
        customerId
        disabled
        notes
        lastOrderId
        lastOrderName
        taxExempt
        totalSpent
      }
      CartTax {
        id
        price
        rate
        title
        cartId
      }
      CartIntegratedPayment {
        id
        approveAmount
        batchNumber
        cardHolder
        fullResponseObject
        hostResponseMessage
        lastFour
        surchargeFee
        timeStamp
        transactionNumber
        cartId
      }
    }
    CartTender {
      id
      amount
      type
      cartId
    }
    CartTax {
      id
      price
      rate
      title
      cartId
    }
    BinderCustomerUser_BinderCustomerUserToCart_createdBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
    BinderCustomerUser_BinderCustomerUserToCart_submittedBy {
      id
      userId
      email
      enabled
      firstName
      lastName
    }
  }
}
    `;
export const useUpdateCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCartMutation, TError, UpdateCartMutationVariables, TContext>) =>
    useMutation<UpdateCartMutation, TError, UpdateCartMutationVariables, TContext>(
      ['UpdateCart'],
      (variables?: UpdateCartMutationVariables) => graphQlFetcher<UpdateCartMutation, UpdateCartMutationVariables>(UpdateCartDocument, variables)(),
      options
    );
export const DeleteCartDocument = `
    mutation DeleteCart($removeStock: Boolean!, $deleteCartByPkId: Float!) {
  DeleteCart_by_pk(removeStock: $removeStock, id: $deleteCartByPkId) {
    id
  }
}
    `;
export const useDeleteCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCartMutation, TError, DeleteCartMutationVariables, TContext>) =>
    useMutation<DeleteCartMutation, TError, DeleteCartMutationVariables, TContext>(
      ['DeleteCart'],
      (variables?: DeleteCartMutationVariables) => graphQlFetcher<DeleteCartMutation, DeleteCartMutationVariables>(DeleteCartDocument, variables)(),
      options
    );
export const ReturnCartDocument = `
    mutation ReturnCart($returnCartId: Float!) {
  ReturnCart(id: $returnCartId) {
    id
    cartType
    cartNotes
    discountAmount
    discountType
    discountValue
    CartItem {
      id
      buying
      imageSrc
      price
      productTitle
      quantity
      variantTitle
      cartId
      variantId
      itemTax
      taxable
      tags
      shopifyPrice
      shopifyTaxable
      actualPrice
      discountAmount
      discountType
      discountValue
      ShopifyCustomerProductVariant {
        inventoryQuantity
      }
      CartItemAdditionalInfo {
        id
        name
        value
      }
    }
    ShopifyCustomer {
      id
      email
      firstName
      lastName
      storeCredit
    }
    Cart {
      CartIntegratedPayment {
        id
        lastFour
        fullResponseObject
      }
    }
  }
}
    `;
export const useReturnCartMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReturnCartMutation, TError, ReturnCartMutationVariables, TContext>) =>
    useMutation<ReturnCartMutation, TError, ReturnCartMutationVariables, TContext>(
      ['ReturnCart'],
      (variables?: ReturnCartMutationVariables) => graphQlFetcher<ReturnCartMutation, ReturnCartMutationVariables>(ReturnCartDocument, variables)(),
      options
    );
export const GetActiveTillsDocument = `
    query GetActiveTills {
  BinderCustomerTill(where: {archived: {equals: false}}) {
    id
    name
    archived
  }
}
    `;
export const useGetActiveTillsQuery = <
      TData = GetActiveTillsQuery,
      TError = unknown
    >(
      variables?: GetActiveTillsQueryVariables,
      options?: UseQueryOptions<GetActiveTillsQuery, TError, TData>
    ) =>
    useQuery<GetActiveTillsQuery, TError, TData>(
      variables === undefined ? ['GetActiveTills'] : ['GetActiveTills', variables],
      graphQlFetcher<GetActiveTillsQuery, GetActiveTillsQueryVariables>(GetActiveTillsDocument, variables),
      options
    );
export const GetTillSettingsDocument = `
    query GetTillSettings($tillId: BigInt) {
  BinderCustomerTillSettings(where: {tillId: {equals: $tillId}}) {
    id
    settingName
    settingValue
    tillId
  }
}
    `;
export const useGetTillSettingsQuery = <
      TData = GetTillSettingsQuery,
      TError = unknown
    >(
      variables?: GetTillSettingsQueryVariables,
      options?: UseQueryOptions<GetTillSettingsQuery, TError, TData>
    ) =>
    useQuery<GetTillSettingsQuery, TError, TData>(
      variables === undefined ? ['GetTillSettings'] : ['GetTillSettings', variables],
      graphQlFetcher<GetTillSettingsQuery, GetTillSettingsQueryVariables>(GetTillSettingsDocument, variables),
      options
    );
export const CreateProductDocument = `
    mutation CreateProduct($title: String!, $variants: [CreateVariants!]!, $published: Boolean!, $tags: [String!], $bodyHtml: String, $productType: String, $vendor: String) {
  CreateProduct(
    title: $title
    variants: $variants
    published: $published
    vendor: $vendor
    productType: $productType
    tags: $tags
    bodyHtml: $bodyHtml
  ) {
    title
    productType
    id
    ProductDescription {
      descriptionHtml
      customerId
      productId
    }
    vendor
    ProductTag {
      id
      tag
    }
    ProductImage {
      height
      id
      imageUrl
      width
      position
    }
    ProductVariant {
      title
      sku
      barcode
      id
      weight
      weightUnit
      price
      position
    }
  }
}
    `;
export const useCreateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductMutation, TError, CreateProductMutationVariables, TContext>) =>
    useMutation<CreateProductMutation, TError, CreateProductMutationVariables, TContext>(
      ['CreateProduct'],
      (variables?: CreateProductMutationVariables) => graphQlFetcher<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, variables)(),
      options
    );
export const CreateProductVariantDocument = `
    mutation CreateProductVariant($variant: CreateVariants!, $productId: BigInt!) {
  CreateVariant(variant: $variant, productId: $productId) {
    title
    productType
    id
    ProductDescription {
      descriptionHtml
      customerId
      productId
    }
    vendor
    ProductTag {
      id
      tag
    }
    ProductImage {
      height
      id
      imageUrl
      width
      position
    }
    ProductVariant {
      title
      sku
      barcode
      id
      weight
      weightUnit
      price
      position
    }
  }
}
    `;
export const useCreateProductVariantMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProductVariantMutation, TError, CreateProductVariantMutationVariables, TContext>) =>
    useMutation<CreateProductVariantMutation, TError, CreateProductVariantMutationVariables, TContext>(
      ['CreateProductVariant'],
      (variables?: CreateProductVariantMutationVariables) => graphQlFetcher<CreateProductVariantMutation, CreateProductVariantMutationVariables>(CreateProductVariantDocument, variables)(),
      options
    );
export const DeleteProductDocument = `
    mutation DeleteProduct($id: BigInt!) {
  UpdateProduct(id: $id, delete: true) {
    id
  }
}
    `;
export const useDeleteProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteProductMutation, TError, DeleteProductMutationVariables, TContext>) =>
    useMutation<DeleteProductMutation, TError, DeleteProductMutationVariables, TContext>(
      ['DeleteProduct'],
      (variables?: DeleteProductMutationVariables) => graphQlFetcher<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, variables)(),
      options
    );
export const ProductTypesDocument = `
    query ProductTypes {
  Product(distinct: productType) {
    productType
  }
}
    `;
export const useProductTypesQuery = <
      TData = ProductTypesQuery,
      TError = unknown
    >(
      variables?: ProductTypesQueryVariables,
      options?: UseQueryOptions<ProductTypesQuery, TError, TData>
    ) =>
    useQuery<ProductTypesQuery, TError, TData>(
      variables === undefined ? ['ProductTypes'] : ['ProductTypes', variables],
      graphQlFetcher<ProductTypesQuery, ProductTypesQueryVariables>(ProductTypesDocument, variables),
      options
    );
export const ProductVendorsDocument = `
    query ProductVendors {
  Product(distinct: vendor) {
    vendor
  }
}
    `;
export const useProductVendorsQuery = <
      TData = ProductVendorsQuery,
      TError = unknown
    >(
      variables?: ProductVendorsQueryVariables,
      options?: UseQueryOptions<ProductVendorsQuery, TError, TData>
    ) =>
    useQuery<ProductVendorsQuery, TError, TData>(
      variables === undefined ? ['ProductVendors'] : ['ProductVendors', variables],
      graphQlFetcher<ProductVendorsQuery, ProductVendorsQueryVariables>(ProductVendorsDocument, variables),
      options
    );
export const ProductByIdDocument = `
    query ProductById($productByPkId: Float!) {
  Product_by_pk(id: $productByPkId) {
    title
    productType
    id
    ProductDescription {
      descriptionHtml
      customerId
      productId
    }
    vendor
    ProductTag {
      id
      tag
    }
    ProductImage {
      height
      id
      imageUrl
      width
      position
    }
    ProductVariant(orderBy: [{position: asc}], where: {archived: {equals: false}}) {
      title
      sku
      barcode
      id
      weight
      weightUnit
      price
      position
    }
  }
}
    `;
export const useProductByIdQuery = <
      TData = ProductByIdQuery,
      TError = unknown
    >(
      variables: ProductByIdQueryVariables,
      options?: UseQueryOptions<ProductByIdQuery, TError, TData>
    ) =>
    useQuery<ProductByIdQuery, TError, TData>(
      ['ProductById', variables],
      graphQlFetcher<ProductByIdQuery, ProductByIdQueryVariables>(ProductByIdDocument, variables),
      options
    );
export const UpdateProductDocument = `
    mutation UpdateProduct($updateProductId: BigInt!, $published: Boolean, $title: String, $variants: [UpdateVariants!], $bodyHtml: String, $images: [Images!], $tags: [String!], $productType: String, $vendor: String) {
  UpdateProduct(
    id: $updateProductId
    published: $published
    title: $title
    variants: $variants
    images: $images
    vendor: $vendor
    productType: $productType
    tags: $tags
    bodyHtml: $bodyHtml
  ) {
    title
    productType
    id
    ProductDescription {
      descriptionHtml
      customerId
      productId
    }
    vendor
    ProductTag {
      id
      tag
    }
    ProductImage {
      height
      id
      imageUrl
      width
      position
    }
    ProductVariant {
      title
      sku
      barcode
      id
      weight
      weightUnit
      price
      position
    }
  }
}
    `;
export const useUpdateProductMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>) =>
    useMutation<UpdateProductMutation, TError, UpdateProductMutationVariables, TContext>(
      ['UpdateProduct'],
      (variables?: UpdateProductMutationVariables) => graphQlFetcher<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, variables)(),
      options
    );
export const GetInstalledShopifyThemeVersionDocument = `
    query GetInstalledShopifyThemeVersion($where: BinderCustomerShopifyThemeWhereInput) {
  BinderCustomerShopifyTheme(where: $where) {
    ShopifyThemeRelease {
      version
      theme
      releaseDate
    }
  }
}
    `;
export const useGetInstalledShopifyThemeVersionQuery = <
      TData = GetInstalledShopifyThemeVersionQuery,
      TError = unknown
    >(
      variables?: GetInstalledShopifyThemeVersionQueryVariables,
      options?: UseQueryOptions<GetInstalledShopifyThemeVersionQuery, TError, TData>
    ) =>
    useQuery<GetInstalledShopifyThemeVersionQuery, TError, TData>(
      variables === undefined ? ['GetInstalledShopifyThemeVersion'] : ['GetInstalledShopifyThemeVersion', variables],
      graphQlFetcher<GetInstalledShopifyThemeVersionQuery, GetInstalledShopifyThemeVersionQueryVariables>(GetInstalledShopifyThemeVersionDocument, variables),
      options
    );
export const GetInstalledShopifyThemesDocument = `
    query GetInstalledShopifyThemes {
  BinderCustomerSettings(where: {settingName: {contains: "shopify%Theme%Id"}}) {
    settingName
  }
}
    `;
export const useGetInstalledShopifyThemesQuery = <
      TData = GetInstalledShopifyThemesQuery,
      TError = unknown
    >(
      variables?: GetInstalledShopifyThemesQueryVariables,
      options?: UseQueryOptions<GetInstalledShopifyThemesQuery, TError, TData>
    ) =>
    useQuery<GetInstalledShopifyThemesQuery, TError, TData>(
      variables === undefined ? ['GetInstalledShopifyThemes'] : ['GetInstalledShopifyThemes', variables],
      graphQlFetcher<GetInstalledShopifyThemesQuery, GetInstalledShopifyThemesQueryVariables>(GetInstalledShopifyThemesDocument, variables),
      options
    );
export const ShopifyThemeAvailableRollbacksDocument = `
    query ShopifyThemeAvailableRollbacks($currentVersion: String!, $theme: String!) {
  ShopifyThemeAvailableRollbacks(currentVersion: $currentVersion, theme: $theme) {
    version
    releaseDate
    summary
  }
}
    `;
export const useShopifyThemeAvailableRollbacksQuery = <
      TData = ShopifyThemeAvailableRollbacksQuery,
      TError = unknown
    >(
      variables: ShopifyThemeAvailableRollbacksQueryVariables,
      options?: UseQueryOptions<ShopifyThemeAvailableRollbacksQuery, TError, TData>
    ) =>
    useQuery<ShopifyThemeAvailableRollbacksQuery, TError, TData>(
      ['ShopifyThemeAvailableRollbacks', variables],
      graphQlFetcher<ShopifyThemeAvailableRollbacksQuery, ShopifyThemeAvailableRollbacksQueryVariables>(ShopifyThemeAvailableRollbacksDocument, variables),
      options
    );
export const ShopifyThemeAvailableUpdatesDocument = `
    query ShopifyThemeAvailableUpdates($currentVersion: String!, $theme: String!) {
  ShopifyThemeAvailableUpdates(currentVersion: $currentVersion, theme: $theme) {
    summary
    version
    releaseDate
  }
}
    `;
export const useShopifyThemeAvailableUpdatesQuery = <
      TData = ShopifyThemeAvailableUpdatesQuery,
      TError = unknown
    >(
      variables: ShopifyThemeAvailableUpdatesQueryVariables,
      options?: UseQueryOptions<ShopifyThemeAvailableUpdatesQuery, TError, TData>
    ) =>
    useQuery<ShopifyThemeAvailableUpdatesQuery, TError, TData>(
      ['ShopifyThemeAvailableUpdates', variables],
      graphQlFetcher<ShopifyThemeAvailableUpdatesQuery, ShopifyThemeAvailableUpdatesQueryVariables>(ShopifyThemeAvailableUpdatesDocument, variables),
      options
    );
export const GetShopifyThemesDocument = `
    query GetShopifyThemes {
  BinderCustomerShopifyTheme {
    customerId
    theme
    currentVersion
    releaseTrain
    lastUpdate
  }
}
    `;
export const useGetShopifyThemesQuery = <
      TData = GetShopifyThemesQuery,
      TError = unknown
    >(
      variables?: GetShopifyThemesQueryVariables,
      options?: UseQueryOptions<GetShopifyThemesQuery, TError, TData>
    ) =>
    useQuery<GetShopifyThemesQuery, TError, TData>(
      variables === undefined ? ['GetShopifyThemes'] : ['GetShopifyThemes', variables],
      graphQlFetcher<GetShopifyThemesQuery, GetShopifyThemesQueryVariables>(GetShopifyThemesDocument, variables),
      options
    );
export const UpdateBinderCustomerShopifyThemeDocument = `
    mutation UpdateBinderCustomerShopifyTheme($data: BinderCustomerShopifyThemeUpdateInput!, $theme: String!) {
  UpdateBinderCustomerShopifyTheme(data: $data, theme: $theme) {
    theme
    releaseTrain
    lastUpdate
  }
}
    `;
export const useUpdateBinderCustomerShopifyThemeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBinderCustomerShopifyThemeMutation, TError, UpdateBinderCustomerShopifyThemeMutationVariables, TContext>) =>
    useMutation<UpdateBinderCustomerShopifyThemeMutation, TError, UpdateBinderCustomerShopifyThemeMutationVariables, TContext>(
      ['UpdateBinderCustomerShopifyTheme'],
      (variables?: UpdateBinderCustomerShopifyThemeMutationVariables) => graphQlFetcher<UpdateBinderCustomerShopifyThemeMutation, UpdateBinderCustomerShopifyThemeMutationVariables>(UpdateBinderCustomerShopifyThemeDocument, variables)(),
      options
    );